/* tslint:disable */
/* eslint-disable */
/**
 * A ruleset for the tag, group, subnet and device group ACL view
 * @export
 * @interface ACLRuleSet
 */
export interface ACLRuleSet {
    /**
     * A description
     * @type {string}
     * @memberof ACLRuleSet
     */
    description: string;
    /**
     * A name
     * @type {string}
     * @memberof ACLRuleSet
     */
    name: string;
    /**
     * A [`Plugin`]'s primary key
     * @type {string}
     * @memberof ACLRuleSet
     */
    plugin_uuid?: string | null;
    /**
     * 
     * @type {Array<SimpleRulesetRule>}
     * @memberof ACLRuleSet
     */
    rules: Array<SimpleRulesetRule>;
    /**
     * The `src` or `dst` of the ruleset.
     * 
     * If the corresponding tag, group, subnet and device group is `src`, all other `dst` will be given to the frontend
     * 
     * If the tag, group, subnet and device group are `dst`, then all `src` will be given to the frontend
     * @type {Array<FullAccessRuleSrc>}
     * @memberof ACLRuleSet
     */
    src_or_dst: Array<FullAccessRuleSrc>;
    /**
     * The primary key
     * @type {string}
     * @memberof ACLRuleSet
     */
    uuid: string;
}
/**
 * An aggregated edge between two entities in the access graph
 * @export
 * @interface AccessGraphEdgeSchema
 */
export interface AccessGraphEdgeSchema {
    /**
     * The destination entity
     * @type {AccessVisualizationEntitySchema}
     * @memberof AccessGraphEdgeSchema
     */
    dst: AccessVisualizationEntitySchema;
    /**
     * Port ranges across all contributing rules
     * @type {Array<AccessGraphPortRange>}
     * @memberof AccessGraphEdgeSchema
     */
    port_ranges: Array<AccessGraphPortRange>;
    /**
     * Protocols used across all contributing rules
     * @type {Array<AccessRuleProtocol>}
     * @memberof AccessGraphEdgeSchema
     */
    protocols: Array<AccessRuleProtocol>;
    /**
     * Number of rules contributing to this edge
     * @type {number}
     * @memberof AccessGraphEdgeSchema
     */
    rule_count: number;
    /**
     * Individual rule details
     * @type {Array<EdgeRuleDetailSchema>}
     * @memberof AccessGraphEdgeSchema
     */
    rules: Array<EdgeRuleDetailSchema>;
    /**
     * The source entity
     * @type {AccessVisualizationEntitySchema}
     * @memberof AccessGraphEdgeSchema
     */
    src: AccessVisualizationEntitySchema;
}
/**
 * A node in the access visualization graph
 * @export
 * @interface AccessGraphNodeSchema
 */
export interface AccessGraphNodeSchema {
    /**
     * The number of devices belonging to this entity
     * @type {number}
     * @memberof AccessGraphNodeSchema
     */
    device_count: number;
    /**
     * The entity this node represents
     * @type {AccessVisualizationEntitySchema}
     * @memberof AccessGraphNodeSchema
     */
    entity: AccessVisualizationEntitySchema;
    /**
     * The display name of the entity
     * @type {string}
     * @memberof AccessGraphNodeSchema
     */
    name: string;
}
/**
 * A port range
 * @export
 * @interface AccessGraphPortRange
 */
export interface AccessGraphPortRange {
    /**
     * The high end of the port range
     * @type {number}
     * @memberof AccessGraphPortRange
     */
    high: number;
    /**
     * The low end of the port range
     * @type {number}
     * @memberof AccessGraphPortRange
     */
    low: number;
}

/**
 * 
 * @export
 */
export const AccessRuleProtocol = {
    Tcp: 'Tcp',
    Udp: 'Udp',
    Icmp: 'Icmp',
    Sctp: 'Sctp',
    Igmp: 'Igmp',
    IpInIP: 'IpInIP',
    Egp: 'Egp',
    Igp: 'Igp',
    Gre: 'Gre',
    Esp: 'Esp',
    Ah: 'Ah'
} as const;
export type AccessRuleProtocol = typeof AccessRuleProtocol[keyof typeof AccessRuleProtocol];


/**
 * 
 * @export
 */
export const AccessRuleProtocol2 = {
    Tcp: 'Tcp',
    Udp: 'Udp',
    Icmp: 'Icmp',
    Sctp: 'Sctp',
    Igmp: 'Igmp',
    IpInIP: 'IpInIP',
    Egp: 'Egp',
    Igp: 'Igp',
    Gre: 'Gre',
    Esp: 'Esp',
    Ah: 'Ah'
} as const;
export type AccessRuleProtocol2 = typeof AccessRuleProtocol2[keyof typeof AccessRuleProtocol2];

/**
 * @type AccessVisualizationEntitySchema
 * An entity reference used in the access visualization
 * @export
 */
export type AccessVisualizationEntitySchema = AccessVisualizationEntitySchemaOneOf | AccessVisualizationEntitySchemaOneOf1 | AccessVisualizationEntitySchemaOneOf2 | AccessVisualizationEntitySchemaOneOf3;
/**
 * A user group
 * @export
 * @interface AccessVisualizationEntitySchemaOneOf
 */
export interface AccessVisualizationEntitySchemaOneOf {
    /**
     * 
     * @type {string}
     * @memberof AccessVisualizationEntitySchemaOneOf
     */
    type: AccessVisualizationEntitySchemaOneOfTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AccessVisualizationEntitySchemaOneOf
     */
    value: string;
}


/**
 * @export
 */
export const AccessVisualizationEntitySchemaOneOfTypeEnum = {
    Group: 'Group'
} as const;
export type AccessVisualizationEntitySchemaOneOfTypeEnum = typeof AccessVisualizationEntitySchemaOneOfTypeEnum[keyof typeof AccessVisualizationEntitySchemaOneOfTypeEnum];

/**
 * A server tag
 * @export
 * @interface AccessVisualizationEntitySchemaOneOf1
 */
export interface AccessVisualizationEntitySchemaOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof AccessVisualizationEntitySchemaOneOf1
     */
    type: AccessVisualizationEntitySchemaOneOf1TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AccessVisualizationEntitySchemaOneOf1
     */
    value: string;
}


/**
 * @export
 */
export const AccessVisualizationEntitySchemaOneOf1TypeEnum = {
    Tag: 'Tag'
} as const;
export type AccessVisualizationEntitySchemaOneOf1TypeEnum = typeof AccessVisualizationEntitySchemaOneOf1TypeEnum[keyof typeof AccessVisualizationEntitySchemaOneOf1TypeEnum];

/**
 * A device group
 * @export
 * @interface AccessVisualizationEntitySchemaOneOf2
 */
export interface AccessVisualizationEntitySchemaOneOf2 {
    /**
     * 
     * @type {string}
     * @memberof AccessVisualizationEntitySchemaOneOf2
     */
    type: AccessVisualizationEntitySchemaOneOf2TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AccessVisualizationEntitySchemaOneOf2
     */
    value: string;
}


/**
 * @export
 */
export const AccessVisualizationEntitySchemaOneOf2TypeEnum = {
    DeviceGroup: 'DeviceGroup'
} as const;
export type AccessVisualizationEntitySchemaOneOf2TypeEnum = typeof AccessVisualizationEntitySchemaOneOf2TypeEnum[keyof typeof AccessVisualizationEntitySchemaOneOf2TypeEnum];

/**
 * A subnet
 * @export
 * @interface AccessVisualizationEntitySchemaOneOf3
 */
export interface AccessVisualizationEntitySchemaOneOf3 {
    /**
     * 
     * @type {string}
     * @memberof AccessVisualizationEntitySchemaOneOf3
     */
    type: AccessVisualizationEntitySchemaOneOf3TypeEnum;
    /**
     * A [`SubnetModel`]'s primary key
     * @type {string}
     * @memberof AccessVisualizationEntitySchemaOneOf3
     */
    value: string;
}


/**
 * @export
 */
export const AccessVisualizationEntitySchemaOneOf3TypeEnum = {
    Subnet: 'Subnet'
} as const;
export type AccessVisualizationEntitySchemaOneOf3TypeEnum = typeof AccessVisualizationEntitySchemaOneOf3TypeEnum[keyof typeof AccessVisualizationEntitySchemaOneOf3TypeEnum];

/**
 * 
 * @export
 * @interface AddExtraDnsRecordRequest
 */
export interface AddExtraDnsRecordRequest {
    /**
     * The record type, A or AAAA accepted
     * @type {ExtraDnsRecordType}
     * @memberof AddExtraDnsRecordRequest
     */
    record_type: ExtraDnsRecordType;
    /**
     * The IP of the Record
     * @type {string}
     * @memberof AddExtraDnsRecordRequest
     */
    to_ip: string;
}
/**
 * Add member to local group errors
 * @export
 * @interface AddMemberToLocalGroupError
 */
export interface AddMemberToLocalGroupError {
    /**
     * The name is not unique
     * @type {boolean}
     * @memberof AddMemberToLocalGroupError
     */
    already_part_of_group: boolean;
}
/**
 * 
 * @export
 * @interface AddRuleToRulesetRequest
 */
export interface AddRuleToRulesetRequest {
    /**
     * A description
     * @type {string}
     * @memberof AddRuleToRulesetRequest
     */
    description: string;
    /**
     * 
     * @type {CreateAccessRulePort}
     * @memberof AddRuleToRulesetRequest
     */
    port: CreateAccessRulePort;
    /**
     * The transport protocol allowed by the rule.
     * @type {AccessRuleProtocol}
     * @memberof AddRuleToRulesetRequest
     */
    protocol: AccessRuleProtocol;
}
/**
 * 
 * @export
 * @interface AddTenantDomainErrors
 */
export interface AddTenantDomainErrors {
    /**
     * 
     * @type {boolean}
     * @memberof AddTenantDomainErrors
     */
    domain_conflict: boolean;
}
/**
 * 
 * @export
 * @interface AddTenantDomainRequest
 */
export interface AddTenantDomainRequest {
    /**
     * 
     * @type {string}
     * @memberof AddTenantDomainRequest
     */
    uuid: string;
}
/**
 * The response that is sent in a case of an error the caller should report to an admin
 * @export
 * @interface ApiErrorResponse
 */
export interface ApiErrorResponse {
    /**
     * ID of the opentelemetry trace this error originated in
     * @type {string}
     * @memberof ApiErrorResponse
     */
    trace_id: string;
}

/**
 * The color of a badge in the frontend
 * @export
 */
export const BadgeColor = {
    Red: 'Red',
    Orange: 'Orange',
    Amber: 'Amber',
    Yellow: 'Yellow',
    Lime: 'Lime',
    Green: 'Green',
    Emerald: 'Emerald',
    Teal: 'Teal',
    Cyan: 'Cyan',
    Sky: 'Sky',
    Blue: 'Blue',
    Indigo: 'Indigo',
    Violet: 'Violet',
    Purple: 'Purple',
    Fuchsia: 'Fuchsia',
    Pink: 'Pink',
    Rose: 'Rose',
    Zinc: 'Zinc'
} as const;
export type BadgeColor = typeof BadgeColor[keyof typeof BadgeColor];

/**
 * `CapGrant` grants capabilities in a FilterRule.
 * @export
 * @interface CapGrant
 */
export interface CapGrant {
    /**
     * `cap_map` is a map of capabilities to their values. The key is the capability name, and the value is a list of values for that capability.
     * @type {{ [key: string]: Array<any> | undefined | null; }}
     * @memberof CapGrant
     */
    CapMap?: { [key: string]: Array<any> | undefined | null; };
    /**
     * `caps` are the capabilities the source IP matched by `FilterRule.src_ips` are granted to the destination IP, matched by `dsts`. Deprecated: use `cap_map` instead.
     * @type {Array<string>}
     * @memberof CapGrant
     */
    Caps?: Array<string> | null;
    /**
     * `dsts` are the destination IP ranges that this capability grant matches.
     * @type {Array<string>}
     * @memberof CapGrant
     */
    Dsts?: Array<string> | null;
}

/**
 * 
 * @export
 */
export const ChangelogOperation = {
    Create: 'Create',
    Update: 'Update',
    Delete: 'Delete'
} as const;
export type ChangelogOperation = typeof ChangelogOperation[keyof typeof ChangelogOperation];


/**
 * 
 * @export
 */
export const ChangelogTarget = {
    PreAuthKey: 'PreAuthKey',
    Tag: 'Tag',
    SettingsLdap: 'SettingsLdap',
    SettingsScim: 'SettingsScim',
    SettingsOidc: 'SettingsOidc',
    Device: 'Device',
    Account: 'Account',
    AccessRule: 'AccessRule',
    Group: 'Group',
    DeviceGroup: 'DeviceGroup',
    Subnet: 'Subnet',
    User: 'User',
    GlobalDns: 'GlobalDns',
    SplitDns: 'SplitDns',
    TagDirectory: 'TagDirectory',
    SettingsLdapConnection: 'SettingsLdapConnection'
} as const;
export type ChangelogTarget = typeof ChangelogTarget[keyof typeof ChangelogTarget];

/**
 * Request for the device-to-device access check
 * @export
 * @interface CheckDeviceAccessRequest
 */
export interface CheckDeviceAccessRequest {
    /**
     * The first device's UUID
     * @type {string}
     * @memberof CheckDeviceAccessRequest
     */
    device_a: string;
    /**
     * The second device's UUID
     * @type {string}
     * @memberof CheckDeviceAccessRequest
     */
    device_b: string;
}
/**
 * Response for the device-to-device access check
 * @export
 * @interface CheckDeviceAccessResponse
 */
export interface CheckDeviceAccessResponse {
    /**
     * Rules allowing traffic from A to B
     * @type {Array<CheckDeviceAccessRuleSchema>}
     * @memberof CheckDeviceAccessResponse
     */
    a_to_b: Array<CheckDeviceAccessRuleSchema>;
    /**
     * Rules allowing traffic from B to A
     * @type {Array<CheckDeviceAccessRuleSchema>}
     * @memberof CheckDeviceAccessResponse
     */
    b_to_a: Array<CheckDeviceAccessRuleSchema>;
    /**
     * Information about device A
     * @type {CheckDeviceAccessSide}
     * @memberof CheckDeviceAccessResponse
     */
    device_a: CheckDeviceAccessSide;
    /**
     * Information about device B
     * @type {CheckDeviceAccessSide}
     * @memberof CheckDeviceAccessResponse
     */
    device_b: CheckDeviceAccessSide;
}
/**
 * A rule allowing traffic between two devices
 * @export
 * @interface CheckDeviceAccessRuleSchema
 */
export interface CheckDeviceAccessRuleSchema {
    /**
     * The destination entity this rule matches through
     * @type {AccessVisualizationEntitySchema}
     * @memberof CheckDeviceAccessRuleSchema
     */
    dst_entity: AccessVisualizationEntitySchema;
    /**
     * The high end of the allowed port range
     * @type {number}
     * @memberof CheckDeviceAccessRuleSchema
     */
    port_high: number;
    /**
     * The low end of the allowed port range
     * @type {number}
     * @memberof CheckDeviceAccessRuleSchema
     */
    port_low: number;
    /**
     * The protocol allowed by this rule
     * @type {AccessRuleProtocol}
     * @memberof CheckDeviceAccessRuleSchema
     */
    protocol: AccessRuleProtocol;
    /**
     * The source entity this rule matches through
     * @type {AccessVisualizationEntitySchema}
     * @memberof CheckDeviceAccessRuleSchema
     */
    src_entity: AccessVisualizationEntitySchema;
}
/**
 * One side of the device access check result
 * @export
 * @interface CheckDeviceAccessSide
 */
export interface CheckDeviceAccessSide {
    /**
     * The device's DNS name
     * @type {string}
     * @memberof CheckDeviceAccessSide
     */
    dnsname: string;
    /**
     * Whether this is a user device (true) or a tagged device (false)
     * @type {boolean}
     * @memberof CheckDeviceAccessSide
     */
    is_user_device: boolean;
    /**
     * The device's UUID
     * @type {string}
     * @memberof CheckDeviceAccessSide
     */
    uuid: string;
}
/**
 * `ClientVersion` is information about the latest client version that's available for the client (and whether they're already running it).
 * 
 * It does not include a URL to download the client, as that varies by platform.
 * @export
 * @interface ClientVersion
 */
export interface ClientVersion {
    /**
     * `latest_version` is the latest version.Short ("1.34.2") version available for download for the client's platform and packaging type. It won't be populated if `running_latest` is `true`.
     * @type {string}
     * @memberof ClientVersion
     */
    LatestVersion?: string;
    /**
     * `notify` is whether the client should do an OS-specific notification about a new version being available. This should not be populated if `running_latest` is `true`. The client should not notify multiple times for the same `latest_version` value.
     * @type {boolean}
     * @memberof ClientVersion
     */
    Notify?: boolean;
    /**
     * `notify_text` is the text to show in the notification, when `notify` is `true`.
     * @type {string}
     * @memberof ClientVersion
     */
    NotifyText?: string;
    /**
     * `running_latest` is true if the client is running the latest build.
     * @type {boolean}
     * @memberof ClientVersion
     */
    RunningLatest?: boolean;
    /**
     * `notify_url` is a URL to open in the browser when the user clicks on the notification, when `notify` is `true`.
     * @type {string}
     * @memberof ClientVersion
     */
    TODO?: string;
    /**
     * `urgent_security_update` is set when the client is missing an important security update. That update may be in `latest_version` or earlier. `urgent_security_update` should not be set if `running_latest` is `false`.
     * @type {boolean}
     * @memberof ClientVersion
     */
    UrgentSecurityUpdate?: boolean;
}
/**
 * `ControlDialPlan` is instructions from the control server to the client on how to connect to the control server; this is useful for maintaining connection if the client's network state changes after the initial connection, or due to the configuration that the control server pushes.
 * @export
 * @interface ControlDialPlan
 */
export interface ControlDialPlan {
    /**
     * An empty list means the default: use DNS (unspecified which DNS).
     * @type {Array<ControlIPCandidate>}
     * @memberof ControlDialPlan
     */
    Candidates?: Array<ControlIPCandidate> | null;
}
/**
 * `ControlIPCandidate` represents a single candidate address to use when connecting to the control server.
 * @export
 * @interface ControlIPCandidate
 */
export interface ControlIPCandidate {
    /**
     * `dial_start_delay_sec` is the number of seconds after the beginning of the connection process to wait before trying this candidate.
     * @type {number}
     * @memberof ControlIPCandidate
     */
    DialStartDelaySec?: number;
    /**
     * `dial_timeout_sec` is the timeout for a connection to this candidate, starting after `dial_start_delay_sec`.
     * @type {number}
     * @memberof ControlIPCandidate
     */
    DialTimeoutSec?: number;
    /**
     * `ip` is the address to attempt connecting to.
     * @type {string}
     * @memberof ControlIPCandidate
     */
    IP?: string;
    /**
     * `priority` is the relative priority of this candidate; candidates with a higher priority are preferred over candidates with a lower priority.
     * @type {number}
     * @memberof ControlIPCandidate
     */
    Priority?: number;
}
/**
 * @type CreateAccessRuleDst
 * 
 * @export
 */
export type CreateAccessRuleDst = CreateAccessRuleDstOneOf | CreateAccessRuleDstOneOf1 | CreateAccessRuleDstOneOf2 | CreateAccessRuleDstOneOf3;
/**
 * 
 * @export
 * @interface CreateAccessRuleDstOneOf
 */
export interface CreateAccessRuleDstOneOf {
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf
     */
    type: CreateAccessRuleDstOneOfTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf
     */
    value: string;
}


/**
 * @export
 */
export const CreateAccessRuleDstOneOfTypeEnum = {
    Group: 'Group'
} as const;
export type CreateAccessRuleDstOneOfTypeEnum = typeof CreateAccessRuleDstOneOfTypeEnum[keyof typeof CreateAccessRuleDstOneOfTypeEnum];

/**
 * 
 * @export
 * @interface CreateAccessRuleDstOneOf1
 */
export interface CreateAccessRuleDstOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf1
     */
    type: CreateAccessRuleDstOneOf1TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf1
     */
    value: string;
}


/**
 * @export
 */
export const CreateAccessRuleDstOneOf1TypeEnum = {
    Tag: 'Tag'
} as const;
export type CreateAccessRuleDstOneOf1TypeEnum = typeof CreateAccessRuleDstOneOf1TypeEnum[keyof typeof CreateAccessRuleDstOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface CreateAccessRuleDstOneOf2
 */
export interface CreateAccessRuleDstOneOf2 {
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf2
     */
    type: CreateAccessRuleDstOneOf2TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf2
     */
    value: string;
}


/**
 * @export
 */
export const CreateAccessRuleDstOneOf2TypeEnum = {
    DeviceGroup: 'DeviceGroup'
} as const;
export type CreateAccessRuleDstOneOf2TypeEnum = typeof CreateAccessRuleDstOneOf2TypeEnum[keyof typeof CreateAccessRuleDstOneOf2TypeEnum];

/**
 * 
 * @export
 * @interface CreateAccessRuleDstOneOf3
 */
export interface CreateAccessRuleDstOneOf3 {
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf3
     */
    type: CreateAccessRuleDstOneOf3TypeEnum;
    /**
     * A [`SubnetModel`]'s primary key
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf3
     */
    value: string;
}


/**
 * @export
 */
export const CreateAccessRuleDstOneOf3TypeEnum = {
    Subnet: 'Subnet'
} as const;
export type CreateAccessRuleDstOneOf3TypeEnum = typeof CreateAccessRuleDstOneOf3TypeEnum[keyof typeof CreateAccessRuleDstOneOf3TypeEnum];

/**
 * @type CreateAccessRulePort
 * 
 * @export
 */
export type CreateAccessRulePort = CreateAccessRulePortOneOf | CreateAccessRulePortOneOf1 | CreateAccessRulePortOneOf2;
/**
 * 
 * @export
 * @interface CreateAccessRulePortOneOf
 */
export interface CreateAccessRulePortOneOf {
    /**
     * 
     * @type {number}
     * @memberof CreateAccessRulePortOneOf
     */
    port: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRulePortOneOf
     */
    type: CreateAccessRulePortOneOfTypeEnum;
}


/**
 * @export
 */
export const CreateAccessRulePortOneOfTypeEnum = {
    Single: 'Single'
} as const;
export type CreateAccessRulePortOneOfTypeEnum = typeof CreateAccessRulePortOneOfTypeEnum[keyof typeof CreateAccessRulePortOneOfTypeEnum];

/**
 * 
 * @export
 * @interface CreateAccessRulePortOneOf1
 */
export interface CreateAccessRulePortOneOf1 {
    /**
     * 
     * @type {number}
     * @memberof CreateAccessRulePortOneOf1
     */
    end: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAccessRulePortOneOf1
     */
    start: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRulePortOneOf1
     */
    type: CreateAccessRulePortOneOf1TypeEnum;
}


/**
 * @export
 */
export const CreateAccessRulePortOneOf1TypeEnum = {
    Range: 'Range'
} as const;
export type CreateAccessRulePortOneOf1TypeEnum = typeof CreateAccessRulePortOneOf1TypeEnum[keyof typeof CreateAccessRulePortOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface CreateAccessRulePortOneOf2
 */
export interface CreateAccessRulePortOneOf2 {
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRulePortOneOf2
     */
    type: CreateAccessRulePortOneOf2TypeEnum;
}


/**
 * @export
 */
export const CreateAccessRulePortOneOf2TypeEnum = {
    Any: 'Any'
} as const;
export type CreateAccessRulePortOneOf2TypeEnum = typeof CreateAccessRulePortOneOf2TypeEnum[keyof typeof CreateAccessRulePortOneOf2TypeEnum];

/**
 * 
 * @export
 * @interface CreateAccessRuleRequest
 */
export interface CreateAccessRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleRequest
     */
    description: string;
    /**
     * 
     * @type {CreateAccessRuleDst}
     * @memberof CreateAccessRuleRequest
     */
    dst: CreateAccessRuleDst;
    /**
     * 
     * @type {CreateAccessRulePort}
     * @memberof CreateAccessRuleRequest
     */
    port: CreateAccessRulePort;
    /**
     * 
     * @type {AccessRuleProtocol}
     * @memberof CreateAccessRuleRequest
     */
    protocol: AccessRuleProtocol;
    /**
     * 
     * @type {CreateAccessRuleSrc}
     * @memberof CreateAccessRuleRequest
     */
    src: CreateAccessRuleSrc;
}
/**
 * @type CreateAccessRuleSrc
 * 
 * @export
 */
export type CreateAccessRuleSrc = CreateAccessRuleDstOneOf | CreateAccessRuleDstOneOf1 | CreateAccessRuleDstOneOf2 | CreateAccessRuleDstOneOf3;
/**
 * 
 * @export
 * @interface CreateDeviceGroupErrors
 */
export interface CreateDeviceGroupErrors {
    /**
     * The device group's name already exists
     * @type {boolean}
     * @memberof CreateDeviceGroupErrors
     */
    name_not_unique: boolean;
}
/**
 * 
 * @export
 * @interface CreateDeviceGroupRequest
 */
export interface CreateDeviceGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDeviceGroupRequest
     */
    description: string;
    /**
     * The device group's name
     * @type {string}
     * @memberof CreateDeviceGroupRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface CreateExtraDnsRecordsError
 */
export interface CreateExtraDnsRecordsError {
    /**
     * List of failed domains if any existing device has the same name
     * @type {Array<string>}
     * @memberof CreateExtraDnsRecordsError
     */
    domains_collide_existing_devices: Array<string>;
    /**
     * List of failed domains if any existing domain has the same name
     * @type {Array<string>}
     * @memberof CreateExtraDnsRecordsError
     */
    domains_collide_existing_domains: Array<string>;
    /**
     * List of invalid domains from the request
     * @type {Array<string>}
     * @memberof CreateExtraDnsRecordsError
     */
    invalid_domains: Array<string>;
    /**
     * The IPv4 of the record is not a valid IP
     * @type {boolean}
     * @memberof CreateExtraDnsRecordsError
     */
    ipv4_invalid: boolean;
    /**
     * The IPv6 of the record is not a valid IP
     * @type {boolean}
     * @memberof CreateExtraDnsRecordsError
     */
    ipv6_invalid: boolean;
    /**
     * If the IPv4 is in the internal range but no device exists for that address
     * @type {boolean}
     * @memberof CreateExtraDnsRecordsError
     */
    no_internal_ipv4_device: boolean;
    /**
     * If the IPv6 is in the internal range but no device exists for that address
     * @type {boolean}
     * @memberof CreateExtraDnsRecordsError
     */
    no_internal_ipv6_device: boolean;
    /**
     * If neither an IPv4 nor an IPv6 is provided
     * @type {boolean}
     * @memberof CreateExtraDnsRecordsError
     */
    no_ip_configured: boolean;
}
/**
 * 
 * @export
 * @interface CreateExtraDnsRecordsRequest
 */
export interface CreateExtraDnsRecordsRequest {
    /**
     * Description for all newly added domains
     * @type {string}
     * @memberof CreateExtraDnsRecordsRequest
     */
    description: string;
    /**
     * List of domains for the extra records
     * @type {Array<string>}
     * @memberof CreateExtraDnsRecordsRequest
     */
    domains: Array<string>;
    /**
     * IPv4 target of all records, at least one target must exist
     * @type {string}
     * @memberof CreateExtraDnsRecordsRequest
     */
    ipv4_target?: string | null;
    /**
     * IPv6 target of all records, at least one target must exist
     * @type {string}
     * @memberof CreateExtraDnsRecordsRequest
     */
    ipv6_target?: string | null;
}
/**
 * 
 * @export
 * @interface CreateLocalGroupErrors
 */
export interface CreateLocalGroupErrors {
    /**
     * The name is not unique
     * @type {boolean}
     * @memberof CreateLocalGroupErrors
     */
    name: boolean;
}
/**
 * 
 * @export
 * @interface CreateLocalGroupRequest
 */
export interface CreateLocalGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLocalGroupRequest
     */
    description: string;
    /**
     * Allows this group to have access to `autogroup:internet`
     * @type {boolean}
     * @memberof CreateLocalGroupRequest
     */
    internet: boolean;
    /**
     * The group's name
     * 
     * Must be unique among all local groups
     * @type {string}
     * @memberof CreateLocalGroupRequest
     */
    name: string;
}
/**
 * @type CreateOidcProvider200Response
 * 
 * @export
 */
export type CreateOidcProvider200Response = CreateOidcProviderResponse | FormErrorResponseForCreateOidcProviderErrors;
/**
 * 
 * @export
 * @interface CreateOidcProviderErrors
 */
export interface CreateOidcProviderErrors {
    /**
     * If true, the provider name was already occupied
     * @type {boolean}
     * @memberof CreateOidcProviderErrors
     */
    name_already_exist: boolean;
}
/**
 * 
 * @export
 * @interface CreateOidcProviderRequest
 */
export interface CreateOidcProviderRequest {
    /**
     * Display name for this provider
     * @type {string}
     * @memberof CreateOidcProviderRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface CreateOidcProviderResponse
 */
export interface CreateOidcProviderResponse {
    /**
     * The primary key of the newly created provider
     * @type {string}
     * @memberof CreateOidcProviderResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface CreatePreAuthKeyRequest
 */
export interface CreatePreAuthKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePreAuthKeyRequest
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePreAuthKeyRequest
     */
    ephemeral: boolean;
    /**
     * Number of days until the key expires
     * @type {number}
     * @memberof CreatePreAuthKeyRequest
     */
    expiration?: number | null;
    /**
     * Can the key be used more than once?
     * @type {boolean}
     * @memberof CreatePreAuthKeyRequest
     */
    reusable: boolean;
    /**
     * List of tags to apply to the device which will use this key
     * 
     * It is a list of uuids.
     * 
     * Each uuid must appear at most once.
     * @type {Array<string>}
     * @memberof CreatePreAuthKeyRequest
     */
    tags: Array<string>;
    /**
     * A [`Tenant`]'s uuid
     * @type {string}
     * @memberof CreatePreAuthKeyRequest
     */
    tenant: string;
}
/**
 * 
 * @export
 * @interface CreatePreAuthKeyResponse
 */
export interface CreatePreAuthKeyResponse {
    /**
     * The key's value
     * @type {string}
     * @memberof CreatePreAuthKeyResponse
     */
    key: string;
    /**
     * The key's uuid
     * @type {string}
     * @memberof CreatePreAuthKeyResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface CreateRulesetInstanceRequest
 */
export interface CreateRulesetInstanceRequest {
    /**
     * 
     * @type {CreateAccessRuleSrc}
     * @memberof CreateRulesetInstanceRequest
     */
    dst: CreateAccessRuleSrc;
    /**
     * Uuid of the ruleset to instantiate
     * @type {string}
     * @memberof CreateRulesetInstanceRequest
     */
    ruleset: string;
    /**
     * 
     * @type {CreateAccessRuleSrc}
     * @memberof CreateRulesetInstanceRequest
     */
    src: CreateAccessRuleSrc;
}
/**
 * 
 * @export
 * @interface CreateRulesetRequest
 */
export interface CreateRulesetRequest {
    /**
     * A description
     * @type {string}
     * @memberof CreateRulesetRequest
     */
    description: string;
    /**
     * A name
     * @type {string}
     * @memberof CreateRulesetRequest
     */
    name: string;
}
/**
 * Error response for creating a new Split Dns Domain
 * @export
 * @interface CreateSplitDnsDomainError
 */
export interface CreateSplitDnsDomainError {
    /**
     * The domain name is already in use
     * @type {boolean}
     * @memberof CreateSplitDnsDomainError
     */
    domain_already_exists: boolean;
    /**
     * The name of the domain which is not a valid domain
     * @type {boolean}
     * @memberof CreateSplitDnsDomainError
     */
    domain_invalid: boolean;
}
/**
 * Request for creating a new Split Dns Domain
 * @export
 * @interface CreateSplitDnsDomainRequest
 */
export interface CreateSplitDnsDomainRequest {
    /**
     * Marks whether this Split Dns configuration is actively used or not
     * @type {boolean}
     * @memberof CreateSplitDnsDomainRequest
     */
    disabled: boolean;
    /**
     * The domain name
     * @type {string}
     * @memberof CreateSplitDnsDomainRequest
     */
    domain: string;
}
/**
 * Errors for creating a new split dns resolver
 * @export
 * @interface CreateSplitDnsResolverErrors
 */
export interface CreateSplitDnsResolverErrors {
    /**
     * Ip address is already in use in this domain
     * @type {boolean}
     * @memberof CreateSplitDnsResolverErrors
     */
    ip_already_exists: boolean;
    /**
     * Ip address is not a valid ip address
     * @type {boolean}
     * @memberof CreateSplitDnsResolverErrors
     */
    ip_invalid: boolean;
}
/**
 * Request for creating a new split dns resolver
 * @export
 * @interface CreateSplitDnsResolverRequest
 */
export interface CreateSplitDnsResolverRequest {
    /**
     * Better description to identify the resolver
     * @type {string}
     * @memberof CreateSplitDnsResolverRequest
     */
    description: string;
    /**
     * Marks whether this resolver is actively used or not
     * @type {boolean}
     * @memberof CreateSplitDnsResolverRequest
     */
    disabled: boolean;
    /**
     * The IP of the resolver
     * @type {string}
     * @memberof CreateSplitDnsResolverRequest
     */
    ip: string;
}
/**
 * Request to create a subnet
 * @export
 * @interface CreateSubnetWithFstRouterRequest
 */
export interface CreateSubnetWithFstRouterRequest {
    /**
     * The description of the subnet
     * @type {string}
     * @memberof CreateSubnetWithFstRouterRequest
     */
    description: string;
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof CreateSubnetWithFstRouterRequest
     */
    name: string;
    /**
     * The subnet's initial router
     * @type {string}
     * @memberof CreateSubnetWithFstRouterRequest
     */
    router: string;
}
/**
 * A directory creation errors
 * @export
 * @interface CreateTagDirectoryErrors
 */
export interface CreateTagDirectoryErrors {
    /**
     * The directory's name already exists
     * @type {boolean}
     * @memberof CreateTagDirectoryErrors
     */
    name_not_unique: boolean;
}
/**
 * A directory creates request
 * @export
 * @interface CreateTagDirectoryRequest
 */
export interface CreateTagDirectoryRequest {
    /**
     * The directory's name
     * @type {string}
     * @memberof CreateTagDirectoryRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface CreateTagErrors
 */
export interface CreateTagErrors {
    /**
     * The tag's name already exists
     * @type {boolean}
     * @memberof CreateTagErrors
     */
    name_not_unique: boolean;
}
/**
 * 
 * @export
 * @interface CreateTagRequest
 */
export interface CreateTagRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTagRequest
     */
    description: string;
    /**
     * The directory this tag belongs to. If not set, the tag is not assigned to any directory.
     * @type {string}
     * @memberof CreateTagRequest
     */
    directory?: string | null;
    /**
     * The tag's name (**without** the "tag:" prefix)
     * @type {string}
     * @memberof CreateTagRequest
     */
    name: string;
}
/**
 * @type CreateTenant200Response
 * 
 * @export
 */
export type CreateTenant200Response = CreateTenantResponse | FormErrorResponseForCreateTenantErrors;
/**
 * 
 * @export
 * @interface CreateTenantErrors
 */
export interface CreateTenantErrors {
    /**
     * If the name is already used
     * @type {boolean}
     * @memberof CreateTenantErrors
     */
    name_already_used: boolean;
}
/**
 * 
 * @export
 * @interface CreateTenantRequest
 */
export interface CreateTenantRequest {
    /**
     * The name of the tenant
     * @type {string}
     * @memberof CreateTenantRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface CreateTenantResponse
 */
export interface CreateTenantResponse {
    /**
     * The primary key of the tenant
     * @type {string}
     * @memberof CreateTenantResponse
     */
    uuid: string;
}
/**
 * `DERPHomeParams` contains parameters from the server related to selecting a DERP home region (sometimes referred to as the "preferred DERP").
 * @export
 * @interface DERPHomeParams
 */
export interface DERPHomeParams {
    /**
     * `region_score` scales latencies of DERP regions by a given scaling factor when determining which region to use as the home ("preferred") DERP. Scores in the range (0, 1) will cause this region to be proportionally more preferred, and scores in the range (1, ∞) will penalize a region.
     * 
     * If a region is not present in this map, it is treated as having a score of 1.0.
     * 
     * Scores should not be 0 or negative; such scores will be ignored.
     * 
     * A nil map means no change from the previous value (if any); an empty non-nil map can be sent to reset all scores back to 1.0.
     * @type {{ [key: string]: number | undefined; }}
     * @memberof DERPHomeParams
     */
    RegionScore?: { [key: string]: number | undefined; };
}
/**
 * `DERPMap` describes the set of DERP packet relay servers that are available.
 * @export
 * @interface DERPMap
 */
export interface DERPMap {
    /**
     * `home_params`, if non-nil, is a change in home parameters.
     * 
     * The rest of the DEPRMap fields, if zero, means unchanged.
     * @type {DERPHomeParams}
     * @memberof DERPMap
     */
    HomeParams?: DERPHomeParams | null;
    /**
     * `regions` is the set of geographic regions running DERP node(s).
     * 
     * It's keyed by the DERPRegion.RegionID.
     * 
     * The numbers are not necessarily contiguous.
     * @type {{ [key: string]: DERPRegion | undefined | null; }}
     * @memberof DERPMap
     */
    Regions?: { [key: string]: DERPRegion | undefined | null; };
    /**
     * `omit_default_regions` specifies to not use Tailscale's DERP servers, and only use those specified in this DERPMap. If there are none set outside of the defaults, this is a noop.
     * 
     * This field is only meaningful if the Regions map is non-nil (indicating a change).
     * @type {boolean}
     * @memberof DERPMap
     */
    omitDefaultRegions?: boolean;
}
/**
 * `DERPNode` describes a DERP packet relay node running within a [`DERPRegion`].
 * @export
 * @interface DERPNode
 */
export interface DERPNode {
    /**
     * CanPort80 specifies whether this DERP node is accessible over HTTP on port 80 specifically. This is used for captive portal checks.
     * @type {boolean}
     * @memberof DERPNode
     */
    CanPort80?: boolean;
    /**
     * `cert_name` optionally specifies the expected TLS cert common name. If empty, HostName is used. If `cert_name` is non-empty, HostName is only used for the TCP dial (if IPv4/IPv6 are not present) + TLS ClientHello.
     * @type {string}
     * @memberof DERPNode
     */
    CertName?: string;
    /**
     * `derp_port` optionally provides an alternate TLS port number for the DERP HTTPS server.
     * 
     * If zero, 443 is used.
     * @type {number}
     * @memberof DERPNode
     */
    DERPPort?: number;
    /**
     * `host_name` is the DERP node's hostname.
     * 
     * It is required but need not be unique; multiple nodes may have the same HostName but vary in configuration otherwise.
     * @type {string}
     * @memberof DERPNode
     */
    HostName?: string;
    /**
     * `ipv4` optionally forces an IPv4 address to use, instead of using DNS. If empty, A record(s) from DNS lookups of HostName are used. If the string is not an IPv4 address, `ipv4` is not used; the conventional string to disable IPv4 (and not use DNS) is "none".
     * @type {string}
     * @memberof DERPNode
     */
    IPv4?: string;
    /**
     * `ipv6` optionally forces an IPv6 address to use, instead of using DNS. If empty, AAAA record(s) from DNS lookups of HostName are used. If the string is not an IPv6 address, IPv6 is not used; the conventional string to disable `ipv6` (and not use DNS) is "none".
     * @type {string}
     * @memberof DERPNode
     */
    IPv6?: string;
    /**
     * `insecure_for_tests` is used by unit tests to disable TLS verification. It should not be set by users.
     * @type {boolean}
     * @memberof DERPNode
     */
    InsecureForTests?: boolean;
    /**
     * `name` is a unique node name (across all regions). It is not a host name. It's typically of the form "1b", "2a", "3b", etc. (region ID + suffix within that region)
     * @type {string}
     * @memberof DERPNode
     */
    Name?: string;
    /**
     * `region_id` is the region id of the DERPRegion that this node is running in.
     * @type {number}
     * @memberof DERPNode
     */
    RegionID?: number;
    /**
     * `stun_only` marks a node as only a STUN server and not a DERP server.
     * @type {boolean}
     * @memberof DERPNode
     */
    STUNOnly?: boolean;
    /**
     * `stun_port` optionally specifies a STUN port to use. Zero means 3478. To disable STUN on this node, use -1.
     * @type {number}
     * @memberof DERPNode
     */
    STUNPort?: number;
    /**
     * `stun_test_ip` is used in tests to override the STUN server's IP. If empty, it's assumed to be the same as the DERP server.
     * @type {string}
     * @memberof DERPNode
     */
    STUNTestIP?: string;
}
/**
 * `DERPRegion` is a geographic region running DERP relay node(s).
 * 
 * Client nodes discover which region they're closest to, advertise that "home" DERP region (previously called "home node", when there was only 1 node per region) and maintain a persistent connection that region as long as it's the closest. Client nodes will further connect to other regions as necessary to communicate with peers advertising other regions as their homes.
 * @export
 * @interface DERPRegion
 */
export interface DERPRegion {
    /**
     * `avoid` is whether the client should avoid picking this as its home region. The region should only be used if a peer is there. Clients already using this region as their home should migrate away to a new region without `avoid` set.
     * @type {boolean}
     * @memberof DERPRegion
     */
    Avoid?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DERPRegion
     */
    Latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof DERPRegion
     */
    Longitude?: number;
    /**
     * `nodes` are the DERP nodes running in this region, in priority order for the current client. Client TLS connections should ideally only go to the first entry (falling back to the second if necessary). STUN packets should go to the first 1 or 2.
     * 
     * If nodes within a region route packets amongst themselves, but not to other regions. That said, each user/domain should get a the same preferred node order, so if all nodes for a user/network pick the first one (as they should, when things are healthy), the inter-cluster routing is minimal to zero.
     * @type {Array<DERPNode>}
     * @memberof DERPRegion
     */
    Nodes?: Array<DERPNode> | null;
    /**
     * `region_code` is a short name for the region. It's usually a popular city or airport code in the region: "nyc", "sf", "sin", "fra", etc.
     * @type {string}
     * @memberof DERPRegion
     */
    RegionCode?: string;
    /**
     * `region_id` is a unique integer for a geographic region.
     * 
     * It corresponds to the legacy derpN.tailscale.com hostnames used by older clients. (Older clients will continue to resolve derpN.tailscale.com when contacting peers, rather than use the server-provided DERPMap)
     * 
     * RegionIDs must be non-zero, positive, and guaranteed to fit in a JavaScript number.
     * 
     * RegionIDs in range 900-999 are reserved for end users to run their own DERP nodes.
     * @type {number}
     * @memberof DERPRegion
     */
    RegionID?: number;
    /**
     * `region_name` is a long English name for the region: "New York City", "San Francisco", "Singapore", "Frankfurt", etc.
     * @type {string}
     * @memberof DERPRegion
     */
    RegionName?: string;
}
/**
 * `DNSConfig` is the DNS configuration.
 * @export
 * @interface DNSConfig
 */
export interface DNSConfig {
    /**
     * `cert_domains` are the set of DNS names for which the control plane server will assist with provisioning TLS certificates. See SetDNSRequest, which can be used to answer dns-01 ACME challenges for e.g. LetsEncrypt. These names are FQDNs without trailing periods, and without any "_acme-challenge." prefix.
     * @type {Array<string>}
     * @memberof DNSConfig
     */
    CertDomains?: Array<string> | null;
    /**
     * `domains` are the search domains to use. Search domains must be FQDNs, but *without* the trailing dot.
     * @type {Array<string>}
     * @memberof DNSConfig
     */
    Domains?: Array<string> | null;
    /**
     * `exit_node_filtered_set` are the DNS suffixes that the node, when being an exit node DNS proxy, should not answer.
     * 
     * The entries do not contain trailing periods and are always all lowercase.
     * 
     * If an entry starts with a period, it's a suffix match (but suffix ".a.b" doesn't match "a.b"; a prefix is required).
     * 
     * If an entry does not start with a period, it's an exact match.
     * 
     * Matches are case insensitive.
     * @type {Array<string>}
     * @memberof DNSConfig
     */
    ExitNodeFilteredSet?: Array<string> | null;
    /**
     * `extra_records` contains extra DNS records to add to the MagicDNS config.
     * @type {Array<DNSRecord>}
     * @memberof DNSConfig
     */
    ExtraRecords?: Array<DNSRecord> | null;
    /**
     * `fallback_resolvers` is like `resolvers`, but is only used if a split DNS configuration is requested in a configuration that doesn't work yet without explicit default resolvers. https://github.com/tailscale/tailscale/issues/1743
     * @type {Array<DnsResolver>}
     * @memberof DNSConfig
     */
    FallbackResolvers?: Array<DnsResolver> | null;
    /**
     * `nameservers` are the IP addresses of the nameservers to use.
     * @type {Array<string>}
     * @memberof DNSConfig
     */
    Nameservers?: Array<string> | null;
    /**
     * `proxied` turns on automatic resolution of hostnames for devices in the network map, aka MagicDNS. Despite the (legacy) name, does not necessarily cause request proxying to be enabled.
     * @type {boolean}
     * @memberof DNSConfig
     */
    Proxied?: boolean;
    /**
     * `resolvers` are the DNS resolvers to use, in order of preference.
     * @type {Array<DnsResolver>}
     * @memberof DNSConfig
     */
    Resolvers?: Array<DnsResolver> | null;
    /**
     * `routes` maps DNS name suffixes to a set of DNS resolvers to use. It is used to implement "split DNS" and other advanced DNS routing overlays.
     * 
     * Map keys are fully-qualified DNS name suffixes; they may optionally contain a trailing dot but no leading dot.
     * 
     * If the value is an empty slice, that means the suffix should still be handled by Tailscale's built-in resolver (100.100.100.100), such as for the purpose of handling ExtraRecords.
     * @type {{ [key: string]: Array<DnsResolver> | undefined | null; }}
     * @memberof DNSConfig
     */
    Routes?: { [key: string]: Array<DnsResolver> | undefined | null; };
    /**
     * `temp_corp_issue_13969` is a temporary (2023-08-16) field for an internal hack day prototype. It contains a user inputed URL that should have a list of domains to be blocked. See https://github.com/tailscale/corp/issues/13969.
     * @type {string}
     * @memberof DNSConfig
     */
    TempCorpIssue13969?: string;
}
/**
 * `DNSRecord` is an extra DNS record to add to MagicDNS.
 * @export
 * @interface DNSRecord
 */
export interface DNSRecord {
    /**
     * `name` is the fully qualified domain name of the record to add. The trailing dot is optional.
     * @type {string}
     * @memberof DNSRecord
     */
    Name?: string;
    /**
     * `type` is the DNS record type. Empty means A or AAAA, depending on value. Other values are currently ignored.
     * @type {string}
     * @memberof DNSRecord
     */
    Type?: string;
    /**
     * `value` is the IP address in string form.
     * @type {string}
     * @memberof DNSRecord
     */
    Value?: string;
}
/**
 * `Debug` used to be a miscellaneous set of declarative debug config changes and imperative debug commands. They've since been mostly migrated to node attributes (MapResponse.Node.Capabilities) for the declarative things and c2n requests for the imperative things. Not much remains here. Don't add more.
 * @export
 * @interface Debug
 */
export interface Debug {
    /**
     * `disable_log_tail` disables the logtail package. Once disabled it can't be re-enabled for the lifetime of the process.
     * 
     * This is primarily used by Headscale.
     * @type {boolean}
     * @memberof Debug
     */
    DisableLogTail?: boolean;
    /**
     * `exit` optionally specifies that the client should os.Exit with this code. This is a safety measure in case a client is crash looping or in an unsafe state and we need to remotely shut it down.
     * @type {number}
     * @memberof Debug
     */
    Exit?: number | null;
    /**
     * `sleep_seconds` requests that the client sleep for the provided number of seconds. The client can (and should) limit the value (such as 5 minutes). This exists as a safety measure to slow down spinning clients, in case we introduce a bug in the state machine.
     * @type {number}
     * @memberof Debug
     */
    SleepSeconds?: number;
}
/**
 * 
 * @export
 * @interface DeleteDeviceGroupErrors
 */
export interface DeleteDeviceGroupErrors {
    /**
     * Number of access rules which still use this device group
     * @type {number}
     * @memberof DeleteDeviceGroupErrors
     */
    access_rules?: number | null;
    /**
     * Number of devices which still use this device group
     * @type {number}
     * @memberof DeleteDeviceGroupErrors
     */
    devices?: number | null;
}
/**
 * 
 * @export
 * @interface DeleteLocalGroupErrors
 */
export interface DeleteLocalGroupErrors {
    /**
     * Number of access rules which still use this group
     * @type {number}
     * @memberof DeleteLocalGroupErrors
     */
    access_rules?: number | null;
}
/**
 * 
 * @export
 * @interface DeleteTagErrors
 */
export interface DeleteTagErrors {
    /**
     * Number of access rules which still use this tag
     * @type {number}
     * @memberof DeleteTagErrors
     */
    access_rules?: number | null;
    /**
     * Number of devices which still use this tag
     * @type {number}
     * @memberof DeleteTagErrors
     */
    devices?: number | null;
    /**
     * Number of pre-auth keys which still require this tag
     * @type {number}
     * @memberof DeleteTagErrors
     */
    preauthkeys?: number | null;
}
/**
 * 
 * @export
 * @interface DeviceFromIpResponse
 */
export interface DeviceFromIpResponse {
    /**
     * Name of the Device
     * @type {string}
     * @memberof DeviceFromIpResponse
     */
    name: string;
    /**
     * Uuid of the Device
     * @type {string}
     * @memberof DeviceFromIpResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface DevicesFromNameResponse
 */
export interface DevicesFromNameResponse {
    /**
     * List of resulting devices
     * @type {Array<ShortDeviceFromName>}
     * @memberof DevicesFromNameResponse
     */
    devices: Array<ShortDeviceFromName>;
}
/**
 * `DnsResolver` is the configuration for one DNS resolver.
 * @export
 * @interface DnsResolver
 */
export interface DnsResolver {
    /**
     * `addr` is the address of the DNS resolver, one of: - A plain IP address for a "classic" UDP+TCP DNS resolver. This is the common format as sent by the control plane. - An IP:port, for tests. - "https://resolver.com/path" for DNS over HTTPS; currently as of 2022-09-08 only used for certain well-known resolvers (see the publicdns package) for which the IP addresses to dial DoH are known ahead of time, so bootstrap DNS resolution is not required. - "http://node-address:port/path" for DNS over HTTP over WireGuard. This is implemented in the PeerAPI for exit nodes and app connectors. - [TODO] "tls://resolver.com" for DNS over TCP+TLS
     * @type {string}
     * @memberof DnsResolver
     */
    Addr?: string;
    /**
     * `bootstrap_resolution` is an optional suggested resolution for the DoT/DoH resolver, if the resolver URL does not reference an IP address directly. `bootstrap_resolution` may be empty, in which case clients should look up the DoT/DoH server using their local "classic" DNS resolver.
     * 
     * As of 2022-09-08, `bootstrap_resolution` is not yet used.
     * @type {Array<string>}
     * @memberof DnsResolver
     */
    BootstrapResolution?: Array<string>;
}
/**
 * A single rule contributing to an edge
 * @export
 * @interface EdgeRuleDetailSchema
 */
export interface EdgeRuleDetailSchema {
    /**
     * The rule's description
     * @type {string}
     * @memberof EdgeRuleDetailSchema
     */
    description: string;
    /**
     * High port
     * @type {number}
     * @memberof EdgeRuleDetailSchema
     */
    port_high: number;
    /**
     * Low port
     * @type {number}
     * @memberof EdgeRuleDetailSchema
     */
    port_low: number;
    /**
     * The protocol
     * @type {AccessRuleProtocol}
     * @memberof EdgeRuleDetailSchema
     */
    protocol: AccessRuleProtocol;
    /**
     * Where this rule comes from
     * @type {EdgeRuleSourceSchema}
     * @memberof EdgeRuleDetailSchema
     */
    source: EdgeRuleSourceSchema;
}
/**
 * @type EdgeRuleSourceSchema
 * Whether a rule comes from a direct AccessRule or a RulesetInstance
 * @export
 */
export type EdgeRuleSourceSchema = EdgeRuleSourceSchemaOneOf | EdgeRuleSourceSchemaOneOf1;
/**
 * A direct access rule
 * @export
 * @interface EdgeRuleSourceSchemaOneOf
 */
export interface EdgeRuleSourceSchemaOneOf {
    /**
     * 
     * @type {string}
     * @memberof EdgeRuleSourceSchemaOneOf
     */
    type: EdgeRuleSourceSchemaOneOfTypeEnum;
    /**
     * The access rule's UUID
     * @type {string}
     * @memberof EdgeRuleSourceSchemaOneOf
     */
    uuid: string;
}


/**
 * @export
 */
export const EdgeRuleSourceSchemaOneOfTypeEnum = {
    AccessRule: 'AccessRule'
} as const;
export type EdgeRuleSourceSchemaOneOfTypeEnum = typeof EdgeRuleSourceSchemaOneOfTypeEnum[keyof typeof EdgeRuleSourceSchemaOneOfTypeEnum];

/**
 * A rule from a ruleset instance
 * @export
 * @interface EdgeRuleSourceSchemaOneOf1
 */
export interface EdgeRuleSourceSchemaOneOf1 {
    /**
     * The ruleset instance's UUID
     * @type {string}
     * @memberof EdgeRuleSourceSchemaOneOf1
     */
    instance_uuid: string;
    /**
     * The ruleset's name
     * @type {string}
     * @memberof EdgeRuleSourceSchemaOneOf1
     */
    ruleset_name: string;
    /**
     * 
     * @type {string}
     * @memberof EdgeRuleSourceSchemaOneOf1
     */
    type: EdgeRuleSourceSchemaOneOf1TypeEnum;
}


/**
 * @export
 */
export const EdgeRuleSourceSchemaOneOf1TypeEnum = {
    Ruleset: 'Ruleset'
} as const;
export type EdgeRuleSourceSchemaOneOf1TypeEnum = typeof EdgeRuleSourceSchemaOneOf1TypeEnum[keyof typeof EdgeRuleSourceSchemaOneOf1TypeEnum];

/**
 * An entity referenced in rules that has zero devices
 * @export
 * @interface EmptyEntityInRuleSchema
 */
export interface EmptyEntityInRuleSchema {
    /**
     * The empty entity
     * @type {AccessVisualizationEntitySchema}
     * @memberof EmptyEntityInRuleSchema
     */
    entity: AccessVisualizationEntitySchema;
    /**
     * The entity's display name
     * @type {string}
     * @memberof EmptyEntityInRuleSchema
     */
    entity_name: string;
    /**
     * UUIDs of rules referencing this empty entity
     * @type {Array<string>}
     * @memberof EmptyEntityInRuleSchema
     */
    rule_uuids: Array<string>;
}
/**
 * 
 * @export
 * @interface EnableSubnetRequest
 */
export interface EnableSubnetRequest {
    /**
     * Uuids of the devices to use as routers.
     * @type {Array<string>}
     * @memberof EnableSubnetRequest
     */
    routers: Array<string>;
}

/**
 * Constant string `"Err"` which is documented by schemars
 * @export
 */
export const ErrorConstant = {
    Err: 'Err'
} as const;
export type ErrorConstant = typeof ErrorConstant[keyof typeof ErrorConstant];

/**
 * Represent a device, with only relevant parameters for the exit node
 * @export
 * @interface ExitNodeDevice
 */
export interface ExitNodeDevice {
    /**
     * When the device was created
     * @type {string}
     * @memberof ExitNodeDevice
     */
    created_at: string;
    /**
     * Name this device is named in the dns
     * 
     * This value is inferred from `hostname` but can be overwritten by an admin.
     * @type {string}
     * @memberof ExitNodeDevice
     */
    dnsname: string;
    /**
     * Has the device' session expired?
     * @type {boolean}
     * @memberof ExitNodeDevice
     */
    expired: boolean;
    /**
     * When will the device's current session expire?
     * @type {string}
     * @memberof ExitNodeDevice
     */
    expiry?: string | null;
    /**
     * Hostname set by the tailscale client
     * 
     * This value is not used for the DNS.
     * @type {string}
     * @memberof ExitNodeDevice
     */
    hostname: string;
    /**
     * Ip v4 addresses
     * @type {string}
     * @memberof ExitNodeDevice
     */
    ipv4?: string | null;
    /**
     * Ip v6 addresses
     * @type {string}
     * @memberof ExitNodeDevice
     */
    ipv6?: string | null;
    /**
     * When was the time the device was online?
     * @type {string}
     * @memberof ExitNodeDevice
     */
    last_seen?: string | null;
    /**
     * Is the device currently online?
     * @type {boolean}
     * @memberof ExitNodeDevice
     */
    online: boolean;
    /**
     * The device's tags
     * @type {Array<SimpleTag>}
     * @memberof ExitNodeDevice
     */
    tags: Array<SimpleTag>;
    /**
     * The primary key
     * @type {string}
     * @memberof ExitNodeDevice
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface ExtraDnsRecordError
 */
export interface ExtraDnsRecordError {
    /**
     * The IP address was already added to the Domain
     * @type {boolean}
     * @memberof ExtraDnsRecordError
     */
    ip_address_exists: boolean;
    /**
     * The ip of the record is not a valid ip
     * @type {boolean}
     * @memberof ExtraDnsRecordError
     */
    ip_invalid: boolean;
    /**
     * If the IP is in the internal range but no device exists
     * @type {boolean}
     * @memberof ExtraDnsRecordError
     */
    no_internal_device: boolean;
}

/**
 * 
 * @export
 */
export const ExtraDnsRecordType = {
    A: 'A',
    AAAA: 'AAAA'
} as const;
export type ExtraDnsRecordType = typeof ExtraDnsRecordType[keyof typeof ExtraDnsRecordType];

/**
 * `FilterRule` represents one rule in a packet filter.
 * 
 * A rule is logically a set of source CIDRs to match (described by SrcIPs), and a set of destination targets that are then allowed if a source IP is matches of those CIDRs.
 * @export
 * @interface FilterRule
 */
export interface FilterRule {
    /**
     * `cap_grant`, if non-empty, are the capabilities to conditionally grant to the source IP in SrcIPs.
     * 
     * Think of `dst_ports` as "capabilities for networking" and `cap_grant` as arbitrary application-defined capabilities defined between the admin's ACLs and the application doing WhoIs lookups, looking up the remote IP address's application-level capabilities.
     * 
     * `cap_grant` and `dst_ports` are mutually exclusive: at most one can be non-nil.
     * @type {Array<CapGrant>}
     * @memberof FilterRule
     */
    CapGrant?: Array<CapGrant> | null;
    /**
     * `dst_ports` are the port ranges to allow once a source IP matches (is in the CIDR described by SrcIPs).
     * 
     * `cap_grant` and `dst_ports` are mutually exclusive: at most one can be non-nil.
     * @type {Array<NetPortRange>}
     * @memberof FilterRule
     */
    DstPorts?: Array<NetPortRange> | null;
    /**
     * `ip_proto` are the IP protocol numbers to match.
     * 
     * As a special case, nil or empty means TCP, UDP, and ICMP.
     * 
     * Numbers outside the uint8 range (below 0 or above 255) are reserved for Tailscale's use. Unknown ones are ignored.
     * 
     * Depending on the `IPProto` values, `dst_ports` may or may not be used.
     * @type {Array<number>}
     * @memberof FilterRule
     */
    IPProto?: Array<number> | null;
    /**
     * `src_bits` is deprecated; it was the old way to specify a CIDR prior to CapabilityVersion 7. Its values correspond to the SrcIPs above.
     * 
     * If an entry of `src_bits` is present for the same index as a SrcIPs entry, it changes the SrcIP above to be a network with /n CIDR bits. If the slice is nil or insufficiently long, the default value (for an IPv4 address) for a position is 32, as if the SrcIPs above were a /32 mask. For a "*" SrcIPs value, the corresponding `src_bits` value is ignored.
     * 
     * This is still present in this file because the Tailscale control plane code still uses this type, for 118 clients that are still connected as of 2024-06-18, 3.5 years after the last release that used this type.
     * @type {Array<number>}
     * @memberof FilterRule
     */
    SrcBits?: Array<number> | null;
    /**
     * `src_ips` are the source IPs/networks to match.
     * 
     * It may take the following forms: * an IP address (IPv4 or IPv6) * the string "*" to match everything (both IPv4 & IPv6) * a CIDR (e.g. "192.168.0.0/16") * a range of two IPs, inclusive, separated by hyphen ("2eff::1-2eff::0800") * a string "cap:<capability>" with NodeCapMap cap name
     * @type {Array<string>}
     * @memberof FilterRule
     */
    SrcIPs?: Array<string> | null;
}
/**
 * The response that is sent in a case of an error the caller should present his user
 * @export
 * @interface FormErrorResponseForAddTenantDomainErrors
 */
export interface FormErrorResponseForAddTenantDomainErrors {
    /**
     * The actual error struct
     * @type {AddTenantDomainErrors}
     * @memberof FormErrorResponseForAddTenantDomainErrors
     */
    error: AddTenantDomainErrors;
    /**
     * A constant `"Err"` used to differentiate this schema from any other "Ok" schema
     * @type {ErrorConstant}
     * @memberof FormErrorResponseForAddTenantDomainErrors
     */
    result: ErrorConstant;
}
/**
 * The response that is sent in a case of an error the caller should present his user
 * @export
 * @interface FormErrorResponseForCreateExtraDnsRecordsError
 */
export interface FormErrorResponseForCreateExtraDnsRecordsError {
    /**
     * The actual error struct
     * @type {CreateExtraDnsRecordsError}
     * @memberof FormErrorResponseForCreateExtraDnsRecordsError
     */
    error: CreateExtraDnsRecordsError;
    /**
     * A constant `"Err"` used to differentiate this schema from any other "Ok" schema
     * @type {ErrorConstant}
     * @memberof FormErrorResponseForCreateExtraDnsRecordsError
     */
    result: ErrorConstant;
}
/**
 * The response that is sent in a case of an error the caller should present his user
 * @export
 * @interface FormErrorResponseForCreateOidcProviderErrors
 */
export interface FormErrorResponseForCreateOidcProviderErrors {
    /**
     * The actual error struct
     * @type {CreateOidcProviderErrors}
     * @memberof FormErrorResponseForCreateOidcProviderErrors
     */
    error: CreateOidcProviderErrors;
    /**
     * A constant `"Err"` used to differentiate this schema from any other "Ok" schema
     * @type {ErrorConstant}
     * @memberof FormErrorResponseForCreateOidcProviderErrors
     */
    result: ErrorConstant;
}
/**
 * The response that is sent in a case of an error the caller should present his user
 * @export
 * @interface FormErrorResponseForCreateTenantErrors
 */
export interface FormErrorResponseForCreateTenantErrors {
    /**
     * The actual error struct
     * @type {CreateTenantErrors}
     * @memberof FormErrorResponseForCreateTenantErrors
     */
    error: CreateTenantErrors;
    /**
     * A constant `"Err"` used to differentiate this schema from any other "Ok" schema
     * @type {ErrorConstant}
     * @memberof FormErrorResponseForCreateTenantErrors
     */
    result: ErrorConstant;
}
/**
 * The response that is sent in a case of an error the caller should present his user
 * @export
 * @interface FormErrorResponseForInsertDnsSearchDomainError
 */
export interface FormErrorResponseForInsertDnsSearchDomainError {
    /**
     * The actual error struct
     * @type {InsertDnsSearchDomainError}
     * @memberof FormErrorResponseForInsertDnsSearchDomainError
     */
    error: InsertDnsSearchDomainError;
    /**
     * A constant `"Err"` used to differentiate this schema from any other "Ok" schema
     * @type {ErrorConstant}
     * @memberof FormErrorResponseForInsertDnsSearchDomainError
     */
    result: ErrorConstant;
}
/**
 * The response that is sent in a case of an error the caller should present his user
 * @export
 * @interface FormErrorResponseForInsertTenantSearchDomainErrors
 */
export interface FormErrorResponseForInsertTenantSearchDomainErrors {
    /**
     * The actual error struct
     * @type {InsertTenantSearchDomainErrors}
     * @memberof FormErrorResponseForInsertTenantSearchDomainErrors
     */
    error: InsertTenantSearchDomainErrors;
    /**
     * A constant `"Err"` used to differentiate this schema from any other "Ok" schema
     * @type {ErrorConstant}
     * @memberof FormErrorResponseForInsertTenantSearchDomainErrors
     */
    result: ErrorConstant;
}
/**
 * The response that is sent in a case of an error the caller should present his user
 * @export
 * @interface FormErrorResponseForSetDeviceDnsnameErrors
 */
export interface FormErrorResponseForSetDeviceDnsnameErrors {
    /**
     * The actual error struct
     * @type {SetDeviceDnsnameErrors}
     * @memberof FormErrorResponseForSetDeviceDnsnameErrors
     */
    error: SetDeviceDnsnameErrors;
    /**
     * A constant `"Err"` used to differentiate this schema from any other "Ok" schema
     * @type {ErrorConstant}
     * @memberof FormErrorResponseForSetDeviceDnsnameErrors
     */
    result: ErrorConstant;
}
/**
 * The response that is sent in a case of an error the caller should present his user
 * @export
 * @interface FormErrorResponseForUpdateExtraDnsDomainError
 */
export interface FormErrorResponseForUpdateExtraDnsDomainError {
    /**
     * The actual error struct
     * @type {UpdateExtraDnsDomainError}
     * @memberof FormErrorResponseForUpdateExtraDnsDomainError
     */
    error: UpdateExtraDnsDomainError;
    /**
     * A constant `"Err"` used to differentiate this schema from any other "Ok" schema
     * @type {ErrorConstant}
     * @memberof FormErrorResponseForUpdateExtraDnsDomainError
     */
    result: ErrorConstant;
}
/**
 * The response that is sent in a case of an error the caller should present his user
 * @export
 * @interface FormErrorResponseForUpdateOidcProviderErrors
 */
export interface FormErrorResponseForUpdateOidcProviderErrors {
    /**
     * The actual error struct
     * @type {UpdateOidcProviderErrors}
     * @memberof FormErrorResponseForUpdateOidcProviderErrors
     */
    error: UpdateOidcProviderErrors;
    /**
     * A constant `"Err"` used to differentiate this schema from any other "Ok" schema
     * @type {ErrorConstant}
     * @memberof FormErrorResponseForUpdateOidcProviderErrors
     */
    result: ErrorConstant;
}
/**
 * The response that is sent in a case of an error the caller should present his user
 * @export
 * @interface FormErrorResponseForUpdateTenantErrors
 */
export interface FormErrorResponseForUpdateTenantErrors {
    /**
     * The actual error struct
     * @type {UpdateTenantErrors}
     * @memberof FormErrorResponseForUpdateTenantErrors
     */
    error: UpdateTenantErrors;
    /**
     * A constant `"Err"` used to differentiate this schema from any other "Ok" schema
     * @type {ErrorConstant}
     * @memberof FormErrorResponseForUpdateTenantErrors
     */
    result: ErrorConstant;
}
/**
 * @type FormResultForNullAndAddMemberToLocalGroupError
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndAddMemberToLocalGroupError = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndAddMemberToLocalGroupErrorOneOf1;
/**
 * 
 * @export
 * @interface FormResultForNullAndAddMemberToLocalGroupErrorOneOf
 */
export interface FormResultForNullAndAddMemberToLocalGroupErrorOneOf {
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndAddMemberToLocalGroupErrorOneOf
     */
    result: FormResultForNullAndAddMemberToLocalGroupErrorOneOfResultEnum;
    /**
     * 
     * @type {any}
     * @memberof FormResultForNullAndAddMemberToLocalGroupErrorOneOf
     */
    value: any | null;
}


/**
 * @export
 */
export const FormResultForNullAndAddMemberToLocalGroupErrorOneOfResultEnum = {
    Ok: 'Ok'
} as const;
export type FormResultForNullAndAddMemberToLocalGroupErrorOneOfResultEnum = typeof FormResultForNullAndAddMemberToLocalGroupErrorOneOfResultEnum[keyof typeof FormResultForNullAndAddMemberToLocalGroupErrorOneOfResultEnum];

/**
 * 
 * @export
 * @interface FormResultForNullAndAddMemberToLocalGroupErrorOneOf1
 */
export interface FormResultForNullAndAddMemberToLocalGroupErrorOneOf1 {
    /**
     * 
     * @type {AddMemberToLocalGroupError}
     * @memberof FormResultForNullAndAddMemberToLocalGroupErrorOneOf1
     */
    error: AddMemberToLocalGroupError;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndAddMemberToLocalGroupErrorOneOf1
     */
    result: FormResultForNullAndAddMemberToLocalGroupErrorOneOf1ResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndAddMemberToLocalGroupErrorOneOf1ResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndAddMemberToLocalGroupErrorOneOf1ResultEnum = typeof FormResultForNullAndAddMemberToLocalGroupErrorOneOf1ResultEnum[keyof typeof FormResultForNullAndAddMemberToLocalGroupErrorOneOf1ResultEnum];

/**
 * @type FormResultForNullAndCreateSplitDnsDomainError
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndCreateSplitDnsDomainError = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndCreateSplitDnsDomainErrorOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndCreateSplitDnsDomainErrorOneOf
 */
export interface FormResultForNullAndCreateSplitDnsDomainErrorOneOf {
    /**
     * 
     * @type {CreateSplitDnsDomainError}
     * @memberof FormResultForNullAndCreateSplitDnsDomainErrorOneOf
     */
    error: CreateSplitDnsDomainError;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndCreateSplitDnsDomainErrorOneOf
     */
    result: FormResultForNullAndCreateSplitDnsDomainErrorOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndCreateSplitDnsDomainErrorOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndCreateSplitDnsDomainErrorOneOfResultEnum = typeof FormResultForNullAndCreateSplitDnsDomainErrorOneOfResultEnum[keyof typeof FormResultForNullAndCreateSplitDnsDomainErrorOneOfResultEnum];

/**
 * @type FormResultForNullAndCreateSplitDnsResolverErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndCreateSplitDnsResolverErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndCreateSplitDnsResolverErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndCreateSplitDnsResolverErrorsOneOf
 */
export interface FormResultForNullAndCreateSplitDnsResolverErrorsOneOf {
    /**
     * 
     * @type {CreateSplitDnsResolverErrors}
     * @memberof FormResultForNullAndCreateSplitDnsResolverErrorsOneOf
     */
    error: CreateSplitDnsResolverErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndCreateSplitDnsResolverErrorsOneOf
     */
    result: FormResultForNullAndCreateSplitDnsResolverErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndCreateSplitDnsResolverErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndCreateSplitDnsResolverErrorsOneOfResultEnum = typeof FormResultForNullAndCreateSplitDnsResolverErrorsOneOfResultEnum[keyof typeof FormResultForNullAndCreateSplitDnsResolverErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndCreateTagDirectoryErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndCreateTagDirectoryErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndCreateTagDirectoryErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndCreateTagDirectoryErrorsOneOf
 */
export interface FormResultForNullAndCreateTagDirectoryErrorsOneOf {
    /**
     * 
     * @type {CreateTagDirectoryErrors}
     * @memberof FormResultForNullAndCreateTagDirectoryErrorsOneOf
     */
    error: CreateTagDirectoryErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndCreateTagDirectoryErrorsOneOf
     */
    result: FormResultForNullAndCreateTagDirectoryErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndCreateTagDirectoryErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndCreateTagDirectoryErrorsOneOfResultEnum = typeof FormResultForNullAndCreateTagDirectoryErrorsOneOfResultEnum[keyof typeof FormResultForNullAndCreateTagDirectoryErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndDeleteDeviceGroupErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndDeleteDeviceGroupErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndDeleteDeviceGroupErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndDeleteDeviceGroupErrorsOneOf
 */
export interface FormResultForNullAndDeleteDeviceGroupErrorsOneOf {
    /**
     * 
     * @type {DeleteDeviceGroupErrors}
     * @memberof FormResultForNullAndDeleteDeviceGroupErrorsOneOf
     */
    error: DeleteDeviceGroupErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndDeleteDeviceGroupErrorsOneOf
     */
    result: FormResultForNullAndDeleteDeviceGroupErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndDeleteDeviceGroupErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndDeleteDeviceGroupErrorsOneOfResultEnum = typeof FormResultForNullAndDeleteDeviceGroupErrorsOneOfResultEnum[keyof typeof FormResultForNullAndDeleteDeviceGroupErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndDeleteLocalGroupErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndDeleteLocalGroupErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndDeleteLocalGroupErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndDeleteLocalGroupErrorsOneOf
 */
export interface FormResultForNullAndDeleteLocalGroupErrorsOneOf {
    /**
     * 
     * @type {DeleteLocalGroupErrors}
     * @memberof FormResultForNullAndDeleteLocalGroupErrorsOneOf
     */
    error: DeleteLocalGroupErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndDeleteLocalGroupErrorsOneOf
     */
    result: FormResultForNullAndDeleteLocalGroupErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndDeleteLocalGroupErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndDeleteLocalGroupErrorsOneOfResultEnum = typeof FormResultForNullAndDeleteLocalGroupErrorsOneOfResultEnum[keyof typeof FormResultForNullAndDeleteLocalGroupErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndDeleteTagErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndDeleteTagErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndDeleteTagErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndDeleteTagErrorsOneOf
 */
export interface FormResultForNullAndDeleteTagErrorsOneOf {
    /**
     * 
     * @type {DeleteTagErrors}
     * @memberof FormResultForNullAndDeleteTagErrorsOneOf
     */
    error: DeleteTagErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndDeleteTagErrorsOneOf
     */
    result: FormResultForNullAndDeleteTagErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndDeleteTagErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndDeleteTagErrorsOneOfResultEnum = typeof FormResultForNullAndDeleteTagErrorsOneOfResultEnum[keyof typeof FormResultForNullAndDeleteTagErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndExtraDnsRecordError
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndExtraDnsRecordError = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndExtraDnsRecordErrorOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndExtraDnsRecordErrorOneOf
 */
export interface FormResultForNullAndExtraDnsRecordErrorOneOf {
    /**
     * 
     * @type {ExtraDnsRecordError}
     * @memberof FormResultForNullAndExtraDnsRecordErrorOneOf
     */
    error: ExtraDnsRecordError;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndExtraDnsRecordErrorOneOf
     */
    result: FormResultForNullAndExtraDnsRecordErrorOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndExtraDnsRecordErrorOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndExtraDnsRecordErrorOneOfResultEnum = typeof FormResultForNullAndExtraDnsRecordErrorOneOfResultEnum[keyof typeof FormResultForNullAndExtraDnsRecordErrorOneOfResultEnum];

/**
 * @type FormResultForNullAndSetDeviceGroupNameErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndSetDeviceGroupNameErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndSetDeviceGroupNameErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndSetDeviceGroupNameErrorsOneOf
 */
export interface FormResultForNullAndSetDeviceGroupNameErrorsOneOf {
    /**
     * 
     * @type {SetDeviceGroupNameErrors}
     * @memberof FormResultForNullAndSetDeviceGroupNameErrorsOneOf
     */
    error: SetDeviceGroupNameErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndSetDeviceGroupNameErrorsOneOf
     */
    result: FormResultForNullAndSetDeviceGroupNameErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndSetDeviceGroupNameErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndSetDeviceGroupNameErrorsOneOfResultEnum = typeof FormResultForNullAndSetDeviceGroupNameErrorsOneOfResultEnum[keyof typeof FormResultForNullAndSetDeviceGroupNameErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndSetGeneralSettingsErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndSetGeneralSettingsErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndSetGeneralSettingsErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndSetGeneralSettingsErrorsOneOf
 */
export interface FormResultForNullAndSetGeneralSettingsErrorsOneOf {
    /**
     * 
     * @type {SetGeneralSettingsErrors}
     * @memberof FormResultForNullAndSetGeneralSettingsErrorsOneOf
     */
    error: SetGeneralSettingsErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndSetGeneralSettingsErrorsOneOf
     */
    result: FormResultForNullAndSetGeneralSettingsErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndSetGeneralSettingsErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndSetGeneralSettingsErrorsOneOfResultEnum = typeof FormResultForNullAndSetGeneralSettingsErrorsOneOfResultEnum[keyof typeof FormResultForNullAndSetGeneralSettingsErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndSetLdapConnectionSettingsErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndSetLdapConnectionSettingsErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndSetLdapConnectionSettingsErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndSetLdapConnectionSettingsErrorsOneOf
 */
export interface FormResultForNullAndSetLdapConnectionSettingsErrorsOneOf {
    /**
     * 
     * @type {SetLdapConnectionSettingsErrors}
     * @memberof FormResultForNullAndSetLdapConnectionSettingsErrorsOneOf
     */
    error: SetLdapConnectionSettingsErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndSetLdapConnectionSettingsErrorsOneOf
     */
    result: FormResultForNullAndSetLdapConnectionSettingsErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndSetLdapConnectionSettingsErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndSetLdapConnectionSettingsErrorsOneOfResultEnum = typeof FormResultForNullAndSetLdapConnectionSettingsErrorsOneOfResultEnum[keyof typeof FormResultForNullAndSetLdapConnectionSettingsErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndSetLdapSettingsErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndSetLdapSettingsErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndSetLdapSettingsErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndSetLdapSettingsErrorsOneOf
 */
export interface FormResultForNullAndSetLdapSettingsErrorsOneOf {
    /**
     * 
     * @type {SetLdapSettingsErrors}
     * @memberof FormResultForNullAndSetLdapSettingsErrorsOneOf
     */
    error: SetLdapSettingsErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndSetLdapSettingsErrorsOneOf
     */
    result: FormResultForNullAndSetLdapSettingsErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndSetLdapSettingsErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndSetLdapSettingsErrorsOneOfResultEnum = typeof FormResultForNullAndSetLdapSettingsErrorsOneOfResultEnum[keyof typeof FormResultForNullAndSetLdapSettingsErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndSetTagNameErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndSetTagNameErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndSetTagNameErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndSetTagNameErrorsOneOf
 */
export interface FormResultForNullAndSetTagNameErrorsOneOf {
    /**
     * 
     * @type {SetTagNameErrors}
     * @memberof FormResultForNullAndSetTagNameErrorsOneOf
     */
    error: SetTagNameErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndSetTagNameErrorsOneOf
     */
    result: FormResultForNullAndSetTagNameErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndSetTagNameErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndSetTagNameErrorsOneOfResultEnum = typeof FormResultForNullAndSetTagNameErrorsOneOfResultEnum[keyof typeof FormResultForNullAndSetTagNameErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndUpdateExtraDnsRecordError
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndUpdateExtraDnsRecordError = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndUpdateExtraDnsRecordErrorOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndUpdateExtraDnsRecordErrorOneOf
 */
export interface FormResultForNullAndUpdateExtraDnsRecordErrorOneOf {
    /**
     * 
     * @type {UpdateExtraDnsRecordError}
     * @memberof FormResultForNullAndUpdateExtraDnsRecordErrorOneOf
     */
    error: UpdateExtraDnsRecordError;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndUpdateExtraDnsRecordErrorOneOf
     */
    result: FormResultForNullAndUpdateExtraDnsRecordErrorOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndUpdateExtraDnsRecordErrorOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndUpdateExtraDnsRecordErrorOneOfResultEnum = typeof FormResultForNullAndUpdateExtraDnsRecordErrorOneOfResultEnum[keyof typeof FormResultForNullAndUpdateExtraDnsRecordErrorOneOfResultEnum];

/**
 * @type FormResultForNullAndUpdateGlobalDnsErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndUpdateGlobalDnsErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndUpdateGlobalDnsErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndUpdateGlobalDnsErrorsOneOf
 */
export interface FormResultForNullAndUpdateGlobalDnsErrorsOneOf {
    /**
     * 
     * @type {UpdateGlobalDnsErrors}
     * @memberof FormResultForNullAndUpdateGlobalDnsErrorsOneOf
     */
    error: UpdateGlobalDnsErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndUpdateGlobalDnsErrorsOneOf
     */
    result: FormResultForNullAndUpdateGlobalDnsErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndUpdateGlobalDnsErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndUpdateGlobalDnsErrorsOneOfResultEnum = typeof FormResultForNullAndUpdateGlobalDnsErrorsOneOfResultEnum[keyof typeof FormResultForNullAndUpdateGlobalDnsErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndUpdateSplitDnsDomainError
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndUpdateSplitDnsDomainError = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndUpdateSplitDnsDomainErrorOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndUpdateSplitDnsDomainErrorOneOf
 */
export interface FormResultForNullAndUpdateSplitDnsDomainErrorOneOf {
    /**
     * 
     * @type {UpdateSplitDnsDomainError}
     * @memberof FormResultForNullAndUpdateSplitDnsDomainErrorOneOf
     */
    error: UpdateSplitDnsDomainError;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndUpdateSplitDnsDomainErrorOneOf
     */
    result: FormResultForNullAndUpdateSplitDnsDomainErrorOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndUpdateSplitDnsDomainErrorOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndUpdateSplitDnsDomainErrorOneOfResultEnum = typeof FormResultForNullAndUpdateSplitDnsDomainErrorOneOfResultEnum[keyof typeof FormResultForNullAndUpdateSplitDnsDomainErrorOneOfResultEnum];

/**
 * @type FormResultForNullAndUpdateSplitDnsResolverErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndUpdateSplitDnsResolverErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndUpdateSplitDnsResolverErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndUpdateSplitDnsResolverErrorsOneOf
 */
export interface FormResultForNullAndUpdateSplitDnsResolverErrorsOneOf {
    /**
     * 
     * @type {UpdateSplitDnsResolverErrors}
     * @memberof FormResultForNullAndUpdateSplitDnsResolverErrorsOneOf
     */
    error: UpdateSplitDnsResolverErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndUpdateSplitDnsResolverErrorsOneOf
     */
    result: FormResultForNullAndUpdateSplitDnsResolverErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndUpdateSplitDnsResolverErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndUpdateSplitDnsResolverErrorsOneOfResultEnum = typeof FormResultForNullAndUpdateSplitDnsResolverErrorsOneOfResultEnum[keyof typeof FormResultForNullAndUpdateSplitDnsResolverErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndUpdateTagDirectoryErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndUpdateTagDirectoryErrors = FormResultForNullAndAddMemberToLocalGroupErrorOneOf | FormResultForNullAndUpdateTagDirectoryErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndUpdateTagDirectoryErrorsOneOf
 */
export interface FormResultForNullAndUpdateTagDirectoryErrorsOneOf {
    /**
     * 
     * @type {UpdateTagDirectoryErrors}
     * @memberof FormResultForNullAndUpdateTagDirectoryErrorsOneOf
     */
    error: UpdateTagDirectoryErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndUpdateTagDirectoryErrorsOneOf
     */
    result: FormResultForNullAndUpdateTagDirectoryErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndUpdateTagDirectoryErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndUpdateTagDirectoryErrorsOneOfResultEnum = typeof FormResultForNullAndUpdateTagDirectoryErrorsOneOfResultEnum[keyof typeof FormResultForNullAndUpdateTagDirectoryErrorsOneOfResultEnum];

/**
 * @type FormResultForSimpleInvitationLinkAndInviteUserErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForSimpleInvitationLinkAndInviteUserErrors = FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf | FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf1;
/**
 * 
 * @export
 * @interface FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf
 */
export interface FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf {
    /**
     * 
     * @type {string}
     * @memberof FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf
     */
    result: FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOfResultEnum;
    /**
     * 
     * @type {SimpleInvitationLink}
     * @memberof FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf
     */
    value: SimpleInvitationLink;
}


/**
 * @export
 */
export const FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOfResultEnum = {
    Ok: 'Ok'
} as const;
export type FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOfResultEnum = typeof FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOfResultEnum[keyof typeof FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOfResultEnum];

/**
 * 
 * @export
 * @interface FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf1
 */
export interface FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf1 {
    /**
     * 
     * @type {InviteUserErrors}
     * @memberof FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf1
     */
    error: InviteUserErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf1
     */
    result: FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf1ResultEnum;
}


/**
 * @export
 */
export const FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf1ResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf1ResultEnum = typeof FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf1ResultEnum[keyof typeof FormResultForSimpleInvitationLinkAndInviteUserErrorsOneOf1ResultEnum];

/**
 * @type FormResultForSingleUuidAndCreateDeviceGroupErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForSingleUuidAndCreateDeviceGroupErrors = FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf | FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf1;
/**
 * 
 * @export
 * @interface FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf
 */
export interface FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf {
    /**
     * 
     * @type {string}
     * @memberof FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf
     */
    result: FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOfResultEnum;
    /**
     * 
     * @type {SingleUuid}
     * @memberof FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf
     */
    value: SingleUuid;
}


/**
 * @export
 */
export const FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOfResultEnum = {
    Ok: 'Ok'
} as const;
export type FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOfResultEnum = typeof FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOfResultEnum[keyof typeof FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOfResultEnum];

/**
 * 
 * @export
 * @interface FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf1
 */
export interface FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf1 {
    /**
     * 
     * @type {CreateDeviceGroupErrors}
     * @memberof FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf1
     */
    error: CreateDeviceGroupErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf1
     */
    result: FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf1ResultEnum;
}


/**
 * @export
 */
export const FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf1ResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf1ResultEnum = typeof FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf1ResultEnum[keyof typeof FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf1ResultEnum];

/**
 * @type FormResultForSingleUuidAndCreateLocalGroupErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForSingleUuidAndCreateLocalGroupErrors = FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf | FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf
 */
export interface FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf {
    /**
     * 
     * @type {CreateLocalGroupErrors}
     * @memberof FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf
     */
    error: CreateLocalGroupErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf
     */
    result: FormResultForSingleUuidAndCreateLocalGroupErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForSingleUuidAndCreateLocalGroupErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForSingleUuidAndCreateLocalGroupErrorsOneOfResultEnum = typeof FormResultForSingleUuidAndCreateLocalGroupErrorsOneOfResultEnum[keyof typeof FormResultForSingleUuidAndCreateLocalGroupErrorsOneOfResultEnum];

/**
 * @type FormResultForSingleUuidAndCreateTagErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForSingleUuidAndCreateTagErrors = FormResultForSingleUuidAndCreateDeviceGroupErrorsOneOf | FormResultForSingleUuidAndCreateTagErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForSingleUuidAndCreateTagErrorsOneOf
 */
export interface FormResultForSingleUuidAndCreateTagErrorsOneOf {
    /**
     * 
     * @type {CreateTagErrors}
     * @memberof FormResultForSingleUuidAndCreateTagErrorsOneOf
     */
    error: CreateTagErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForSingleUuidAndCreateTagErrorsOneOf
     */
    result: FormResultForSingleUuidAndCreateTagErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForSingleUuidAndCreateTagErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForSingleUuidAndCreateTagErrorsOneOfResultEnum = typeof FormResultForSingleUuidAndCreateTagErrorsOneOfResultEnum[keyof typeof FormResultForSingleUuidAndCreateTagErrorsOneOfResultEnum];

/**
 * @type FormResultForTestLdapSearchResponseAndTestLdapSettingsErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForTestLdapSearchResponseAndTestLdapSettingsErrors = FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf | FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1;
/**
 * 
 * @export
 * @interface FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf
 */
export interface FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf {
    /**
     * 
     * @type {string}
     * @memberof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf
     */
    result: FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOfResultEnum;
    /**
     * 
     * @type {TestLdapSearchResponse}
     * @memberof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf
     */
    value: TestLdapSearchResponse;
}


/**
 * @export
 */
export const FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOfResultEnum = {
    Ok: 'Ok'
} as const;
export type FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOfResultEnum = typeof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOfResultEnum[keyof typeof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOfResultEnum];

/**
 * 
 * @export
 * @interface FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1
 */
export interface FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1 {
    /**
     * 
     * @type {TestLdapSettingsErrors}
     * @memberof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1
     */
    error: TestLdapSettingsErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1
     */
    result: FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1ResultEnum;
}


/**
 * @export
 */
export const FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1ResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1ResultEnum = typeof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1ResultEnum[keyof typeof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1ResultEnum];

/**
 * 
 * @export
 * @interface FullAccessRule
 */
export interface FullAccessRule {
    /**
     * 
     * @type {string}
     * @memberof FullAccessRule
     */
    description: string;
    /**
     * 
     * @type {FullAccessRuleDst}
     * @memberof FullAccessRule
     */
    dst: FullAccessRuleDst;
    /**
     * 
     * @type {number}
     * @memberof FullAccessRule
     */
    port: number;
    /**
     * 
     * @type {number}
     * @memberof FullAccessRule
     */
    port_range_end?: number | null;
    /**
     * 
     * @type {AccessRuleProtocol}
     * @memberof FullAccessRule
     */
    protocol: AccessRuleProtocol;
    /**
     * 
     * @type {FullAccessRuleSrc}
     * @memberof FullAccessRule
     */
    src: FullAccessRuleSrc;
    /**
     * 
     * @type {string}
     * @memberof FullAccessRule
     */
    uuid: string;
}
/**
 * @type FullAccessRuleDst
 * 
 * @export
 */
export type FullAccessRuleDst = FullAccessRuleDstOneOf | FullAccessRuleDstOneOf1 | FullAccessRuleDstOneOf2 | FullAccessRuleDstOneOf3;
/**
 * 
 * @export
 * @interface FullAccessRuleDstOneOf
 */
export interface FullAccessRuleDstOneOf {
    /**
     * 
     * @type {string}
     * @memberof FullAccessRuleDstOneOf
     */
    type: FullAccessRuleDstOneOfTypeEnum;
    /**
     * 
     * @type {SimpleGroup}
     * @memberof FullAccessRuleDstOneOf
     */
    value: SimpleGroup;
}


/**
 * @export
 */
export const FullAccessRuleDstOneOfTypeEnum = {
    Group: 'Group'
} as const;
export type FullAccessRuleDstOneOfTypeEnum = typeof FullAccessRuleDstOneOfTypeEnum[keyof typeof FullAccessRuleDstOneOfTypeEnum];

/**
 * 
 * @export
 * @interface FullAccessRuleDstOneOf1
 */
export interface FullAccessRuleDstOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof FullAccessRuleDstOneOf1
     */
    type: FullAccessRuleDstOneOf1TypeEnum;
    /**
     * 
     * @type {SimpleTag}
     * @memberof FullAccessRuleDstOneOf1
     */
    value: SimpleTag;
}


/**
 * @export
 */
export const FullAccessRuleDstOneOf1TypeEnum = {
    Tag: 'Tag'
} as const;
export type FullAccessRuleDstOneOf1TypeEnum = typeof FullAccessRuleDstOneOf1TypeEnum[keyof typeof FullAccessRuleDstOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface FullAccessRuleDstOneOf2
 */
export interface FullAccessRuleDstOneOf2 {
    /**
     * 
     * @type {string}
     * @memberof FullAccessRuleDstOneOf2
     */
    type: FullAccessRuleDstOneOf2TypeEnum;
    /**
     * 
     * @type {SimpleDeviceGroup}
     * @memberof FullAccessRuleDstOneOf2
     */
    value: SimpleDeviceGroup;
}


/**
 * @export
 */
export const FullAccessRuleDstOneOf2TypeEnum = {
    DeviceGroup: 'DeviceGroup'
} as const;
export type FullAccessRuleDstOneOf2TypeEnum = typeof FullAccessRuleDstOneOf2TypeEnum[keyof typeof FullAccessRuleDstOneOf2TypeEnum];

/**
 * 
 * @export
 * @interface FullAccessRuleDstOneOf3
 */
export interface FullAccessRuleDstOneOf3 {
    /**
     * 
     * @type {string}
     * @memberof FullAccessRuleDstOneOf3
     */
    type: FullAccessRuleDstOneOf3TypeEnum;
    /**
     * 
     * @type {SimpleSubnet}
     * @memberof FullAccessRuleDstOneOf3
     */
    value: SimpleSubnet;
}


/**
 * @export
 */
export const FullAccessRuleDstOneOf3TypeEnum = {
    Subnet: 'Subnet'
} as const;
export type FullAccessRuleDstOneOf3TypeEnum = typeof FullAccessRuleDstOneOf3TypeEnum[keyof typeof FullAccessRuleDstOneOf3TypeEnum];

/**
 * @type FullAccessRuleSrc
 * 
 * @export
 */
export type FullAccessRuleSrc = FullAccessRuleDstOneOf | FullAccessRuleDstOneOf1 | FullAccessRuleDstOneOf2 | FullAccessRuleDstOneOf3;
/**
 * 
 * @export
 * @interface FullDevice
 */
export interface FullDevice {
    /**
     * When was the device created?
     * @type {string}
     * @memberof FullDevice
     */
    created_at: string;
    /**
     * The device's device groups **if** the device is a user device
     * @type {Array<SimpleDeviceGroup>}
     * @memberof FullDevice
     */
    device_groups?: Array<SimpleDeviceGroup> | null;
    /**
     * Name this device is named in the dns
     * 
     * This value is inferred from `hostname` but can be overwritten by an admin.
     * @type {string}
     * @memberof FullDevice
     */
    dnsname: string;
    /**
     * Has the device' session expired?
     * @type {boolean}
     * @memberof FullDevice
     */
    expired: boolean;
    /**
     * When will the device's current session expire?
     * @type {string}
     * @memberof FullDevice
     */
    expiry?: string | null;
    /**
     * The extra records for this device
     * @type {Array<SimpleExtraDnsDomain>}
     * @memberof FullDevice
     */
    extra_records: Array<SimpleExtraDnsDomain>;
    /**
     * Hostname set by the tailscale client
     * 
     * This value is not used for the DNS.
     * @type {string}
     * @memberof FullDevice
     */
    hostname: string;
    /**
     * 
     * @type {string}
     * @memberof FullDevice
     */
    ipv4?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FullDevice
     */
    ipv6?: string | null;
    /**
     * When was the time the device was online?
     * @type {string}
     * @memberof FullDevice
     */
    last_seen?: string | null;
    /**
     * Is the device currently online?
     * @type {boolean}
     * @memberof FullDevice
     */
    online: boolean;
    /**
     * The device's tags **if** the device is a server device
     * @type {Array<SimpleTag>}
     * @memberof FullDevice
     */
    tags?: Array<SimpleTag> | null;
    /**
     * The tenant the device belongs to
     * @type {SimpleTenant}
     * @memberof FullDevice
     */
    tenant: SimpleTenant;
    /**
     * The device's user **if** the device is a user device
     * @type {SimpleUser}
     * @memberof FullDevice
     */
    user?: SimpleUser | null;
    /**
     * The primary key
     * @type {string}
     * @memberof FullDevice
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullDeviceRulesByAssociation
 */
export interface FullDeviceRulesByAssociation {
    /**
     * 
     * @type {Array<FullDeviceRulesForDeviceGroup>}
     * @memberof FullDeviceRulesByAssociation
     */
    device_groups: Array<FullDeviceRulesForDeviceGroup>;
    /**
     * 
     * @type {Array<FullDeviceRulesForGroup>}
     * @memberof FullDeviceRulesByAssociation
     */
    groups: Array<FullDeviceRulesForGroup>;
    /**
     * 
     * @type {Array<FullDeviceRulesForSubnet>}
     * @memberof FullDeviceRulesByAssociation
     */
    subnets: Array<FullDeviceRulesForSubnet>;
    /**
     * 
     * @type {Array<FullDeviceRulesForTag>}
     * @memberof FullDeviceRulesByAssociation
     */
    tags: Array<FullDeviceRulesForTag>;
}
/**
 * 
 * @export
 * @interface FullDeviceRulesForDeviceGroup
 */
export interface FullDeviceRulesForDeviceGroup {
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof FullDeviceRulesForDeviceGroup
     */
    access_rules: Array<FullAccessRule>;
    /**
     * The description for the device group
     * @type {string}
     * @memberof FullDeviceRulesForDeviceGroup
     */
    description: string;
    /**
     * The device group's name
     * @type {string}
     * @memberof FullDeviceRulesForDeviceGroup
     */
    name: string;
    /**
     * 
     * @type {Array<FullRulesetInstance>}
     * @memberof FullDeviceRulesForDeviceGroup
     */
    rulesets: Array<FullRulesetInstance>;
    /**
     * Primary key
     * @type {string}
     * @memberof FullDeviceRulesForDeviceGroup
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullDeviceRulesForGroup
 */
export interface FullDeviceRulesForGroup {
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof FullDeviceRulesForGroup
     */
    access_rules: Array<FullAccessRule>;
    /**
     * 
     * @type {string}
     * @memberof FullDeviceRulesForGroup
     */
    description: string;
    /**
     * The group's identifier in the synced source of truth
     * 
     * I.e. DN for LDAP syncs
     * @type {string}
     * @memberof FullDeviceRulesForGroup
     */
    external_id: string;
    /**
     * Allows this group to have access to `autogroup:internet`
     * @type {boolean}
     * @memberof FullDeviceRulesForGroup
     */
    internet: boolean;
    /**
     * The group's name (**without** the "group:" prefix)
     * @type {string}
     * @memberof FullDeviceRulesForGroup
     */
    name: string;
    /**
     * 
     * @type {GroupProvider}
     * @memberof FullDeviceRulesForGroup
     */
    provider: GroupProvider;
    /**
     * 
     * @type {Array<FullRulesetInstance>}
     * @memberof FullDeviceRulesForGroup
     */
    rulesets: Array<FullRulesetInstance>;
    /**
     * The group's uuid
     * @type {string}
     * @memberof FullDeviceRulesForGroup
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullDeviceRulesForSubnet
 */
export interface FullDeviceRulesForSubnet {
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof FullDeviceRulesForSubnet
     */
    access_rules: Array<FullAccessRule>;
    /**
     * Description of the subnet
     * @type {string}
     * @memberof FullDeviceRulesForSubnet
     */
    description: string;
    /**
     * Does this network have an associated device routing it?
     * @type {boolean}
     * @memberof FullDeviceRulesForSubnet
     */
    has_router: boolean;
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof FullDeviceRulesForSubnet
     */
    name: string;
    /**
     * 
     * @type {Array<FullRulesetInstance>}
     * @memberof FullDeviceRulesForSubnet
     */
    rulesets: Array<FullRulesetInstance>;
    /**
     * Primary key
     * @type {string}
     * @memberof FullDeviceRulesForSubnet
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullDeviceRulesForTag
 */
export interface FullDeviceRulesForTag {
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof FullDeviceRulesForTag
     */
    access_rules: Array<FullAccessRule>;
    /**
     * 
     * @type {string}
     * @memberof FullDeviceRulesForTag
     */
    description: string;
    /**
     * The directory this tag belongs to
     * @type {string}
     * @memberof FullDeviceRulesForTag
     */
    directory?: string | null;
    /**
     * A locked tag's access rules can't be edited
     * @type {boolean}
     * @memberof FullDeviceRulesForTag
     */
    locked: boolean;
    /**
     * The tag's name (**without** the "tag:" prefix)
     * @type {string}
     * @memberof FullDeviceRulesForTag
     */
    name: string;
    /**
     * 
     * @type {Array<FullRulesetInstance>}
     * @memberof FullDeviceRulesForTag
     */
    rulesets: Array<FullRulesetInstance>;
    /**
     * Primary key
     * @type {string}
     * @memberof FullDeviceRulesForTag
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullExtraDnsDomain
 */
export interface FullExtraDnsDomain {
    /**
     * Description
     * @type {string}
     * @memberof FullExtraDnsDomain
     */
    description: string;
    /**
     * The fully qualified domain name
     * @type {string}
     * @memberof FullExtraDnsDomain
     */
    from_dns: string;
    /**
     * BackRef to all records that belong to this domain
     * @type {Array<FullExtraDnsRecord>}
     * @memberof FullExtraDnsDomain
     */
    records: Array<FullExtraDnsRecord>;
    /**
     * The primary key
     * @type {string}
     * @memberof FullExtraDnsDomain
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullExtraDnsRecord
 */
export interface FullExtraDnsRecord {
    /**
     * Optional link to a known device (if to_ip matches device IP)
     * @type {string}
     * @memberof FullExtraDnsRecord
     */
    device_uuid?: string | null;
    /**
     * The DNS record type. Only A or AAAA. Other values are currently ignored.
     * @type {ExtraDnsRecordType}
     * @memberof FullExtraDnsRecord
     */
    record_type: ExtraDnsRecordType;
    /**
     * Target IP address for this record.
     * @type {string}
     * @memberof FullExtraDnsRecord
     */
    to_ip: string;
    /**
     * The primary key
     * @type {string}
     * @memberof FullExtraDnsRecord
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullGlobalDns
 */
export interface FullGlobalDns {
    /**
     * which type of DNS
     * 
     * e.g. "*google*", "*cloudflare*", "*quad9*" or "*custom*"
     * @type {GlobalDnsType}
     * @memberof FullGlobalDns
     */
    dns_type: GlobalDnsType;
    /**
     * 
     * @type {Array<string>}
     * @memberof FullGlobalDns
     */
    ipv4: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FullGlobalDns
     */
    ipv6: Array<string>;
}
/**
 * 
 * @export
 * @interface FullHeadscalePreAuthKey
 */
export interface FullHeadscalePreAuthKey {
    /**
     * 
     * @type {string}
     * @memberof FullHeadscalePreAuthKey
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof FullHeadscalePreAuthKey
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof FullHeadscalePreAuthKey
     */
    ephemeral: boolean;
    /**
     * 
     * @type {string}
     * @memberof FullHeadscalePreAuthKey
     */
    expiration?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FullHeadscalePreAuthKey
     */
    key: string;
    /**
     * 
     * @type {boolean}
     * @memberof FullHeadscalePreAuthKey
     */
    reusable: boolean;
    /**
     * 
     * @type {Array<SimpleTag>}
     * @memberof FullHeadscalePreAuthKey
     */
    tags: Array<SimpleTag>;
    /**
     * 
     * @type {SimpleTenant}
     * @memberof FullHeadscalePreAuthKey
     */
    tenant: SimpleTenant;
    /**
     * 
     * @type {boolean}
     * @memberof FullHeadscalePreAuthKey
     */
    used: boolean;
    /**
     * The key's uuid
     * @type {string}
     * @memberof FullHeadscalePreAuthKey
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullLdapSettings
 */
export interface FullLdapSettings {
    /**
     * The dn to search for groups
     * @type {string}
     * @memberof FullLdapSettings
     */
    group_base: string;
    /**
     * The filter to use when searching for groups
     * @type {string}
     * @memberof FullLdapSettings
     */
    group_filter: string;
    /**
     * LDAP attribute containing the group's name
     * @type {string}
     * @memberof FullLdapSettings
     */
    group_name: string;
    /**
     * Is the ldap sync enabled?
     * @type {boolean}
     * @memberof FullLdapSettings
     */
    ldap_enabled: boolean;
    /**
     * The password to authenticate with at ldap
     * @type {boolean}
     * @memberof FullLdapSettings
     */
    ldap_password: boolean;
    /**
     * The url under which the backend can reach the ldap
     * @type {string}
     * @memberof FullLdapSettings
     */
    ldap_url: string;
    /**
     * The username to authenticate with at ldap
     * @type {string}
     * @memberof FullLdapSettings
     */
    ldap_user: string;
    /**
     * LDAP attribute which stores the membership relation between groups and users
     * 
     * The flag `membership_in_group` stores whether this attribute is found on groups or users
     * @type {string}
     * @memberof FullLdapSettings
     */
    membership_attr: string;
    /**
     * Is the `membership_attr` set for groups and stores the list of users which are members of the group?
     * 
     * Alternatively, the `membership_attr` is set for users and stores the list of groups the user is member of.
     * @type {boolean}
     * @memberof FullLdapSettings
     */
    membership_in_group: boolean;
    /**
     * The dn to search for users
     * @type {string}
     * @memberof FullLdapSettings
     */
    user_base: string;
    /**
     * The filter to use when searching for users
     * @type {string}
     * @memberof FullLdapSettings
     */
    user_filter: string;
    /**
     * LDAP attribute containing the user's name
     * @type {string}
     * @memberof FullLdapSettings
     */
    user_name: string;
    /**
     * LDAP attribute containing the user's remote_id
     * @type {string}
     * @memberof FullLdapSettings
     */
    user_remote_id: string;
}
/**
 * 
 * @export
 * @interface FullPluginSchema
 */
export interface FullPluginSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof FullPluginSchema
     */
    categories: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FullPluginSchema
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof FullPluginSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FullPluginSchema
     */
    uuid: string;
    /**
     * 
     * @type {string}
     * @memberof FullPluginSchema
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof FullPluginSchema
     */
    version_description: string;
    /**
     * Base64-encoded image
     * @type {string}
     * @memberof FullPluginSchema
     */
    version_image: string;
    /**
     * 
     * @type {Array<FullRulesetSchema>}
     * @memberof FullPluginSchema
     */
    version_rulesets: Array<FullRulesetSchema>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FullPluginSchema
     */
    versions: Array<string>;
}
/**
 * 
 * @export
 * @interface FullPossibleSubnetRouter
 */
export interface FullPossibleSubnetRouter {
    /**
     * 
     * @type {boolean}
     * @memberof FullPossibleSubnetRouter
     */
    approved?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FullPossibleSubnetRouter
     */
    created_at: string;
    /**
     * 
     * @type {FullSubnetRouter}
     * @memberof FullPossibleSubnetRouter
     */
    device: FullSubnetRouter;
}
/**
 * 
 * @export
 * @interface FullRuleSchema
 */
export interface FullRuleSchema {
    /**
     * 
     * @type {number}
     * @memberof FullRuleSchema
     */
    dest_port_end?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FullRuleSchema
     */
    dest_port_start: number;
    /**
     * 
     * @type {AccessRuleProtocol2}
     * @memberof FullRuleSchema
     */
    protocol: AccessRuleProtocol2;
}
/**
 * 
 * @export
 * @interface FullRuleset
 */
export interface FullRuleset {
    /**
     * A description
     * @type {string}
     * @memberof FullRuleset
     */
    description: string;
    /**
     * A name
     * @type {string}
     * @memberof FullRuleset
     */
    name: string;
    /**
     * A [`Plugin`]'s primary key
     * @type {string}
     * @memberof FullRuleset
     */
    plugin_uuid?: string | null;
    /**
     * 
     * @type {Array<SimpleRulesetRule>}
     * @memberof FullRuleset
     */
    rules: Array<SimpleRulesetRule>;
    /**
     * The primary key
     * @type {string}
     * @memberof FullRuleset
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullRulesetInstance
 */
export interface FullRulesetInstance {
    /**
     * 
     * @type {FullAccessRuleSrc}
     * @memberof FullRulesetInstance
     */
    dst: FullAccessRuleSrc;
    /**
     * Ruleset applied to `src` and `dst`
     * @type {FullRuleset}
     * @memberof FullRulesetInstance
     */
    ruleset: FullRuleset;
    /**
     * 
     * @type {FullAccessRuleSrc}
     * @memberof FullRulesetInstance
     */
    src: FullAccessRuleSrc;
    /**
     * The primary key
     * @type {string}
     * @memberof FullRulesetInstance
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullRulesetSchema
 */
export interface FullRulesetSchema {
    /**
     * 
     * @type {string}
     * @memberof FullRulesetSchema
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof FullRulesetSchema
     */
    dst_description: string;
    /**
     * 
     * @type {string}
     * @memberof FullRulesetSchema
     */
    name: string;
    /**
     * 
     * @type {Array<FullRuleSchema>}
     * @memberof FullRulesetSchema
     */
    rules: Array<FullRuleSchema>;
    /**
     * 
     * @type {string}
     * @memberof FullRulesetSchema
     */
    src_description: string;
    /**
     * 
     * @type {string}
     * @memberof FullRulesetSchema
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullSplitDnsDomain
 */
export interface FullSplitDnsDomain {
    /**
     * Marks whether this Split Dns configuration is actively used or not
     * @type {boolean}
     * @memberof FullSplitDnsDomain
     */
    disabled: boolean;
    /**
     * The domain name
     * @type {string}
     * @memberof FullSplitDnsDomain
     */
    domain: string;
    /**
     * List of all resolver
     * @type {Array<FullSplitDnsResolver>}
     * @memberof FullSplitDnsDomain
     */
    resolver: Array<FullSplitDnsResolver>;
    /**
     * The tenant this domain is assigned to
     * @type {string}
     * @memberof FullSplitDnsDomain
     */
    tenant?: string | null;
    /**
     * The primary key
     * @type {string}
     * @memberof FullSplitDnsDomain
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullSplitDnsResolver
 */
export interface FullSplitDnsResolver {
    /**
     * Better description to identify the resolver
     * @type {string}
     * @memberof FullSplitDnsResolver
     */
    description: string;
    /**
     * Marks whether this resolver is actively used or not
     * @type {boolean}
     * @memberof FullSplitDnsResolver
     */
    disabled: boolean;
    /**
     * The IP of the resolver
     * @type {string}
     * @memberof FullSplitDnsResolver
     */
    ip: string;
    /**
     * The primary key
     * @type {string}
     * @memberof FullSplitDnsResolver
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullSubnetRouter
 */
export interface FullSubnetRouter {
    /**
     * When was the device created?
     * @type {string}
     * @memberof FullSubnetRouter
     */
    created_at: string;
    /**
     * Name this device is named in the dns
     * 
     * This value is inferred from `hostname` but can be overwritten by an admin.
     * @type {string}
     * @memberof FullSubnetRouter
     */
    dnsname: string;
    /**
     * Has the device' session expired?
     * @type {boolean}
     * @memberof FullSubnetRouter
     */
    expired: boolean;
    /**
     * When will the device's current session expire?
     * @type {string}
     * @memberof FullSubnetRouter
     */
    expiry?: string | null;
    /**
     * Hostname set by the tailscale client
     * 
     * This value is not used for the DNS.
     * @type {string}
     * @memberof FullSubnetRouter
     */
    hostname: string;
    /**
     * 
     * @type {string}
     * @memberof FullSubnetRouter
     */
    ipv4?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FullSubnetRouter
     */
    ipv6?: string | null;
    /**
     * When was the time the device was online?
     * @type {string}
     * @memberof FullSubnetRouter
     */
    last_seen?: string | null;
    /**
     * Is the device currently online?
     * @type {boolean}
     * @memberof FullSubnetRouter
     */
    online: boolean;
    /**
     * The device's tags
     * @type {Array<SimpleTag>}
     * @memberof FullSubnetRouter
     */
    tags: Array<SimpleTag>;
    /**
     * The primary key
     * @type {string}
     * @memberof FullSubnetRouter
     */
    uuid: string;
}
/**
 * A directory
 * @export
 * @interface FullTagDirectory
 */
export interface FullTagDirectory {
    /**
     * The directory's name
     * @type {string}
     * @memberof FullTagDirectory
     */
    name: string;
    /**
     * All tags assigned to this directory.
     * @type {Array<SimpleTag>}
     * @memberof FullTagDirectory
     */
    tags: Array<SimpleTag>;
    /**
     * Primary key
     * @type {string}
     * @memberof FullTagDirectory
     */
    uuid: string;
}
/**
 * A response containing all the ACL rulesets for the tag, group, subnet and device group ACL view
 * @export
 * @interface GetACLRuleSetResponse
 */
export interface GetACLRuleSetResponse {
    /**
     * The inbound rulesets
     * @type {Array<ACLRuleSet>}
     * @memberof GetACLRuleSetResponse
     */
    inbound: Array<ACLRuleSet>;
    /**
     * The outbound rulesets.
     * @type {Array<ACLRuleSet>}
     * @memberof GetACLRuleSetResponse
     */
    outbound: Array<ACLRuleSet>;
}
/**
 * Response for the access graph endpoint
 * @export
 * @interface GetAccessGraphResponse
 */
export interface GetAccessGraphResponse {
    /**
     * All aggregated edges between entity pairs
     * @type {Array<AccessGraphEdgeSchema>}
     * @memberof GetAccessGraphResponse
     */
    edges: Array<AccessGraphEdgeSchema>;
    /**
     * All entity nodes present in the graph
     * @type {Array<AccessGraphNodeSchema>}
     * @memberof GetAccessGraphResponse
     */
    nodes: Array<AccessGraphNodeSchema>;
}
/**
 * Response for the problem detection endpoint
 * @export
 * @interface GetAccessProblemsResponse
 */
export interface GetAccessProblemsResponse {
    /**
     * Entities referenced in rules that have zero devices
     * @type {Array<EmptyEntityInRuleSchema>}
     * @memberof GetAccessProblemsResponse
     */
    empty_entities_in_rules: Array<EmptyEntityInRuleSchema>;
    /**
     * Devices not covered by any access rule
     * @type {Array<OrphanedDeviceSchema>}
     * @memberof GetAccessProblemsResponse
     */
    orphaned_devices: Array<OrphanedDeviceSchema>;
    /**
     * Pairs of redundant rules
     * @type {Array<RedundantRulePairSchema>}
     * @memberof GetAccessProblemsResponse
     */
    redundant_rules: Array<RedundantRulePairSchema>;
    /**
     * Rules where one or both sides resolve to zero devices
     * @type {Array<RuleWithNoDevicesSchema>}
     * @memberof GetAccessProblemsResponse
     */
    rules_with_no_devices: Array<RuleWithNoDevicesSchema>;
}
/**
 * 
 * @export
 * @interface GetAllAccessRuleOptionsResponse
 */
export interface GetAllAccessRuleOptionsResponse {
    /**
     * 
     * @type {Array<SimpleDeviceGroup>}
     * @memberof GetAllAccessRuleOptionsResponse
     */
    device_groups: Array<SimpleDeviceGroup>;
    /**
     * 
     * @type {Array<SimpleGroup>}
     * @memberof GetAllAccessRuleOptionsResponse
     */
    groups: Array<SimpleGroup>;
    /**
     * 
     * @type {Array<SimpleSubnet>}
     * @memberof GetAllAccessRuleOptionsResponse
     */
    subnets: Array<SimpleSubnet>;
    /**
     * 
     * @type {Array<SimpleTag>}
     * @memberof GetAllAccessRuleOptionsResponse
     */
    tags: Array<SimpleTag>;
}
/**
 * 
 * @export
 * @interface GetAllAccessRulesForResponse
 */
export interface GetAllAccessRulesForResponse {
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof GetAllAccessRulesForResponse
     */
    inbound: Array<FullAccessRule>;
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof GetAllAccessRulesForResponse
     */
    outbound: Array<FullAccessRule>;
}
/**
 * 
 * @export
 * @interface GetAllDeviceGroupsRequest
 */
export interface GetAllDeviceGroupsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAllDeviceGroupsRequest
     */
    filter_name?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllDeviceGroupsRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllDeviceGroupsRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetAllDevicesResponse
 */
export interface GetAllDevicesResponse {
    /**
     * 
     * @type {Array<FullDevice>}
     * @memberof GetAllDevicesResponse
     */
    items: Array<FullDevice>;
    /**
     * 
     * @type {number}
     * @memberof GetAllDevicesResponse
     */
    total_clients: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllDevicesResponse
     */
    total_servers: number;
}
/**
 * Page and filter requests for approved exit nodes
 * @export
 * @interface GetAllExitNodesRequest
 */
export interface GetAllExitNodesRequest {
    /**
     * Filters if the exit node is currently advertising
     * @type {boolean}
     * @memberof GetAllExitNodesRequest
     */
    filter_device_advertises?: boolean | null;
    /**
     * Filters if the exit node is disabled or enabled
     * @type {boolean}
     * @memberof GetAllExitNodesRequest
     */
    filter_is_disabled?: boolean | null;
    /**
     * Filter after the dns name of a devices
     * @type {string}
     * @memberof GetAllExitNodesRequest
     */
    filter_name?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllExitNodesRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllExitNodesRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetAllGroupsRequest
 */
export interface GetAllGroupsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAllGroupsRequest
     */
    filter_name?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllGroupsRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllGroupsRequest
     */
    offset: number;
    /**
     * 
     * @type {GroupProvider}
     * @memberof GetAllGroupsRequest
     */
    provider: GroupProvider;
}
/**
 * 
 * @export
 * @interface GetAllGroupsResponseItem
 */
export interface GetAllGroupsResponseItem {
    /**
     * 
     * @type {string}
     * @memberof GetAllGroupsResponseItem
     */
    description: string;
    /**
     * The group's identifier in the synced source of truth
     * 
     * I.e. DN for LDAP syncs
     * @type {string}
     * @memberof GetAllGroupsResponseItem
     */
    external_id: string;
    /**
     * Allows this group to have access to `autogroup:internet`
     * @type {boolean}
     * @memberof GetAllGroupsResponseItem
     */
    internet: boolean;
    /**
     * The number of users in the group
     * @type {number}
     * @memberof GetAllGroupsResponseItem
     */
    members: number;
    /**
     * The group's name (**without** the "group:" prefix)
     * @type {string}
     * @memberof GetAllGroupsResponseItem
     */
    name: string;
    /**
     * 
     * @type {GroupProvider}
     * @memberof GetAllGroupsResponseItem
     */
    provider: GroupProvider;
    /**
     * The tenant this group belongs to
     * @type {SimpleTenant}
     * @memberof GetAllGroupsResponseItem
     */
    tenant?: SimpleTenant | null;
    /**
     * The group's uuid
     * @type {string}
     * @memberof GetAllGroupsResponseItem
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetAllPluginsRequest
 */
export interface GetAllPluginsRequest {
    /**
     * Filters plugins whether they are installed or not
     * @type {boolean}
     * @memberof GetAllPluginsRequest
     */
    filter_installed?: boolean | null;
    /**
     * Filters plugins by name
     * @type {string}
     * @memberof GetAllPluginsRequest
     */
    filter_name?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllPluginsRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllPluginsRequest
     */
    offset: number;
}
/**
 * A page of items
 * @export
 * @interface GetAllPluginsResponse
 */
export interface GetAllPluginsResponse {
    /**
     * The page's items
     * @type {Array<SimplePlugin>}
     * @memberof GetAllPluginsResponse
     */
    items: Array<SimplePlugin>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllPluginsResponse
     */
    limit: number;
    /**
     * `true` if the store can't be reached
     * @type {boolean}
     * @memberof GetAllPluginsResponse
     */
    offline: boolean;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllPluginsResponse
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof GetAllPluginsResponse
     */
    total: number;
}
/**
 * 
 * @export
 * @interface GetAllSubnetsRequest
 */
export interface GetAllSubnetsRequest {
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllSubnetsRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllSubnetsRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetAllSubnetsResponseItem
 */
export interface GetAllSubnetsResponseItem {
    /**
     * Description of the subnet
     * @type {string}
     * @memberof GetAllSubnetsResponseItem
     */
    description: string;
    /**
     * Does this network have an associated device routing it?
     * @type {boolean}
     * @memberof GetAllSubnetsResponseItem
     */
    has_router: boolean;
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof GetAllSubnetsResponseItem
     */
    name: string;
    /**
     * The devices currently routing this network
     * @type {Array<FullSubnetRouter>}
     * @memberof GetAllSubnetsResponseItem
     */
    routers: Array<FullSubnetRouter>;
    /**
     * Primary key
     * @type {string}
     * @memberof GetAllSubnetsResponseItem
     */
    uuid: string;
}
/**
 * A full directory with tag count.
 * @export
 * @interface GetAllTagDirectoriesResponse
 */
export interface GetAllTagDirectoriesResponse {
    /**
     * All directories with tags.
     * @type {Array<FullTagDirectory>}
     * @memberof GetAllTagDirectoriesResponse
     */
    directories: Array<FullTagDirectory>;
    /**
     * All ungrouped tags
     * @type {Array<SimpleTag>}
     * @memberof GetAllTagDirectoriesResponse
     */
    ungrouped_tags: Array<SimpleTag>;
}
/**
 * 
 * @export
 * @interface GetAllTagsRequest
 */
export interface GetAllTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAllTagsRequest
     */
    filter_search?: string | null;
}
/**
 * 
 * @export
 * @interface GetAllUsersResponse
 */
export interface GetAllUsersResponse {
    /**
     * Authentication method used by the user
     * @type {UserSource}
     * @memberof GetAllUsersResponse
     */
    auth: UserSource;
    /**
     * 
     * @type {GetAllUsersResponseAuthSpecific}
     * @memberof GetAllUsersResponse
     */
    auth_specific: GetAllUsersResponseAuthSpecific;
    /**
     * When the user was created
     * @type {string}
     * @memberof GetAllUsersResponse
     */
    created_at: string;
    /**
     * A name for humans to identify the user by
     * @type {string}
     * @memberof GetAllUsersResponse
     */
    display_name: string;
    /**
     * 
     * @type {SimpleTenant}
     * @memberof GetAllUsersResponse
     */
    tenant: SimpleTenant;
    /**
     * The user's uuid
     * @type {string}
     * @memberof GetAllUsersResponse
     */
    uuid: string;
}
/**
 * @type GetAllUsersResponseAuthSpecific
 * Auth state specific details in `GetAllUsersResponse`
 * @export
 */
export type GetAllUsersResponseAuthSpecific = GetAllUsersResponseAuthSpecificOneOf | GetAllUsersResponseAuthSpecificOneOf1 | GetAllUsersResponseAuthSpecificOneOf2;
/**
 * 
 * @export
 * @interface GetAllUsersResponseAuthSpecificOneOf
 */
export interface GetAllUsersResponseAuthSpecificOneOf {
    /**
     * Identifier used by the remote for this user.
     * 
     * This value is used to connect OIDC with the sync protocol (ldap / scim). The admin should configure oidc and ldap or scim such that the report the same external id.
     * @type {string}
     * @memberof GetAllUsersResponseAuthSpecificOneOf
     */
    remote_id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllUsersResponseAuthSpecificOneOf
     */
    type: GetAllUsersResponseAuthSpecificOneOfTypeEnum;
}


/**
 * @export
 */
export const GetAllUsersResponseAuthSpecificOneOfTypeEnum = {
    Remote: 'Remote'
} as const;
export type GetAllUsersResponseAuthSpecificOneOfTypeEnum = typeof GetAllUsersResponseAuthSpecificOneOfTypeEnum[keyof typeof GetAllUsersResponseAuthSpecificOneOfTypeEnum];

/**
 * 
 * @export
 * @interface GetAllUsersResponseAuthSpecificOneOf1
 */
export interface GetAllUsersResponseAuthSpecificOneOf1 {
    /**
     * When will the user's access to the vpn expire?
     * @type {string}
     * @memberof GetAllUsersResponseAuthSpecificOneOf1
     */
    access_expires_at?: string | null;
    /**
     * When did the user's most recent access to the vpn begin?
     * @type {string}
     * @memberof GetAllUsersResponseAuthSpecificOneOf1
     */
    access_start?: string | null;
    /**
     * The current invitation link
     * @type {SimpleInvitationLink}
     * @memberof GetAllUsersResponseAuthSpecificOneOf1
     */
    current_link?: SimpleInvitationLink | null;
    /**
     * Is the user's access to the vpn planned?
     * @type {boolean}
     * @memberof GetAllUsersResponseAuthSpecificOneOf1
     */
    is_access_planned: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAllUsersResponseAuthSpecificOneOf1
     */
    type: GetAllUsersResponseAuthSpecificOneOf1TypeEnum;
}


/**
 * @export
 */
export const GetAllUsersResponseAuthSpecificOneOf1TypeEnum = {
    Invited: 'Invited'
} as const;
export type GetAllUsersResponseAuthSpecificOneOf1TypeEnum = typeof GetAllUsersResponseAuthSpecificOneOf1TypeEnum[keyof typeof GetAllUsersResponseAuthSpecificOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface GetAllUsersResponseAuthSpecificOneOf2
 */
export interface GetAllUsersResponseAuthSpecificOneOf2 {
    /**
     * When will the user's access to the vpn expire?
     * @type {string}
     * @memberof GetAllUsersResponseAuthSpecificOneOf2
     */
    access_expires_at?: string | null;
    /**
     * When did the user's most recent access to the vpn begin?
     * @type {string}
     * @memberof GetAllUsersResponseAuthSpecificOneOf2
     */
    access_start: string;
    /**
     * Has the user's access to the vpn?
     * @type {boolean}
     * @memberof GetAllUsersResponseAuthSpecificOneOf2
     */
    has_access: boolean;
    /**
     * Is the user's access to the vpn planned?
     * @type {boolean}
     * @memberof GetAllUsersResponseAuthSpecificOneOf2
     */
    is_access_planned: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAllUsersResponseAuthSpecificOneOf2
     */
    type: GetAllUsersResponseAuthSpecificOneOf2TypeEnum;
}


/**
 * @export
 */
export const GetAllUsersResponseAuthSpecificOneOf2TypeEnum = {
    Local: 'Local'
} as const;
export type GetAllUsersResponseAuthSpecificOneOf2TypeEnum = typeof GetAllUsersResponseAuthSpecificOneOf2TypeEnum[keyof typeof GetAllUsersResponseAuthSpecificOneOf2TypeEnum];

/**
 * 
 * @export
 * @interface GetChangelogRequest
 */
export interface GetChangelogRequest {
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetChangelogRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetChangelogRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetEphemeralDeviceSettingsResponse
 */
export interface GetEphemeralDeviceSettingsResponse {
    /**
     * The bit of the ephemeral device that is currently being used.
     * @type {number}
     * @memberof GetEphemeralDeviceSettingsResponse
     */
    bit: number;
}
/**
 * Response item for the frontend
 * @export
 * @interface GetExitNodesResponseItem
 */
export interface GetExitNodesResponseItem {
    /**
     * Does the device currently advertise itself as exit node?
     * @type {boolean}
     * @memberof GetExitNodesResponseItem
     */
    advertise: boolean;
    /**
     * The first time the device advocated itself as exit node.
     * @type {string}
     * @memberof GetExitNodesResponseItem
     */
    created_at: string;
    /**
     * The device which is the exit node
     * @type {ExitNodeDevice}
     * @memberof GetExitNodesResponseItem
     */
    device: ExitNodeDevice;
    /**
     * Is the exit node currently enabled?
     * @type {boolean}
     * @memberof GetExitNodesResponseItem
     */
    enabled: boolean;
    /**
     * The primary key
     * @type {string}
     * @memberof GetExitNodesResponseItem
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetGeneralSettingsResponse
 */
export interface GetGeneralSettingsResponse {
    /**
     * URL of the admin web interface. Must contain the protocol (HTTPS) as well as any port and path, if required.
     * @type {string}
     * @memberof GetGeneralSettingsResponse
     */
    admin_origin: string;
    /**
     * Base domain used by 0trust to generate DNS names for devices in the network. Previously called `headscale_base_domain`.
     * @type {string}
     * @memberof GetGeneralSettingsResponse
     */
    dns_base_domain: string;
    /**
     * Search domains used for headscale's magic DNS
     * @type {Array<string>}
     * @memberof GetGeneralSettingsResponse
     */
    headscale_domains: Array<string>;
    /**
     * Publicly reachable target URL of the 0trust server. Must contain the protocol (HTTPS) as well as any port and path, if required. Previously called `headscale_url`.
     * @type {string}
     * @memberof GetGeneralSettingsResponse
     */
    public_origin: string;
}
/**
 * 
 * @export
 * @interface GetLocalAuthRequirementsResponse
 */
export interface GetLocalAuthRequirementsResponse {
    /**
     * The requirements to enforce for local user's credentials
     * @type {LocalAuthRequirements}
     * @memberof GetLocalAuthRequirementsResponse
     */
    requirements: LocalAuthRequirements;
}
/**
 * 
 * @export
 * @interface GetOidcSettingsResponse
 */
export interface GetOidcSettingsResponse {
    /**
     * Self-signed certificate of private key
     * 
     * This needs to be sent to any OpenId Connect provider which wants to use `private_key_jwt` instead of `client_secret` based authentications.
     * @type {string}
     * @memberof GetOidcSettingsResponse
     */
    cert_pem: string;
    /**
     * OAuth client id
     * @type {string}
     * @memberof GetOidcSettingsResponse
     */
    client_id: string;
    /**
     * OAuth client secret
     * 
     * This field might be set but must be ignored if `use_cert` is `true`.
     * @type {string}
     * @memberof GetOidcSettingsResponse
     */
    client_secret: string;
    /**
     * Is the provider currently enabled?
     * @type {boolean}
     * @memberof GetOidcSettingsResponse
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOidcSettingsResponse
     */
    errors?: string | null;
    /**
     * ZTNA's redirect url
     * @type {string}
     * @memberof GetOidcSettingsResponse
     */
    redirect_url: string;
    /**
     * Oidc claim the `remote_id` is read from
     * @type {OidcClaimRemoteId}
     * @memberof GetOidcSettingsResponse
     */
    remote_id: OidcClaimRemoteId;
    /**
     * Issuer Url (the url without the `.well-known/openid-configuration` part)
     * 
     * This should be a valid url but might not be one, if the provider is still being configured.
     * @type {string}
     * @memberof GetOidcSettingsResponse
     */
    url: string;
    /**
     * Use a x509 certificate and a JWT instead of `client_secret`
     * 
     * This option causes `client_secret` to be ignored. Instead, the global `ZtrustSettings.oidc_private_key` is used to sign a JWT. The OpenID Connect provider will verify it using the key's self-signed cert.
     * @type {boolean}
     * @memberof GetOidcSettingsResponse
     */
    use_cert: boolean;
}
/**
 * Page and filter requests for pending exit nodes
 * @export
 * @interface GetPendingExitNodesRequest
 */
export interface GetPendingExitNodesRequest {
    /**
     * Filter after the dns name of a devices
     * @type {string}
     * @memberof GetPendingExitNodesRequest
     */
    filter_name?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetPendingExitNodesRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetPendingExitNodesRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetPendingRoutesRequest
 */
export interface GetPendingRoutesRequest {
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetPendingRoutesRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetPendingRoutesRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetPendingRoutesResponseItem
 */
export interface GetPendingRoutesResponseItem {
    /**
     * When was this route first advertised?
     * @type {string}
     * @memberof GetPendingRoutesResponseItem
     */
    created_at: string;
    /**
     * 
     * @type {FullSubnetRouter}
     * @memberof GetPendingRoutesResponseItem
     */
    device: FullSubnetRouter;
    /**
     * 
     * @type {GetPendingRoutesResponseItemSubnet}
     * @memberof GetPendingRoutesResponseItem
     */
    subnet: GetPendingRoutesResponseItemSubnet;
}
/**
 * @type GetPendingRoutesResponseItemSubnet
 * 
 * @export
 */
export type GetPendingRoutesResponseItemSubnet = GetPendingRoutesResponseItemSubnetOneOf | GetPendingRoutesResponseItemSubnetOneOf1;
/**
 * 
 * @export
 * @interface GetPendingRoutesResponseItemSubnetOneOf
 */
export interface GetPendingRoutesResponseItemSubnetOneOf {
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof GetPendingRoutesResponseItemSubnetOneOf
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetPendingRoutesResponseItemSubnetOneOf
     */
    type: GetPendingRoutesResponseItemSubnetOneOfTypeEnum;
}


/**
 * @export
 */
export const GetPendingRoutesResponseItemSubnetOneOfTypeEnum = {
    New: 'New'
} as const;
export type GetPendingRoutesResponseItemSubnetOneOfTypeEnum = typeof GetPendingRoutesResponseItemSubnetOneOfTypeEnum[keyof typeof GetPendingRoutesResponseItemSubnetOneOfTypeEnum];

/**
 * 
 * @export
 * @interface GetPendingRoutesResponseItemSubnetOneOf1
 */
export interface GetPendingRoutesResponseItemSubnetOneOf1 {
    /**
     * Description of the subnet
     * @type {string}
     * @memberof GetPendingRoutesResponseItemSubnetOneOf1
     */
    description: string;
    /**
     * Does this network have an associated device routing it?
     * @type {boolean}
     * @memberof GetPendingRoutesResponseItemSubnetOneOf1
     */
    has_router: boolean;
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof GetPendingRoutesResponseItemSubnetOneOf1
     */
    name: string;
    /**
     * 
     * @type {Array<FullSubnetRouter>}
     * @memberof GetPendingRoutesResponseItemSubnetOneOf1
     */
    routers: Array<FullSubnetRouter>;
    /**
     * 
     * @type {string}
     * @memberof GetPendingRoutesResponseItemSubnetOneOf1
     */
    type: GetPendingRoutesResponseItemSubnetOneOf1TypeEnum;
    /**
     * Primary key
     * @type {string}
     * @memberof GetPendingRoutesResponseItemSubnetOneOf1
     */
    uuid: string;
}


/**
 * @export
 */
export const GetPendingRoutesResponseItemSubnetOneOf1TypeEnum = {
    Existing: 'Existing'
} as const;
export type GetPendingRoutesResponseItemSubnetOneOf1TypeEnum = typeof GetPendingRoutesResponseItemSubnetOneOf1TypeEnum[keyof typeof GetPendingRoutesResponseItemSubnetOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface GetRulesetResponse
 */
export interface GetRulesetResponse {
    /**
     * A description
     * @type {string}
     * @memberof GetRulesetResponse
     */
    description: string;
    /**
     * 
     * @type {Array<GetRulesetResponseInstance>}
     * @memberof GetRulesetResponse
     */
    instances: Array<GetRulesetResponseInstance>;
    /**
     * A name
     * @type {string}
     * @memberof GetRulesetResponse
     */
    name: string;
    /**
     * A [`Plugin`]'s primary key
     * @type {string}
     * @memberof GetRulesetResponse
     */
    plugin_uuid?: string | null;
    /**
     * 
     * @type {Array<SimpleRulesetRule>}
     * @memberof GetRulesetResponse
     */
    rules: Array<SimpleRulesetRule>;
    /**
     * The primary key
     * @type {string}
     * @memberof GetRulesetResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetRulesetResponseInstance
 */
export interface GetRulesetResponseInstance {
    /**
     * 
     * @type {FullAccessRuleSrc}
     * @memberof GetRulesetResponseInstance
     */
    dst: FullAccessRuleSrc;
    /**
     * 
     * @type {FullAccessRuleSrc}
     * @memberof GetRulesetResponseInstance
     */
    src: FullAccessRuleSrc;
    /**
     * A [`RulesetInstanceUuid`]'s primary key
     * @type {string}
     * @memberof GetRulesetResponseInstance
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetRulesetsPageRequest
 */
export interface GetRulesetsPageRequest {
    /**
     * 
     * @type {string}
     * @memberof GetRulesetsPageRequest
     */
    filter_name?: string | null;
    /**
     * 
     * @type {GetRulesetsPageRequestFilterSource}
     * @memberof GetRulesetsPageRequest
     */
    filter_source?: GetRulesetsPageRequestFilterSource | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetRulesetsPageRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetRulesetsPageRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetRulesetsPageRequestFilterSource
 */
export interface GetRulesetsPageRequestFilterSource {
}

/**
 * 
 * @export
 */
export const GetRulesetsPageRequestFilterSourceUnspecific = {
    Local: 'Local',
    AnyPlugin: 'AnyPlugin'
} as const;
export type GetRulesetsPageRequestFilterSourceUnspecific = typeof GetRulesetsPageRequestFilterSourceUnspecific[keyof typeof GetRulesetsPageRequestFilterSourceUnspecific];

/**
 * 
 * @export
 * @interface GetRulesetsPageResponse
 */
export interface GetRulesetsPageResponse {
    /**
     * A description
     * @type {string}
     * @memberof GetRulesetsPageResponse
     */
    description: string;
    /**
     * A name
     * @type {string}
     * @memberof GetRulesetsPageResponse
     */
    name: string;
    /**
     * 
     * @type {GetRulesetsPageResponsePlugin}
     * @memberof GetRulesetsPageResponse
     */
    plugin?: GetRulesetsPageResponsePlugin | null;
    /**
     * A [`Plugin`]'s primary key
     * @type {string}
     * @memberof GetRulesetsPageResponse
     */
    plugin_uuid?: string | null;
    /**
     * 
     * @type {Array<SimpleRulesetRule>}
     * @memberof GetRulesetsPageResponse
     */
    rules: Array<SimpleRulesetRule>;
    /**
     * The primary key
     * @type {string}
     * @memberof GetRulesetsPageResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetRulesetsPageResponsePlugin
 */
export interface GetRulesetsPageResponsePlugin {
    /**
     * A description of the plugin
     * @type {string}
     * @memberof GetRulesetsPageResponsePlugin
     */
    description: string;
    /**
     * Base64 encoded thumbnail
     * @type {string}
     * @memberof GetRulesetsPageResponsePlugin
     */
    image: string;
    /**
     * A unique display name
     * @type {string}
     * @memberof GetRulesetsPageResponsePlugin
     */
    name: string;
    /**
     * Does the installed version differ from the store's current version?
     * @type {boolean}
     * @memberof GetRulesetsPageResponsePlugin
     */
    outdated: boolean;
    /**
     * Primary key
     * @type {string}
     * @memberof GetRulesetsPageResponsePlugin
     */
    uuid: string;
    /**
     * 
     * @type {string}
     * @memberof GetRulesetsPageResponsePlugin
     */
    version: string;
}
/**
 * 
 * @export
 * @interface GetScimSettingsResponse
 */
export interface GetScimSettingsResponse {
    /**
     * Is the scim API enabled?
     * @type {boolean}
     * @memberof GetScimSettingsResponse
     */
    enabled: boolean;
    /**
     * Enables the workaround required for Microsoft Entra
     * @type {boolean}
     * @memberof GetScimSettingsResponse
     */
    entra_workaround: boolean;
    /**
     * Bearer token required by all scim endpoints
     * @type {string}
     * @memberof GetScimSettingsResponse
     */
    token: string;
}
/**
 * 
 * @export
 * @interface GetSingleDeviceGroupResponse
 */
export interface GetSingleDeviceGroupResponse {
    /**
     * 
     * @type {GetAllAccessRulesForResponse}
     * @memberof GetSingleDeviceGroupResponse
     */
    access_rules: GetAllAccessRulesForResponse;
    /**
     * The description for the device group
     * @type {string}
     * @memberof GetSingleDeviceGroupResponse
     */
    description: string;
    /**
     * 
     * @type {Array<FullDevice>}
     * @memberof GetSingleDeviceGroupResponse
     */
    devices: Array<FullDevice>;
    /**
     * The device group's name
     * @type {string}
     * @memberof GetSingleDeviceGroupResponse
     */
    name: string;
    /**
     * 
     * @type {GetACLRuleSetResponse}
     * @memberof GetSingleDeviceGroupResponse
     */
    rulesets: GetACLRuleSetResponse;
    /**
     * Primary key
     * @type {string}
     * @memberof GetSingleDeviceGroupResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetSingleDeviceResponse
 */
export interface GetSingleDeviceResponse {
    /**
     * When was the device created?
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    created_at: string;
    /**
     * The device's device groups **if** the device is a user device
     * @type {Array<SimpleDeviceGroup>}
     * @memberof GetSingleDeviceResponse
     */
    device_groups?: Array<SimpleDeviceGroup> | null;
    /**
     * Name this device is named in the dns
     * 
     * This value is inferred from `hostname` but can be overwritten by an admin.
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    dnsname: string;
    /**
     * Has the device' session expired?
     * @type {boolean}
     * @memberof GetSingleDeviceResponse
     */
    expired: boolean;
    /**
     * When will the device's current session expire?
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    expiry?: string | null;
    /**
     * The extra records for this device
     * @type {Array<SimpleExtraDnsDomain>}
     * @memberof GetSingleDeviceResponse
     */
    extra_records: Array<SimpleExtraDnsDomain>;
    /**
     * Hostname set by the tailscale client
     * 
     * This value is not used for the DNS.
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    hostname: string;
    /**
     * 
     * @type {FullDeviceRulesByAssociation}
     * @memberof GetSingleDeviceResponse
     */
    inbound_rules: FullDeviceRulesByAssociation;
    /**
     * 
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    ipv4?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    ipv6?: string | null;
    /**
     * When was the time the device was online?
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    last_seen?: string | null;
    /**
     * Is the device currently online?
     * @type {boolean}
     * @memberof GetSingleDeviceResponse
     */
    online: boolean;
    /**
     * 
     * @type {FullDeviceRulesByAssociation}
     * @memberof GetSingleDeviceResponse
     */
    outbound_rules: FullDeviceRulesByAssociation;
    /**
     * 
     * @type {Array<SimpleSubnet>}
     * @memberof GetSingleDeviceResponse
     */
    subnets: Array<SimpleSubnet>;
    /**
     * The device's tags **if** the device is a server device
     * @type {Array<SimpleTag>}
     * @memberof GetSingleDeviceResponse
     */
    tags?: Array<SimpleTag> | null;
    /**
     * The tenant the device belongs to
     * @type {SimpleTenant}
     * @memberof GetSingleDeviceResponse
     */
    tenant: SimpleTenant;
    /**
     * The device's user **if** the device is a user device
     * @type {SimpleUser}
     * @memberof GetSingleDeviceResponse
     */
    user?: SimpleUser | null;
    /**
     * The primary key
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetSingleGroupMembersRequest
 */
export interface GetSingleGroupMembersRequest {
    /**
     * 
     * @type {string}
     * @memberof GetSingleGroupMembersRequest
     */
    filter_name?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetSingleGroupMembersRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetSingleGroupMembersRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetSingleGroupResponse
 */
export interface GetSingleGroupResponse {
    /**
     * 
     * @type {GetAllAccessRulesForResponse}
     * @memberof GetSingleGroupResponse
     */
    access_rules: GetAllAccessRulesForResponse;
    /**
     * 
     * @type {string}
     * @memberof GetSingleGroupResponse
     */
    description: string;
    /**
     * The group's identifier in the synced source of truth
     * 
     * I.e. DN for LDAP syncs
     * @type {string}
     * @memberof GetSingleGroupResponse
     */
    external_id: string;
    /**
     * Allows this group to have access to `autogroup:internet`
     * @type {boolean}
     * @memberof GetSingleGroupResponse
     */
    internet: boolean;
    /**
     * The group's name (**without** the "group:" prefix)
     * @type {string}
     * @memberof GetSingleGroupResponse
     */
    name: string;
    /**
     * 
     * @type {GroupProvider}
     * @memberof GetSingleGroupResponse
     */
    provider: GroupProvider;
    /**
     * 
     * @type {GetACLRuleSetResponse}
     * @memberof GetSingleGroupResponse
     */
    rulesets: GetACLRuleSetResponse;
    /**
     * 
     * @type {SimpleTenant}
     * @memberof GetSingleGroupResponse
     */
    tenant?: SimpleTenant | null;
    /**
     * The group's uuid
     * @type {string}
     * @memberof GetSingleGroupResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetSinglePluginResponse
 */
export interface GetSinglePluginResponse {
    /**
     * A description of the plugin
     * @type {string}
     * @memberof GetSinglePluginResponse
     */
    description: string;
    /**
     * Base64 encoded thumbnail
     * @type {string}
     * @memberof GetSinglePluginResponse
     */
    image: string;
    /**
     * Has the plugin been installed?
     * @type {boolean}
     * @memberof GetSinglePluginResponse
     */
    installed: boolean;
    /**
     * A unique display name
     * @type {string}
     * @memberof GetSinglePluginResponse
     */
    name: string;
    /**
     * Does the installed version differ from the store's current version?
     * @type {boolean}
     * @memberof GetSinglePluginResponse
     */
    outdated: boolean;
    /**
     * The plugin's rulesets
     * 
     * This list is always empty for non-installed plugins
     * @type {Array<FullRuleset>}
     * @memberof GetSinglePluginResponse
     */
    rulesets: Array<FullRuleset>;
    /**
     * The ztna store's schema for this plugin
     * 
     * The returned value is only the version agnostic summary. The store has a different schema type for a plugin's specific version.
     * @type {SimplePluginSchema}
     * @memberof GetSinglePluginResponse
     */
    store?: SimplePluginSchema | null;
    /**
     * The ztna store's schema for this plugin `version`
     * @type {FullPluginSchema}
     * @memberof GetSinglePluginResponse
     */
    store_version?: FullPluginSchema | null;
    /**
     * Primary key
     * @type {string}
     * @memberof GetSinglePluginResponse
     */
    uuid: string;
    /**
     * 
     * @type {string}
     * @memberof GetSinglePluginResponse
     */
    version: string;
}
/**
 * 
 * @export
 * @interface GetSingleSubnetResponse
 */
export interface GetSingleSubnetResponse {
    /**
     * 
     * @type {GetAllAccessRulesForResponse}
     * @memberof GetSingleSubnetResponse
     */
    access_rules: GetAllAccessRulesForResponse;
    /**
     * Description of the subnet
     * @type {string}
     * @memberof GetSingleSubnetResponse
     */
    description: string;
    /**
     * Does this network have an associated device routing it?
     * @type {boolean}
     * @memberof GetSingleSubnetResponse
     */
    has_router: boolean;
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof GetSingleSubnetResponse
     */
    name: string;
    /**
     * List of all devices that could be route this subnet.
     * @type {Array<FullPossibleSubnetRouter>}
     * @memberof GetSingleSubnetResponse
     */
    possible_routers: Array<FullPossibleSubnetRouter>;
    /**
     * The devices currently routing this network
     * @type {Array<FullSubnetRouter>}
     * @memberof GetSingleSubnetResponse
     */
    routers: Array<FullSubnetRouter>;
    /**
     * 
     * @type {GetACLRuleSetResponse}
     * @memberof GetSingleSubnetResponse
     */
    rulesets: GetACLRuleSetResponse;
    /**
     * Primary key
     * @type {string}
     * @memberof GetSingleSubnetResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetSingleTagResponse
 */
export interface GetSingleTagResponse {
    /**
     * 
     * @type {GetAllAccessRulesForResponse}
     * @memberof GetSingleTagResponse
     */
    access_rules: GetAllAccessRulesForResponse;
    /**
     * 
     * @type {string}
     * @memberof GetSingleTagResponse
     */
    description: string;
    /**
     * 
     * @type {Array<FullDevice>}
     * @memberof GetSingleTagResponse
     */
    devices: Array<FullDevice>;
    /**
     * The directory this tag belongs to
     * @type {string}
     * @memberof GetSingleTagResponse
     */
    directory?: string | null;
    /**
     * A locked tag's access rules can't be edited
     * @type {boolean}
     * @memberof GetSingleTagResponse
     */
    locked: boolean;
    /**
     * The tag's name (**without** the "tag:" prefix)
     * @type {string}
     * @memberof GetSingleTagResponse
     */
    name: string;
    /**
     * 
     * @type {GetACLRuleSetResponse}
     * @memberof GetSingleTagResponse
     */
    rulesets: GetACLRuleSetResponse;
    /**
     * Primary key
     * @type {string}
     * @memberof GetSingleTagResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetSingleUserResponse
 */
export interface GetSingleUserResponse {
    /**
     * Authentication method used by the user
     * @type {UserSource}
     * @memberof GetSingleUserResponse
     */
    auth: UserSource;
    /**
     * 
     * @type {GetSingleUserResponseAuthSpecific}
     * @memberof GetSingleUserResponse
     */
    auth_specific: GetSingleUserResponseAuthSpecific;
    /**
     * When the user was created
     * @type {string}
     * @memberof GetSingleUserResponse
     */
    created_at: string;
    /**
     * A name for humans to identify the user by
     * @type {string}
     * @memberof GetSingleUserResponse
     */
    display_name: string;
    /**
     * The groups which the user is assigned to
     * @type {Array<SimpleGroup>}
     * @memberof GetSingleUserResponse
     */
    groups: Array<SimpleGroup>;
    /**
     * The tenant the user belongs to
     * @type {SimpleTenant}
     * @memberof GetSingleUserResponse
     */
    tenant: SimpleTenant;
    /**
     * The user's uuid
     * @type {string}
     * @memberof GetSingleUserResponse
     */
    uuid: string;
}
/**
 * @type GetSingleUserResponseAuthSpecific
 * Auth state specific details in `GetSingleUserResponse`
 * @export
 */
export type GetSingleUserResponseAuthSpecific = GetSingleUserResponseAuthSpecificOneOf | GetSingleUserResponseAuthSpecificOneOf1 | GetSingleUserResponseAuthSpecificOneOf2;
/**
 * 
 * @export
 * @interface GetSingleUserResponseAuthSpecificOneOf
 */
export interface GetSingleUserResponseAuthSpecificOneOf {
    /**
     * 
     * @type {string}
     * @memberof GetSingleUserResponseAuthSpecificOneOf
     */
    type: GetSingleUserResponseAuthSpecificOneOfTypeEnum;
}


/**
 * @export
 */
export const GetSingleUserResponseAuthSpecificOneOfTypeEnum = {
    Remote: 'Remote'
} as const;
export type GetSingleUserResponseAuthSpecificOneOfTypeEnum = typeof GetSingleUserResponseAuthSpecificOneOfTypeEnum[keyof typeof GetSingleUserResponseAuthSpecificOneOfTypeEnum];

/**
 * 
 * @export
 * @interface GetSingleUserResponseAuthSpecificOneOf1
 */
export interface GetSingleUserResponseAuthSpecificOneOf1 {
    /**
     * When will the user's access to the vpn expire?
     * @type {string}
     * @memberof GetSingleUserResponseAuthSpecificOneOf1
     */
    access_expires_at?: string | null;
    /**
     * When did the user's most recent access to the vpn begin?
     * @type {string}
     * @memberof GetSingleUserResponseAuthSpecificOneOf1
     */
    access_start?: string | null;
    /**
     * The current invitation link
     * @type {SimpleInvitationLink}
     * @memberof GetSingleUserResponseAuthSpecificOneOf1
     */
    current_link?: SimpleInvitationLink | null;
    /**
     * Is the user's access to the vpn planned?
     * @type {boolean}
     * @memberof GetSingleUserResponseAuthSpecificOneOf1
     */
    is_access_planned: boolean;
    /**
     * List of previous (already expired) links
     * @type {Array<SimpleInvitationLink>}
     * @memberof GetSingleUserResponseAuthSpecificOneOf1
     */
    prev_links: Array<SimpleInvitationLink>;
    /**
     * 
     * @type {string}
     * @memberof GetSingleUserResponseAuthSpecificOneOf1
     */
    type: GetSingleUserResponseAuthSpecificOneOf1TypeEnum;
}


/**
 * @export
 */
export const GetSingleUserResponseAuthSpecificOneOf1TypeEnum = {
    Invited: 'Invited'
} as const;
export type GetSingleUserResponseAuthSpecificOneOf1TypeEnum = typeof GetSingleUserResponseAuthSpecificOneOf1TypeEnum[keyof typeof GetSingleUserResponseAuthSpecificOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface GetSingleUserResponseAuthSpecificOneOf2
 */
export interface GetSingleUserResponseAuthSpecificOneOf2 {
    /**
     * When will the user's access to the vpn expire?
     * @type {string}
     * @memberof GetSingleUserResponseAuthSpecificOneOf2
     */
    access_expires_at?: string | null;
    /**
     * When did the user's most recent access to the vpn begin?
     * @type {string}
     * @memberof GetSingleUserResponseAuthSpecificOneOf2
     */
    access_start: string;
    /**
     * Has the user's access to the vpn?
     * @type {boolean}
     * @memberof GetSingleUserResponseAuthSpecificOneOf2
     */
    has_access: boolean;
    /**
     * Is the user's access to the vpn planned?
     * @type {boolean}
     * @memberof GetSingleUserResponseAuthSpecificOneOf2
     */
    is_access_planned: boolean;
    /**
     * History of all previous access periods
     * @type {Array<LocalUserAccessHistory>}
     * @memberof GetSingleUserResponseAuthSpecificOneOf2
     */
    prev_accesses: Array<LocalUserAccessHistory>;
    /**
     * 
     * @type {string}
     * @memberof GetSingleUserResponseAuthSpecificOneOf2
     */
    type: GetSingleUserResponseAuthSpecificOneOf2TypeEnum;
}


/**
 * @export
 */
export const GetSingleUserResponseAuthSpecificOneOf2TypeEnum = {
    Local: 'Local'
} as const;
export type GetSingleUserResponseAuthSpecificOneOf2TypeEnum = typeof GetSingleUserResponseAuthSpecificOneOf2TypeEnum[keyof typeof GetSingleUserResponseAuthSpecificOneOf2TypeEnum];

/**
 * Response for the get_tenant_search_domains endpoint
 * @export
 * @interface GetTenantSearchDomainsResponse
 */
export interface GetTenantSearchDomainsResponse {
    /**
     * The list of tenant specific search domains
     * @type {Array<SimpleDnsSearchDomain>}
     * @memberof GetTenantSearchDomainsResponse
     */
    domains: Array<SimpleDnsSearchDomain>;
    /**
     * The list of global search domains
     * @type {Array<SimpleDnsSearchDomain>}
     * @memberof GetTenantSearchDomainsResponse
     */
    global_domains: Array<SimpleDnsSearchDomain>;
}
/**
 * 
 * @export
 * @interface GetTenantSplitDomainsResponseItem
 */
export interface GetTenantSplitDomainsResponseItem {
    /**
     * The domain name
     * @type {string}
     * @memberof GetTenantSplitDomainsResponseItem
     */
    domain: string;
    /**
     * Primary key
     * @type {string}
     * @memberof GetTenantSplitDomainsResponseItem
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetUserNotInGroupRequest
 */
export interface GetUserNotInGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof GetUserNotInGroupRequest
     */
    filter_name?: string | null;
}

/**
 * 
 * @export
 */
export const GlobalDnsType = {
    Google: 'Google',
    Cloudflare: 'Cloudflare',
    Quad9: 'Quad9',
    Custom: 'Custom'
} as const;
export type GlobalDnsType = typeof GlobalDnsType[keyof typeof GlobalDnsType];


/**
 * 
 * @export
 */
export const GroupProvider = {
    Ldap: 'Ldap',
    Local: 'Local',
    Scim: 'Scim'
} as const;
export type GroupProvider = typeof GroupProvider[keyof typeof GroupProvider];

/**
 * `Hostinfo` contains a summary of a Tailscale host.
 * 
 * Because it contains pointers (slices), this type should not be used as a value type.
 * @export
 * @interface Hostinfo
 */
export interface Hostinfo {
    /**
     * 
     * @type {boolean}
     * @memberof Hostinfo
     */
    AllowsUpdate?: boolean;
    /**
     * App is used to disambiguate Tailscale clients that run using tsnet.
     * @type {string}
     * @memberof Hostinfo
     */
    App?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Hostinfo
     */
    AppConnector?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    BackendLogID?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    Cloud?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Hostinfo
     */
    Container?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Hostinfo
     */
    Desktop?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    DeviceModel?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    Distro?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    DistroCodeName?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    DistroVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    Env?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    FrontendLogID?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    GoArch?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    GoArchVar?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    GoVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    Hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    IPNVersion?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Hostinfo
     */
    IngressEnabled?: boolean;
    /**
     * `location` represents geographical location data about a Tailscale host. `location` is optional and only set if explicitly declared by a node.
     * @type {Location}
     * @memberof Hostinfo
     */
    Location?: Location | null;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    Machine?: string;
    /**
     * 
     * @type {NetInfo}
     * @memberof Hostinfo
     */
    NetInfo?: NetInfo | null;
    /**
     * 
     * @type {boolean}
     * @memberof Hostinfo
     */
    NoLogsNoSupport?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    OS?: string;
    /**
     * OSVersion is the version of the OS, if available.
     * 
     * For Android, it's like "10", "11", "12", etc. For iOS and macOS it's like "15.6.1" or "12.4.0". For Windows it's like "10.0.19044.1889". For FreeBSD it's like "12.3-STABLE".
     * 
     * For Linux, prior to Tailscale 1.32, we jammed a bunch of fields into this string on Linux, like "Debian 10.4; kernel=xxx; container; env=kn" and so on. As of Tailscale 1.32, this is simply the kernel version on Linux, like "5.10.0-17-amd64".
     * @type {string}
     * @memberof Hostinfo
     */
    OSVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    Package?: string;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    PushDeviceToken?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Hostinfo
     */
    RequestTags?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Hostinfo
     */
    RoutableIPs?: Array<string> | null;
    /**
     * 
     * @type {Array<Service>}
     * @memberof Hostinfo
     */
    Services?: Array<Service> | null;
    /**
     * 
     * @type {string}
     * @memberof Hostinfo
     */
    ServicesHash?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Hostinfo
     */
    ShareeNode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hostinfo
     */
    ShieldsUp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hostinfo
     */
    Userspace?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Hostinfo
     */
    UserspaceRouter?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Hostinfo
     */
    WireIngress?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Hostinfo
     */
    WoLMACs?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Hostinfo
     */
    sshHostKeys?: Array<string> | null;
}
/**
 * Error response for adding a DNS search domain
 * @export
 * @interface InsertDnsSearchDomainError
 */
export interface InsertDnsSearchDomainError {
    /**
     * The domain already exists
     * @type {boolean}
     * @memberof InsertDnsSearchDomainError
     */
    domain_already_exists: boolean;
}
/**
 * 
 * @export
 * @interface InsertDnsSearchDomainRequest
 */
export interface InsertDnsSearchDomainRequest {
    /**
     * The domain to use as search domain
     * 
     * It must be a FQDN without a trailing dot.
     * @type {string}
     * @memberof InsertDnsSearchDomainRequest
     */
    domain: string;
}
/**
 * Errors for the add_tenant_search_domain endpoint
 * @export
 * @interface InsertTenantSearchDomainErrors
 */
export interface InsertTenantSearchDomainErrors {
    /**
     * The domain already exists
     * @type {boolean}
     * @memberof InsertTenantSearchDomainErrors
     */
    domain_already_exists: boolean;
}
/**
 * 
 * @export
 * @interface InsertTenantSearchDomainRequest
 */
export interface InsertTenantSearchDomainRequest {
    /**
     * The domain to use as search domain
     * 
     * It must be a FQDN without a trailing dot.
     * @type {string}
     * @memberof InsertTenantSearchDomainRequest
     */
    domain: string;
}
/**
 * 
 * @export
 * @interface InviteUserErrors
 */
export interface InviteUserErrors {
    /**
     * The user (identified by his mail) has already been invited
     * @type {boolean}
     * @memberof InviteUserErrors
     */
    has_invited: boolean;
    /**
     * The user (identified by his mail) has already accepted an invitation
     * @type {boolean}
     * @memberof InviteUserErrors
     */
    has_local: boolean;
    /**
     * The user (identified by his mail) already uses oidc
     * @type {boolean}
     * @memberof InviteUserErrors
     */
    has_oidc: boolean;
    /**
     * The start timestamp is after the end timestamp
     * @type {boolean}
     * @memberof InviteUserErrors
     */
    start_after_until: boolean;
}
/**
 * 
 * @export
 * @interface InviteUserRequest
 */
export interface InviteUserRequest {
    /**
     * Start of the user's access period
     * @type {string}
     * @memberof InviteUserRequest
     */
    access_start?: string | null;
    /**
     * Until when is the user allowed to log in?
     * @type {string}
     * @memberof InviteUserRequest
     */
    cant_login_after?: string | null;
    /**
     * A display name to use for the admin site and the ztn.
     * @type {string}
     * @memberof InviteUserRequest
     */
    display_name: string;
    /**
     * Number of days the link is valid for
     * @type {number}
     * @memberof InviteUserRequest
     */
    link_valid_until: number;
    /**
     * The `mail` to set for the new user
     * 
     * This will also be his login identifier.
     * @type {string}
     * @memberof InviteUserRequest
     */
    mail: string;
    /**
     * A [`Tenant`]'s uuid
     * @type {string}
     * @memberof InviteUserRequest
     */
    tenant_uuid: string;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForFullAccessRule
 */
export interface ListForFullAccessRule {
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof ListForFullAccessRule
     */
    list: Array<FullAccessRule>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForFullExtraDnsDomain
 */
export interface ListForFullExtraDnsDomain {
    /**
     * 
     * @type {Array<FullExtraDnsDomain>}
     * @memberof ListForFullExtraDnsDomain
     */
    list: Array<FullExtraDnsDomain>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForFullHeadscalePreAuthKey
 */
export interface ListForFullHeadscalePreAuthKey {
    /**
     * 
     * @type {Array<FullHeadscalePreAuthKey>}
     * @memberof ListForFullHeadscalePreAuthKey
     */
    list: Array<FullHeadscalePreAuthKey>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForFullSplitDnsDomain
 */
export interface ListForFullSplitDnsDomain {
    /**
     * 
     * @type {Array<FullSplitDnsDomain>}
     * @memberof ListForFullSplitDnsDomain
     */
    list: Array<FullSplitDnsDomain>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForGetAllUsersResponse
 */
export interface ListForGetAllUsersResponse {
    /**
     * 
     * @type {Array<GetAllUsersResponse>}
     * @memberof ListForGetAllUsersResponse
     */
    list: Array<GetAllUsersResponse>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForGetTenantSplitDomainsResponseItem
 */
export interface ListForGetTenantSplitDomainsResponseItem {
    /**
     * 
     * @type {Array<GetTenantSplitDomainsResponseItem>}
     * @memberof ListForGetTenantSplitDomainsResponseItem
     */
    list: Array<GetTenantSplitDomainsResponseItem>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForSimpleAccount
 */
export interface ListForSimpleAccount {
    /**
     * 
     * @type {Array<SimpleAccount>}
     * @memberof ListForSimpleAccount
     */
    list: Array<SimpleAccount>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForSimpleChangelogEntry
 */
export interface ListForSimpleChangelogEntry {
    /**
     * 
     * @type {Array<SimpleChangelogEntry>}
     * @memberof ListForSimpleChangelogEntry
     */
    list: Array<SimpleChangelogEntry>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForSimpleDnsSearchDomain
 */
export interface ListForSimpleDnsSearchDomain {
    /**
     * 
     * @type {Array<SimpleDnsSearchDomain>}
     * @memberof ListForSimpleDnsSearchDomain
     */
    list: Array<SimpleDnsSearchDomain>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForSimpleExtraDnsDomain
 */
export interface ListForSimpleExtraDnsDomain {
    /**
     * 
     * @type {Array<SimpleExtraDnsDomain>}
     * @memberof ListForSimpleExtraDnsDomain
     */
    list: Array<SimpleExtraDnsDomain>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForSimpleOidcProvider
 */
export interface ListForSimpleOidcProvider {
    /**
     * 
     * @type {Array<SimpleOidcProvider>}
     * @memberof ListForSimpleOidcProvider
     */
    list: Array<SimpleOidcProvider>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForSimpleTagDirectory
 */
export interface ListForSimpleTagDirectory {
    /**
     * 
     * @type {Array<SimpleTagDirectory>}
     * @memberof ListForSimpleTagDirectory
     */
    list: Array<SimpleTagDirectory>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForSimpleTenant
 */
export interface ListForSimpleTenant {
    /**
     * 
     * @type {Array<SimpleTenant>}
     * @memberof ListForSimpleTenant
     */
    list: Array<SimpleTenant>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForSimpleUser
 */
export interface ListForSimpleUser {
    /**
     * 
     * @type {Array<SimpleUser>}
     * @memberof ListForSimpleUser
     */
    list: Array<SimpleUser>;
}

/**
 * Requirements a local user's authentication method must fulfill
 * @export
 */
export const LocalAuthRequirements = {
    None: 'None',
    MultiFactor: 'MultiFactor',
    Passwordless: 'Passwordless'
} as const;
export type LocalAuthRequirements = typeof LocalAuthRequirements[keyof typeof LocalAuthRequirements];

/**
 * 
 * @export
 * @interface LocalUserAccessHistory
 */
export interface LocalUserAccessHistory {
    /**
     * Start of the user's access period
     * @type {string}
     * @memberof LocalUserAccessHistory
     */
    end: string;
    /**
     * Start of the user's access period
     * @type {string}
     * @memberof LocalUserAccessHistory
     */
    start: string;
}
/**
 * `Location` represents geographical location data about a Tailscale host. `Location` is optional and only set if explicitly declared by a node.
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    City?: string;
    /**
     * `city_code` is a short code representing the city in upper case. `city_code` is used to disambiguate a city from another location with the same city name. It uniquely identifies a particular geographical location, within the tailnet. IATA, ICAO or ISO 3166-2 codes are recommended ("YSE")
     * @type {string}
     * @memberof Location
     */
    CityCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    Country?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    CountryCode?: string;
    /**
     * `latitude`, `longitude` are optional geographical coordinates of the node, in degrees. No particular accuracy level is promised; the coordinates may simply be the center of the city or country.
     * @type {number}
     * @memberof Location
     */
    Latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    Longitude?: number;
    /**
     * `priority` determines the order of use of an exit node when a location based preference matches more than one exit node, the node with the highest priority wins. Nodes of equal probability may be selected arbitrarily.
     * 
     * A value of 0 means the exit node does not have a priority preference. A negative int is not allowed.
     * @type {number}
     * @memberof Location
     */
    Priority?: number;
}
/**
 * `MapResponse` is the response to a MapRequest. It describes the state of the local node, the peer nodes, the DNS configuration, the packet filter, and more. A MapRequest, depending on its parameters, may result in the control plane coordination server sending 0, 1 or a stream of multiple `MapResponse` values.
 * 
 * When the client sets MapRequest.Stream, the server sends a stream of `MapResponse`s. That long-lived HTTP transaction is called a "map poll". In a map poll, the first `MapResponse` will be complete and subsequent `MapResponse`s will be incremental updates with only changed information.
 * 
 * The zero value for all fields means "unchanged". Unfortunately, several fields were defined before that convention was established, so they use a slice with omitempty, meaning this type can't be used to marshal JSON containing non-nil zero-length slices (meaning explicitly now empty). The control plane uses a separate type to marshal these fields. This type is primarily used for unmarshaling responses so the omitempty annotations are mostly useless, except that this type is also used for the integration test's fake control server. (It's not necessary to marshal a non-nil zero-length slice for the things we've needed to test in the integration tests as of 2023-09-09).
 * @export
 * @interface MapResponse
 */
export interface MapResponse {
    /**
     * `client_version` describes the latest client version that's available for download and whether the client is using it. A nil value means no change or nothing to report.
     * @type {ClientVersion}
     * @memberof MapResponse
     */
    ClientVersion?: ClientVersion | null;
    /**
     * `collect_services` reports whether this node's Tailnet has requested that info about services be included in `HostInfo`. If unset, the most recent non-empty `MapResponse` value in the HTTP response stream is used.
     * @type {boolean}
     * @memberof MapResponse
     */
    CollectServices?: boolean | null;
    /**
     * `control_dial_plan` tells the client how to connect to the control server. An initial nil is equivalent to new(ControlDialPlan). A subsequent streamed nil means no change.
     * @type {ControlDialPlan}
     * @memberof MapResponse
     */
    ControlDialPlan?: ControlDialPlan | null;
    /**
     * `control_time`, if non-zero, is the current timestamp according to the control server.
     * @type {any}
     * @memberof MapResponse
     */
    ControlTime?: any | null;
    /**
     * `derp_map` describe the set of DERP servers available. A nil value means unchanged.
     * @type {DERPMap}
     * @memberof MapResponse
     */
    DERPMap?: DERPMap | null;
    /**
     * `dns_config` contains the DNS settings for the client to use. A nil value means no change from an earlier non-nil value.
     * @type {DNSConfig}
     * @memberof MapResponse
     */
    DNSConfig?: DNSConfig | null;
    /**
     * `debug` is normally nil, except for when the control server is setting debug settings on a node.
     * @type {Debug}
     * @memberof MapResponse
     */
    Debug?: Debug | null;
    /**
     * `default_auto_update` is the default node auto-update setting for this tailnet. The node is free to opt-in or out locally regardless of this value. This value is only used on first MapResponse from control, the auto-update setting doesn't change if the tailnet admin flips the default after the node registered.
     * @type {boolean}
     * @memberof MapResponse
     */
    DefaultAutoUpdate?: boolean | null;
    /**
     * `domain` is the name of the network that this node is in. It's either of the form "example.com" (for user foo@example.com, for multi-user networks) or "foo@gmail.com" (for siloed users on shared email providers). Its exact form should not be depended on; new forms are coming later. If empty, the value is unchanged.
     * @type {string}
     * @memberof MapResponse
     */
    Domain?: string;
    /**
     * `domain_data_plane_audit_log_id`, if non-empty, is the per-tailnet log ID to be used when writing data plane audit logs.
     * @type {string}
     * @memberof MapResponse
     */
    DomainDataPlaneAuditLogID?: string;
    /**
     * `health`, if non-nil, sets the health state of the node from the control plane's perspective. A nil value means no change from the previous MapResponse. A non-nil 0-length slice restores the health to good (no known problems). A non-zero length slice are the list of problems that the control place sees.
     * 
     * Note that this package's type, due its use of a slice and omitempty, is unable to marshal a zero-length non-nil slice. The control server needs to marshal this type using a separate type. See MapResponse docs.
     * @type {Array<string>}
     * @memberof MapResponse
     */
    Health?: Array<string> | null;
    /**
     * `keep_alive`, if set, represents an empty message just to keep the connection alive. When true, all other fields except `ping_request`, `control_time`, and `pop_browser_url` are ignored.
     * @type {boolean}
     * @memberof MapResponse
     */
    KeepAlive?: boolean;
    /**
     * `map_session_handle` optionally specifies a unique opaque handle for this stateful MapResponse session. Servers may choose not to send it, and it's only sent on the first MapResponse in a stream. The client can determine whether it's reattaching to a prior stream by seeing whether this value matches the requested `MapRequest.map_session_handle`.
     * @type {string}
     * @memberof MapResponse
     */
    MapSessionHandle?: string;
    /**
     * `MaxKeyDuration` describes the MaxKeyDuration setting for the tailnet. If zero, the value is unchanged.
     * @type {number}
     * @memberof MapResponse
     */
    MaxKeyDuration?: number;
    /**
     * `node` describes the node making the map request. Starting with `MapRequest.version` 18, nil means unchanged.
     * @type {Node}
     * @memberof MapResponse
     */
    Node?: Node | null;
    /**
     * `online_change` changes the value of a Peer `Node.online` value.
     * @type {{ [key: string]: boolean | undefined; }}
     * @memberof MapResponse
     */
    OnlineChange?: { [key: string]: boolean | undefined; };
    /**
     * `packet_filter` are the firewall rules.
     * 
     * For `MapRequest.version >= 6`, a nil value means the most previously streamed non-nil `MapResponse.packet_filter` within the same HTTP response. A non-nil but empty list always means no PacketFilter (that is, to block everything).
     * 
     * Note that this package's type, due its use of a slice and omitempty, is unable to marshal a zero-length non-nil slice. The control server needs to marshal this type using a separate type. See `MapResponse` docs.
     * 
     * See `packet_filters` for the newer way to send `packet_filter` updates.
     * @type {Array<FilterRule>}
     * @memberof MapResponse
     */
    PacketFilter?: Array<FilterRule> | null;
    /**
     * `packet_filters` encodes incremental packet filter updates to the client without having to send the entire packet filter on any changes as required by the older `packet_filter` (singular) field above. The map keys are server-assigned arbitrary strings. The map values are the new rules for that key, or nil to delete it. The client then concatenates all the rules together to generate the final packet filter. Because the FilterRules can only match or not match, the ordering of filter rules doesn't matter. (That said, the client generates the file merged packet filter rules by concananting all the packet filter rules sorted by the map key name. But it does so for stability and testability, not correctness. If something needs to rely on that property, something has gone wrong.)
     * 
     * If the server sends a non-nil `packet_filter` (above), that is equivalent to a named packet filter with the key "base". It is valid for the server to send both `packet_filter` and `packet_filters` in the same `MapResponse` or alternate between them within a session. The `packet_filter` is applied first (if set) and then the `packet_filters`.
     * 
     * As a special case, the map key "*" with a value of nil means to clear all prior named packet filters (including any implicit "base") before processing the other map entries.
     * @type {{ [key: string]: Array<FilterRule> | undefined | null; }}
     * @memberof MapResponse
     */
    PacketFilters?: { [key: string]: Array<FilterRule> | undefined | null; };
    /**
     * `peer_seen_change` contains information on how to update peers' `last_seen` times. If the value is false, the peer is gone. If the value is true, the `last_seen` time is now. Absent means unchanged.
     * @type {{ [key: string]: boolean | undefined; }}
     * @memberof MapResponse
     */
    PeerSeenChange?: { [key: string]: boolean | undefined; };
    /**
     * `peers`, if non-empty, is the complete list of peers. It will be set in the first `MapResponse` for a long-polled request/response. Subsequent responses will be delta-encoded if `MapRequest.version >= 5` and server chooses, in which case `peers` will be nil or zero length. If `peers` is non-empty, `peers_changed` and `peers_removed` should be ignored (and should be empty). `peers` is always returned sorted by Node.ID.
     * @type {Array<Node>}
     * @memberof MapResponse
     */
    Peers?: Array<Node> | null;
    /**
     * `peers_changed` are the Nodes (identified by their ID) that have changed or been added since the past update on the HTTP response. It's not used by the server if `MapRequest.version` < 5. `peers_changed` is always returned sorted by `Node.id`.
     * @type {Array<Node>}
     * @memberof MapResponse
     */
    PeersChanged?: Array<Node> | null;
    /**
     * `peers_changed_patch`, if non-nil, means that node(s) have changed. This is a lighter version of the older `peers_changed` support that only supports certain types of updates.
     * 
     * These are applied after `peers*` above, but in practice the control server should only send these on their own, without the `peers*` fields also set.
     * @type {Array<PeerChange>}
     * @memberof MapResponse
     */
    PeersChangedPatch?: Array<PeerChange> | null;
    /**
     * `peers_removed` are the `NodeID`s that are no longer in the peer list.
     * @type {Array<number>}
     * @memberof MapResponse
     */
    PeersRemoved?: Array<number> | null;
    /**
     * `ping_request`, if non-empty, is a request to the client to prove it's still there by sending an HTTP request to the provided URL. No auth headers are necessary. `ping_request` may be sent on any [`MapResponse`] (ones with `keep_alive` true or false).
     * @type {PingRequest}
     * @memberof MapResponse
     */
    PingRequest?: PingRequest | null;
    /**
     * `pop_browser_url`, if non-empty, is a URL for the client to open to complete an action. The client should dup suppress identical URLs and only open it once for the same URL.
     * @type {string}
     * @memberof MapResponse
     */
    PopBrowserURL?: string;
    /**
     * `ssh_policy`, if non-nil, updates the SSH policy for how incoming SSH connections should be handled.
     * @type {SSHPolicy}
     * @memberof MapResponse
     */
    SSHPolicy?: SSHPolicy | null;
    /**
     * `seq` is a sequence number within a named map session (a response where the first message contains a MapSessionHandle). The `seq` number may be omitted on responses that don't change the state of the stream, such as `keep_alive` or certain types of `ping_request`s. This is the value to be sent in `MapRequest.map_session_seq` to resume after this message.
     * @type {number}
     * @memberof MapResponse
     */
    Seq?: number;
    /**
     * `tka_info` describes the control plane's view of tailnet key authority (TKA) state.
     * 
     * An initial nil `tka_info` indicates that the control plane believes TKA should not be enabled. An initial non-nil `tka_info` indicates the control plane believes TKA should be enabled. A nil `tka_info` in a mapresponse stream (i.e. a 'delta' mapresponse) indicates no change from the value sent earlier.
     * @type {TKAInfo}
     * @memberof MapResponse
     */
    TKAInfo?: TKAInfo | null;
    /**
     * `user_profiles` are the user profiles of nodes in the network. As as of 1.1.541 (mapver 5), this contains new or updated user profiles only.
     * @type {Array<UserProfile>}
     * @memberof MapResponse
     */
    UserProfiles?: Array<UserProfile> | null;
}
/**
 * 
 * @export
 * @interface MoveDnsSearchDomainRequest
 */
export interface MoveDnsSearchDomainRequest {
    /**
     * The domain's new index
     * 
     * This index references to the list of search domains **without** the domain to be moved.
     * @type {number}
     * @memberof MoveDnsSearchDomainRequest
     */
    new_index: number;
    /**
     * The domain's old index
     * 
     * This index is used to identify the domain to move.
     * @type {number}
     * @memberof MoveDnsSearchDomainRequest
     */
    old_index: number;
}
/**
 * A request to move a tag to a directory.
 * @export
 * @interface MoveTagToAnotherDirectoryRequest
 */
export interface MoveTagToAnotherDirectoryRequest {
    /**
     * The directory's uuid.
     * @type {string}
     * @memberof MoveTagToAnotherDirectoryRequest
     */
    directory_uuid?: string | null;
    /**
     * The tag's uuid.
     * @type {string}
     * @memberof MoveTagToAnotherDirectoryRequest
     */
    tag_uuid: string;
}
/**
 * 
 * @export
 * @interface MoveTenantSearchDomainRequest
 */
export interface MoveTenantSearchDomainRequest {
    /**
     * The domain's new index
     * 
     * This index references to the list of search domains **without** the domain to be moved.
     * @type {number}
     * @memberof MoveTenantSearchDomainRequest
     */
    new_index: number;
    /**
     * The domain's old index
     * 
     * This index is used to identify the domain to move.
     * @type {number}
     * @memberof MoveTenantSearchDomainRequest
     */
    old_index: number;
}
/**
 * `NetInfo` contains information about the host's network state.
 * @export
 * @interface NetInfo
 */
export interface NetInfo {
    /**
     * `derp_latency` is the fastest recent time to reach various DERP STUN servers, in seconds. The map key is the "regionID-v4" or "-v6"; it was previously the DERP server's STUN host:port.
     * 
     * This should only be updated rarely, or when there's a material change, as any change here also gets uploaded to the control plane.
     * @type {{ [key: string]: number | undefined; }}
     * @memberof NetInfo
     */
    DERPLatency?: { [key: string]: number | undefined; };
    /**
     * `firewall_mode` encodes both which firewall mode was selected and why. It is Linux-specific (at least as of 2023-08-19) and is meant to help debug iptables-vs-nftables issues. The string is of the form "{nft,ift}-REASON", like "nft-forced" or "ipt-default". Empty means either not Linux or a configuration in which the host firewall rules are not managed by tailscaled.
     * @type {string}
     * @memberof NetInfo
     */
    FirewallMode?: string;
    /**
     * `hair_pinning` is their router does hairpinning. It reports true even if there's no NAT involved.
     * @type {boolean}
     * @memberof NetInfo
     */
    HairPinning?: boolean | null;
    /**
     * `have_port_map` is whether we have an existing portmap open (UPnP, PMP, or PCP).
     * @type {boolean}
     * @memberof NetInfo
     */
    HavePortMap?: boolean;
    /**
     * `link_type` is the current link type, if known.
     * @type {string}
     * @memberof NetInfo
     */
    LinkType?: string;
    /**
     * `mapping_varies_by_dest_ip` says whether the host's NAT mappings vary based on the destination IP.
     * @type {boolean}
     * @memberof NetInfo
     */
    MappingVariesByDestIP?: boolean | null;
    /**
     * `os_has_ipv6` is whether the OS supports IPv6 at all, regardless of whether IPv6 internet connectivity is available.
     * @type {boolean}
     * @memberof NetInfo
     */
    OSHasIPv6?: boolean | null;
    /**
     * `pcp` is whether PCP appears present on the LAN. Empty means not checked.
     * @type {boolean}
     * @memberof NetInfo
     */
    PCP?: boolean | null;
    /**
     * `pmp` is whether NAT-PMP appears present on the LAN. Empty means not checked.
     * @type {boolean}
     * @memberof NetInfo
     */
    PMP?: boolean | null;
    /**
     * `preferred_derp` is this node's preferred (home) DERP region ID. This is where the node expects to be contacted to begin a peer-to-peer connection. The node might be be temporarily connected to multiple DERP servers (to speak to other nodes that are located elsewhere) but `preferred_derp` is the region ID that the node subscribes to traffic at. Zero means disconnected or unknown.
     * @type {number}
     * @memberof NetInfo
     */
    PreferredDERP?: number;
    /**
     * `upnp` is whether UPnP appears present on the LAN. Empty means not checked.
     * @type {boolean}
     * @memberof NetInfo
     */
    UPnP?: boolean | null;
    /**
     * `working_icmp_v4` is whether ICMPv4 works. Empty means not checked.
     * @type {boolean}
     * @memberof NetInfo
     */
    WorkingICMPv4?: boolean | null;
    /**
     * `working_ipv6` is whether the host has IPv6 internet connectivity.
     * @type {boolean}
     * @memberof NetInfo
     */
    WorkingIPv6?: boolean | null;
    /**
     * `working_udp` is whether the host has UDP internet connectivity.
     * @type {boolean}
     * @memberof NetInfo
     */
    working_udp?: boolean | null;
}
/**
 * `NetPortRange` represents a range of ports that's allowed for one or more IPs.
 * @export
 * @interface NetPortRange
 */
export interface NetPortRange {
    /**
     * 
     * @type {number}
     * @memberof NetPortRange
     */
    Bits?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NetPortRange
     */
    IP?: string;
    /**
     * 
     * @type {PortRange}
     * @memberof NetPortRange
     */
    Ports?: PortRange;
}
/**
 * `Node` is a Tailscale device in a tailnet.
 * @export
 * @interface Node
 */
export interface Node {
    /**
     * `addresses` are the IP addresses of this Node directly.
     * @type {Array<string>}
     * @memberof Node
     */
    Addresses?: Array<string> | null;
    /**
     * `allowed_ips` are the IP ranges to route to this node.
     * 
     * As of CapabilityVersion 112, this may be nil (null or undefined) on the wire to mean the same as Addresses. Internally, it is always filled in with its possibly-implicit value.
     * @type {Array<string>}
     * @memberof Node
     */
    AllowedIPs?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof Node
     */
    Cap?: number;
    /**
     * `cap_map` is a map of capabilities to their optional argument/data values.
     * 
     * It is valid for a capability to not have any argument/data values; such capabilities can be tested for using the HasCap method. These type of capabilities are used to indicate that a node has a capability, but there is no additional data associated with it. These were previously represented by the `capabilities` field, but can now be represented by `cap_map` with an empty value.
     * 
     * See NodeCapability for more information on keys.
     * 
     * Metadata about nodes can be transmitted in 3 ways: 1. `MapResponse.node.cap_map` describes attributes that affect behavior for this node, such as which features have been enabled through the admin panel and any associated configuration details. 2. `MapResponse.packet_filter` describes access (both IP and application based) that should be granted to peers. 3. `MapResponse.peers[].cap_map` describes attributes regarding a peer node, such as which features the peer supports or if that peer is preferred for a particular task vs other peers that could also be chosen.
     * @type {{ [key: string]: Array<any> | undefined | null; }}
     * @memberof Node
     */
    CapMap?: { [key: string]: Array<any> | undefined | null; };
    /**
     * `capabilities` are capabilities that the node has. They're free-form strings, but should be in the form of URLs/URIs such as: "https://tailscale.com/cap/is-admin" "https://tailscale.com/cap/file-sharing"
     * 
     * Deprecated: use CapMap instead. See https://github.com/tailscale/tailscale/issues/11508
     * @type {Array<string>}
     * @memberof Node
     */
    Capabilities?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    ComputedHostIfDifferent?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    ComputedName?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    ComputedNameWithHost?: string;
    /**
     * 
     * @type {any}
     * @memberof Node
     */
    Created?: any;
    /**
     * `legacy_derp_string` is this node's home `legacy_derp_string` region ID integer, but shoved into an IP:port string for legacy reasons. The IP address is always "127.3.3.40" (a loopback address (127) followed by the digits over the letters DERP on a QWERTY keyboard (3.3.40)). The "port number" is the home `legacy_derp_string` region ID integer.
     * 
     * Deprecated: HomeDERP has replaced this, but old servers might still send this field. See tailscale/tailscale#14636. Do not use this field in code other than in the upgradeNode func, which canonicalizes it to HomeDERP if it arrives as a `legacy_derp_string` string on the wire.
     * @type {string}
     * @memberof Node
     */
    DERP?: string;
    /**
     * DataPlaneAuditLogID is the per-node logtail ID used for data plane audit logging.
     * @type {string}
     * @memberof Node
     */
    DataPlaneAuditLogID?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    DiscoKey?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Node
     */
    Endpoints?: Array<string> | null;
    /**
     * `exit_node_dns_resolvers` is the list of DNS servers that should be used when this node is marked `is_wire_guard_only` and being used as an exit node.
     * @type {Array<DnsResolver>}
     * @memberof Node
     */
    ExitNodeDnsResolvers?: Array<DnsResolver> | null;
    /**
     * `expired` is whether this node's key has expired. Control may send this; clients are only allowed to set this from false to true. On the client, this is calculated client-side based on a timestamp sent from control, to avoid clock skew issues.
     * @type {boolean}
     * @memberof Node
     */
    Expired?: boolean;
    /**
     * `home_derp` is the modern version of the DERP string field, with just an integer. The client advertises support for this as of capver 111.
     * 
     * `home_derp` may be zero if not (yet) known, but ideally always be non-zero for magicsock connectivity to function normally.
     * @type {number}
     * @memberof Node
     */
    HomeDERP?: number;
    /**
     * 
     * @type {Hostinfo}
     * @memberof Node
     */
    Hostinfo?: Hostinfo;
    /**
     * 
     * @type {number}
     * @memberof Node
     */
    ID?: number;
    /**
     * `is_jailed` indicates that this node is jailed and should not be allowed initiate connections, however outbound connections to it should still be allowed.
     * @type {boolean}
     * @memberof Node
     */
    IsJailed?: boolean;
    /**
     * `is_wire_guard_only` indicates that this is a non-Tailscale WireGuard peer, it is not expected to speak Disco or DERP, and it must have `endpoints` in order to be reachable.
     * @type {boolean}
     * @memberof Node
     */
    IsWireGuardOnly?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    Key?: string;
    /**
     * 
     * @type {any}
     * @memberof Node
     */
    KeyExpiry?: any;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    KeySignature?: string;
    /**
     * `last_seen` is when the node was last online. It is not updated when Online is true. It is nil if the current node doesn't have permission to know, or the node has never been online.
     * @type {any}
     * @memberof Node
     */
    LastSeen?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    Machine?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Node
     */
    MachineAuthorized?: boolean;
    /**
     * `name` is the FQDN of the node. It is also the MagicDNS name for the node. It has a trailing dot. e.g. "host.tail-scale.ts.net."
     * @type {string}
     * @memberof Node
     */
    Name?: string;
    /**
     * `online` is whether the node is currently connected to the coordination server.  A value of nil means unknown, or the current node doesn't have permission to know.
     * @type {boolean}
     * @memberof Node
     */
    Online?: boolean | null;
    /**
     * `primary_routes` are the routes from AllowedIPs that this node is currently the primary subnet router for, as determined by the control plane. It does not include the self address values from Addresses that are in AllowedIPs.
     * @type {Array<string>}
     * @memberof Node
     */
    PrimaryRoutes?: Array<string> | null;
    /**
     * `self_node_v4_masq_addr_for_this_peer` is the IPv4 that this peer knows the current node as. It may be empty if the peer knows the current node by its native IPv4 address. This field is only populated in a `MapResponse` for peers and not for the current node.
     * 
     * If set, it should be used to masquerade traffic originating from the current node to this peer. The masquerade address is only relevant for this peer and not for other peers.
     * 
     * This only applies to traffic originating from the current node to the peer or any of its subnets. Traffic originating from subnet routes will not be masqueraded (e.g. in case of --snat-subnet-routes).
     * @type {string}
     * @memberof Node
     */
    SelfNodeV4MasqAddrForThisPeer?: string | null;
    /**
     * `self_node_v6_masq_addr_for_this_peer` is the IPv6 that this peer knows the current node as. It may be empty if the peer knows the current node by its native IPv6 address. This field is only populated in a `MapResponse` for peers and not for the current node.
     * 
     * If set, it should be used to masquerade traffic originating from the current node to this peer. The masquerade address is only relevant for this peer and not for other peers.
     * 
     * This only applies to traffic originating from the current node to the peer or any of its subnets. Traffic originating from subnet routes will not be masqueraded (e.g. in case of --snat-subnet-routes).
     * @type {string}
     * @memberof Node
     */
    SelfNodeV6MasqAddrForThisPeer?: string | null;
    /**
     * `sharer`, if non-zero, is the user who shared this node, if different than User.
     * @type {number}
     * @memberof Node
     */
    Sharer?: number;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    StableID?: string;
    /**
     * `tags` are the list of ACL tags applied to this node. Tags take the form of `tag:<value>` where value starts with a letter and only contains alphanumerics and dashes `-`. Some valid tag examples: `tag:prod` `tag:database` `tag:lab-1`
     * @type {Array<string>}
     * @memberof Node
     */
    Tags?: Array<string> | null;
    /**
     * `unsigned_peer_api_only` means that this node is not signed nor subject to TKA restrictions. However, in exchange for that privilege, it does not get network access. It can only access this node's peerapi, which may not let it do anything. It is the tailscaled client's job to double-check the `MapResponse`'s `packet_filter` to verify that its `allowed_ips` will not be accepted by the packet filter.
     * @type {boolean}
     * @memberof Node
     */
    UnsignedPeerApiOnly?: boolean;
    /**
     * `user` is the user who created the node. If ACL tags are in use for the node then it doesn't reflect the ACL identity that the node is running as.
     * @type {number}
     * @memberof Node
     */
    User?: number;
}

/**
 * Oidc claim the `remote_id` for [`RemoteUser`](crate::models::users::RemoteUser) is read from
 * 
 * |              | Vendor | Unique for    | Set if |--------------|--------|---------------|-------- | `Subject`    | every  | OIDC provider | Always | `ObjectId`   | Entra  | Entra tenant  | Always | `SecurityId` | Entra  | AD Domain     | Entra uses AD as source and was configured to do so
 * @export
 */
export const OidcClaimRemoteId = {
    Subject: 'Subject',
    ObjectId: 'ObjectId',
    SecurityId: 'SecurityId'
} as const;
export type OidcClaimRemoteId = typeof OidcClaimRemoteId[keyof typeof OidcClaimRemoteId];

/**
 * A single field which might be `null`.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Option<T>>` from your handler, please use `ApiJson<Optional<T>>` instead.
 * 
 * It simply wraps the option into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface OptionalForSimpleGroup
 */
export interface OptionalForSimpleGroup {
    /**
     * 
     * @type {SimpleGroup}
     * @memberof OptionalForSimpleGroup
     */
    optional?: SimpleGroup | null;
}
/**
 * A device not covered by any access rule
 * @export
 * @interface OrphanedDeviceSchema
 */
export interface OrphanedDeviceSchema {
    /**
     * The device's DNS name
     * @type {string}
     * @memberof OrphanedDeviceSchema
     */
    device_dnsname: string;
    /**
     * The device's UUID
     * @type {string}
     * @memberof OrphanedDeviceSchema
     */
    device_uuid: string;
    /**
     * Whether this is a user device or a tagged device
     * @type {boolean}
     * @memberof OrphanedDeviceSchema
     */
    is_user_device: boolean;
}
/**
 * A page of items
 * @export
 * @interface PageForGetAllGroupsResponseItem
 */
export interface PageForGetAllGroupsResponseItem {
    /**
     * The page's items
     * @type {Array<GetAllGroupsResponseItem>}
     * @memberof PageForGetAllGroupsResponseItem
     */
    items: Array<GetAllGroupsResponseItem>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForGetAllGroupsResponseItem
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForGetAllGroupsResponseItem
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForGetAllGroupsResponseItem
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForGetAllSubnetsResponseItem
 */
export interface PageForGetAllSubnetsResponseItem {
    /**
     * The page's items
     * @type {Array<GetAllSubnetsResponseItem>}
     * @memberof PageForGetAllSubnetsResponseItem
     */
    items: Array<GetAllSubnetsResponseItem>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForGetAllSubnetsResponseItem
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForGetAllSubnetsResponseItem
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForGetAllSubnetsResponseItem
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForGetExitNodesResponseItem
 */
export interface PageForGetExitNodesResponseItem {
    /**
     * The page's items
     * @type {Array<GetExitNodesResponseItem>}
     * @memberof PageForGetExitNodesResponseItem
     */
    items: Array<GetExitNodesResponseItem>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForGetExitNodesResponseItem
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForGetExitNodesResponseItem
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForGetExitNodesResponseItem
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForGetPendingRoutesResponseItem
 */
export interface PageForGetPendingRoutesResponseItem {
    /**
     * The page's items
     * @type {Array<GetPendingRoutesResponseItem>}
     * @memberof PageForGetPendingRoutesResponseItem
     */
    items: Array<GetPendingRoutesResponseItem>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForGetPendingRoutesResponseItem
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForGetPendingRoutesResponseItem
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForGetPendingRoutesResponseItem
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForGetRulesetsPageResponse
 */
export interface PageForGetRulesetsPageResponse {
    /**
     * The page's items
     * @type {Array<GetRulesetsPageResponse>}
     * @memberof PageForGetRulesetsPageResponse
     */
    items: Array<GetRulesetsPageResponse>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForGetRulesetsPageResponse
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForGetRulesetsPageResponse
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForGetRulesetsPageResponse
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForSimpleChangelogEntry
 */
export interface PageForSimpleChangelogEntry {
    /**
     * The page's items
     * @type {Array<SimpleChangelogEntry>}
     * @memberof PageForSimpleChangelogEntry
     */
    items: Array<SimpleChangelogEntry>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForSimpleChangelogEntry
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForSimpleChangelogEntry
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForSimpleChangelogEntry
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForSimpleDeviceGroup
 */
export interface PageForSimpleDeviceGroup {
    /**
     * The page's items
     * @type {Array<SimpleDeviceGroup>}
     * @memberof PageForSimpleDeviceGroup
     */
    items: Array<SimpleDeviceGroup>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForSimpleDeviceGroup
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForSimpleDeviceGroup
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForSimpleDeviceGroup
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForSimpleUser
 */
export interface PageForSimpleUser {
    /**
     * The page's items
     * @type {Array<SimpleUser>}
     * @memberof PageForSimpleUser
     */
    items: Array<SimpleUser>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForSimpleUser
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForSimpleUser
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForSimpleUser
     */
    total: number;
}
/**
 * `PeerChange` is an update to a node.
 * @export
 * @interface PeerChange
 */
export interface PeerChange {
    /**
     * `cap`, if non-zero, means that NodeID's capability version has changed.
     * @type {number}
     * @memberof PeerChange
     */
    Cap?: number;
    /**
     * `cap_map`, if non-nil, means that NodeID's capability map has changed.
     * @type {{ [key: string]: Array<any> | undefined | null; }}
     * @memberof PeerChange
     */
    CapMap?: { [key: string]: Array<any> | undefined | null; };
    /**
     * `derp_region`, if non-zero, means that NodeID's home DERP region ID is now this number.
     * @type {number}
     * @memberof PeerChange
     */
    DERPRegion?: number;
    /**
     * `disco_key`, if non-nil, means that the NodeID's discokey changed.
     * @type {string}
     * @memberof PeerChange
     */
    DiscoKey?: string | null;
    /**
     * `endpoints`, if non-empty, means that NodeID's UDP Endpoints have changed to these.
     * @type {Array<string>}
     * @memberof PeerChange
     */
    Endpoints?: Array<string> | null;
    /**
     * `key`, if non-nil, means that the NodeID's wireguard public key changed.
     * @type {string}
     * @memberof PeerChange
     */
    Key?: string | null;
    /**
     * `key_expiry`, if non-nil, changes the NodeID's key expiry.
     * @type {any}
     * @memberof PeerChange
     * @deprecated
     */
    KeyExpiry?: any | null;
    /**
     * `key_signature`, if non-nil, means that the signature of the wireguard public key has changed.
     * @type {string}
     * @memberof PeerChange
     */
    KeySignature?: string;
    /**
     * `last_seen`, if non-nil, means that the NodeID's online status changed.
     * @type {any}
     * @memberof PeerChange
     */
    LastSeen?: any | null;
    /**
     * `node_id` is the node ID being mutated. If the `node_id` is not known in the current netmap, this update should be ignored. (But the server will try not to send such useless updates.)
     * @type {number}
     * @memberof PeerChange
     */
    NodeID?: number;
    /**
     * `online`, if non-nil, means that the NodeID's online status changed.
     * @type {boolean}
     * @memberof PeerChange
     */
    Online?: boolean | null;
}
/**
 * `PingRequest` with no IP and Types is a request to send an HTTP request to prove the long-polling client is still connected. `PingRequest` with Types and IP, will send a ping to the IP and send a POST request containing a [`PingResponse`] to the URL containing results.
 * @export
 * @interface PingRequest
 */
export interface PingRequest {
    /**
     * `ip` is the ping target, when needed by the PingType(s) given in `types`.
     * @type {string}
     * @memberof PingRequest
     */
    IP?: string;
    /**
     * `log` is whether to log about this ping in the success case. For failure cases, the client will log regardless.
     * @type {boolean}
     * @memberof PingRequest
     */
    Log?: boolean;
    /**
     * `payload` is the ping payload.
     * 
     * It is only used for c2n requests, in which case it's an HTTP/1.0 or HTTP/1.1-formatted HTTP request as parsable with http.ReadRequest.
     * @type {string}
     * @memberof PingRequest
     */
    Payload?: string;
    /**
     * `types` is the types of ping that are initiated. Can be any [`PingType`], comma separated, e.g. "disco,TSMP"
     * 
     * As a special case, if `types` is "c2n", then this `PingRequest` is a client-to-node HTTP request. The HTTP request should be handled by this node's c2n handler and the HTTP response sent in a POST to `url`. For c2n, the value of `url_is_noise` is ignored and only the Noise transport (back to the control plane) will be used, as if `url_is_noise` were true.
     * @type {string}
     * @memberof PingRequest
     */
    Types?: string;
    /**
     * `url` is the URL to reply to the PingRequest to. It will be a unique URL each time. No auth headers are necessary. If the client sees multiple `PingRequests` with the same `url`, subsequent ones should be ignored.
     * 
     * The HTTP method that the node should make back to URL depends on the other fields of the `PingRequest`. If Types is defined, then `url` is the URL to send a POST request to. Otherwise, the node should just make a HEAD request to `url`.
     * @type {string}
     * @memberof PingRequest
     */
    URL?: string;
    /**
     * `url_is_noise`, if true, means that the client should hit `url` over the Noise transport instead of TLS.
     * @type {boolean}
     * @memberof PingRequest
     */
    URLIsNoise?: boolean;
}
/**
 * `PortRange` represents a range of UDP or TCP port numbers.
 * @export
 * @interface PortRange
 */
export interface PortRange {
    /**
     * 
     * @type {number}
     * @memberof PortRange
     */
    First?: number;
    /**
     * 
     * @type {number}
     * @memberof PortRange
     */
    Last?: number;
}
/**
 * 
 * @export
 * @interface RecreateInvitationRequest
 */
export interface RecreateInvitationRequest {
    /**
     * Number of days the new link is valid for
     * @type {number}
     * @memberof RecreateInvitationRequest
     */
    link_valid_until: number;
}
/**
 * A pair of rules where the broader one makes the narrower one redundant
 * @export
 * @interface RedundantRulePairSchema
 */
export interface RedundantRulePairSchema {
    /**
     * The broader rule's UUID
     * @type {string}
     * @memberof RedundantRulePairSchema
     */
    broader_rule_uuid: string;
    /**
     * The narrower (redundant) rule's UUID
     * @type {string}
     * @memberof RedundantRulePairSchema
     */
    narrower_rule_uuid: string;
    /**
     * Explanation of the redundancy
     * @type {string}
     * @memberof RedundantRulePairSchema
     */
    reason: string;
}
/**
 * Request to reject a subnet router
 * @export
 * @interface RejectPendingSubnetRouterRequest
 */
export interface RejectPendingSubnetRouterRequest {
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof RejectPendingSubnetRouterRequest
     */
    name: string;
    /**
     * The subnet's initial router
     * @type {string}
     * @memberof RejectPendingSubnetRouterRequest
     */
    router: string;
}
/**
 * 
 * @export
 * @interface RemoveTenantDomainRequest
 */
export interface RemoveTenantDomainRequest {
    /**
     * 
     * @type {string}
     * @memberof RemoveTenantDomainRequest
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface RenewUserAccessRequest
 */
export interface RenewUserAccessRequest {
    /**
     * Start of the user's access period
     * 
     * Must not lie in the past. `None` means access starts now
     * @type {string}
     * @memberof RenewUserAccessRequest
     */
    new_access_start?: string | null;
    /**
     * Until when should the new access be granted
     * 
     * Must not lie in the past. `None` means unlimited access.
     * @type {string}
     * @memberof RenewUserAccessRequest
     */
    new_access_until?: string | null;
}
/**
 * @type RuleEmptySideSchema
 * Which side of a rule has no devices
 * @export
 */
export type RuleEmptySideSchema = string;
/**
 * A rule where one or both sides resolve to zero devices
 * @export
 * @interface RuleWithNoDevicesSchema
 */
export interface RuleWithNoDevicesSchema {
    /**
     * The rule's description
     * @type {string}
     * @memberof RuleWithNoDevicesSchema
     */
    description: string;
    /**
     * Which side(s) have no devices
     * @type {RuleEmptySideSchema}
     * @memberof RuleWithNoDevicesSchema
     */
    empty_side: RuleEmptySideSchema;
    /**
     * The rule's UUID
     * @type {string}
     * @memberof RuleWithNoDevicesSchema
     */
    rule_uuid: string;
}
/**
 * 
 * @export
 * @interface SSHAction
 */
export interface SSHAction {
    /**
     * 
     * @type {boolean}
     * @memberof SSHAction
     */
    accept?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSHAction
     */
    allowAgentForwarding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSHAction
     */
    allowLocalPortForwarding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSHAction
     */
    allowRemotePortForwarding?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SSHAction
     */
    holdAndDelegate?: string;
    /**
     * 
     * @type {string}
     * @memberof SSHAction
     */
    message?: string;
    /**
     * 
     * @type {SSHRecorderFailureAction}
     * @memberof SSHAction
     */
    onRecordingFailure?: SSHRecorderFailureAction | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SSHAction
     */
    recorders?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SSHAction
     */
    reject?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SSHAction
     */
    sessionDuration?: number;
}
/**
 * 
 * @export
 * @interface SSHPolicy
 */
export interface SSHPolicy {
    /**
     * 
     * @type {Array<SSHRule>}
     * @memberof SSHPolicy
     */
    rules?: Array<SSHRule> | null;
}
/**
 * 
 * @export
 * @interface SSHPrincipal
 */
export interface SSHPrincipal {
    /**
     * 
     * @type {boolean}
     * @memberof SSHPrincipal
     */
    any?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SSHPrincipal
     */
    node?: string;
    /**
     * 
     * @type {string}
     * @memberof SSHPrincipal
     */
    nodeIP?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SSHPrincipal
     */
    pubKeys?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SSHPrincipal
     */
    userLogin?: string;
}
/**
 * `SSHRecorderFailureAction` is the action to take if recording fails.
 * @export
 * @interface SSHRecorderFailureAction
 */
export interface SSHRecorderFailureAction {
    /**
     * `notify_url`, if non-empty, specifies a HTTP POST URL to notify when the recording fails. The payload is the JSON encoded SSHRecordingFailureNotifyRequest struct. The host field in the URL is ignored, and it will be sent to control over the Noise transport.
     * @type {string}
     * @memberof SSHRecorderFailureAction
     */
    NotifyUrl?: string;
    /**
     * `reject_session_with_message`, if not empty, specifies that the session should be rejected if the recording fails to start. The message will be shown to the user before the session is rejected.
     * @type {string}
     * @memberof SSHRecorderFailureAction
     */
    RejectSessionWithMessage?: string;
    /**
     * `terminate_session_with_message`, if not empty, specifies that the session should be terminated if the recording fails after it has started. The message will be shown to the user before the session is terminated.
     * @type {string}
     * @memberof SSHRecorderFailureAction
     */
    TerminateSessionWithMessage?: string;
}
/**
 * 
 * @export
 * @interface SSHRule
 */
export interface SSHRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof SSHRule
     */
    acceptEnv?: Array<string> | null;
    /**
     * 
     * @type {SSHAction}
     * @memberof SSHRule
     */
    action?: SSHAction | null;
    /**
     * 
     * @type {Array<SSHPrincipal>}
     * @memberof SSHRule
     */
    principals?: Array<SSHPrincipal> | null;
    /**
     * 
     * @type {any}
     * @memberof SSHRule
     */
    ruleExpires?: any | null;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof SSHRule
     */
    sshUsers?: { [key: string]: string | undefined; };
}
/**
 * A group or user found by a search
 * 
 * This struct is part of [`SearchResults`]
 * @export
 * @interface SearchResultsGroup
 */
export interface SearchResultsGroup {
    /**
     * The group's members
     * 
     * This field is only populated if the [`SearchParams`]'s `membership_in_group` flag is `true`.
     * @type {Array<string>}
     * @memberof SearchResultsGroup
     */
    list: Array<string>;
    /**
     * The group's name
     * @type {string}
     * @memberof SearchResultsGroup
     */
    name: string;
}
/**
 * A group or user found by a search
 * 
 * This struct is part of [`SearchResults`]
 * @export
 * @interface SearchResultsUser
 */
export interface SearchResultsUser {
    /**
     * The user's groups
     * 
     * This field is only populated if the [`SearchParams`]'s `membership_in_group` flag is `false`.
     * @type {Array<string>}
     * @memberof SearchResultsUser
     */
    list: Array<string>;
    /**
     * The user's name
     * @type {string}
     * @memberof SearchResultsUser
     */
    name: string;
    /**
     * External id the remote identifies the user with.
     * 
     * This is not the DN (probably). The DN only identifies the user for the purpose of the LDAP protocol. The `remote_id` needs to identify the user across protocols. That is, OIDC has to report the same `remote_id`.
     * @type {string}
     * @memberof SearchResultsUser
     */
    remote_id: string;
}
/**
 * `Service` represents a service running on a node.
 * @export
 * @interface Service
 */
export interface Service {
    /**
     * `description` is the textual description of the service, usually the process name that's running.
     * @type {string}
     * @memberof Service
     */
    Description?: string;
    /**
     * `port` is the port number.
     * 
     * For Proto "peerapi-dns", it must be 1.
     * @type {number}
     * @memberof Service
     */
    Port?: number;
    /**
     * `proto` is the type of service. It's usually the constant TCP or UDP ("tcp" or "udp"), but it can also be one of the following meta service values:
     * 
     * * "peerapi4": peerapi is available on IPv4; Port is the port number that the peerapi is running on the node's Tailscale IPv4 address. * "peerapi6": peerapi is available on IPv6; Port is the port number that the peerapi is running on the node's Tailscale IPv6 address. * "peerapi-dns-proxy": the local peerapi service supports being a DNS proxy (when the node is an exit node). For this service, the Port number must only be 1.
     * @type {string}
     * @memberof Service
     */
    Proto?: string;
}
/**
 * 
 * @export
 * @interface SetDeviceDnsnameErrors
 */
export interface SetDeviceDnsnameErrors {
    /**
     * 
     * @type {boolean}
     * @memberof SetDeviceDnsnameErrors
     */
    dnsname_not_unique: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SetDeviceDnsnameErrors
     */
    extra_dns_exists: boolean;
}
/**
 * 
 * @export
 * @interface SetDeviceDnsnameRequest
 */
export interface SetDeviceDnsnameRequest {
    /**
     * 
     * @type {string}
     * @memberof SetDeviceDnsnameRequest
     */
    dnsname: string;
}
/**
 * 
 * @export
 * @interface SetDeviceGroupDescriptionRequest
 */
export interface SetDeviceGroupDescriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof SetDeviceGroupDescriptionRequest
     */
    description: string;
}
/**
 * 
 * @export
 * @interface SetDeviceGroupNameErrors
 */
export interface SetDeviceGroupNameErrors {
    /**
     * 
     * @type {boolean}
     * @memberof SetDeviceGroupNameErrors
     */
    name_not_unique: boolean;
}
/**
 * 
 * @export
 * @interface SetDeviceGroupNameRequest
 */
export interface SetDeviceGroupNameRequest {
    /**
     * 
     * @type {string}
     * @memberof SetDeviceGroupNameRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface SetEphemeralDeviceSettingsRequest
 */
export interface SetEphemeralDeviceSettingsRequest {
    /**
     * The bit of the ephemeral device that is currently being used.
     * @type {number}
     * @memberof SetEphemeralDeviceSettingsRequest
     */
    bit: number;
}
/**
 * 
 * @export
 * @interface SetGeneralSettingsErrors
 */
export interface SetGeneralSettingsErrors {
    /**
     * A device's name with the new base domain with conflict with an extra record
     * @type {boolean}
     * @memberof SetGeneralSettingsErrors
     */
    conflicting_device_and_domain: boolean;
}
/**
 * 
 * @export
 * @interface SetGeneralSettingsRequest
 */
export interface SetGeneralSettingsRequest {
    /**
     * URL of the admin web interface. Must contain the protocol (HTTPS) as well as any port and path, if required.
     * @type {string}
     * @memberof SetGeneralSettingsRequest
     */
    admin_origin?: string | null;
    /**
     * Base domain used by 0trust to generate DNS names for devices in the network. Previously called `headscale_base_domain`.
     * @type {string}
     * @memberof SetGeneralSettingsRequest
     */
    dns_base_domain?: string | null;
    /**
     * Publicly reachable target URL of the 0trust server. Must contain the protocol (HTTPS) as well as any port and path, if required. Previously called `headscale_url`.
     * @type {string}
     * @memberof SetGeneralSettingsRequest
     */
    public_origin?: string | null;
}
/**
 * 
 * @export
 * @interface SetLdapConnectionSettingsErrors
 */
export interface SetLdapConnectionSettingsErrors {
    /**
     * 
     * @type {boolean}
     * @memberof SetLdapConnectionSettingsErrors
     */
    url_invalid: boolean;
}
/**
 * 
 * @export
 * @interface SetLdapConnectionSettingsRequest
 */
export interface SetLdapConnectionSettingsRequest {
    /**
     * Is the ldap sync enabled?
     * @type {boolean}
     * @memberof SetLdapConnectionSettingsRequest
     */
    ldap_enabled: boolean;
    /**
     * The password to authenticate with at ldap
     * @type {string}
     * @memberof SetLdapConnectionSettingsRequest
     */
    ldap_password?: string | null;
    /**
     * The url under which the backend can reach the ldap
     * @type {string}
     * @memberof SetLdapConnectionSettingsRequest
     */
    ldap_url: string;
    /**
     * The username to authenticate with at ldap
     * @type {string}
     * @memberof SetLdapConnectionSettingsRequest
     */
    ldap_user: string;
}
/**
 * 
 * @export
 * @interface SetLdapQuerySettingsRequest
 */
export interface SetLdapQuerySettingsRequest {
    /**
     * The dn to search for groups
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    group_base: string;
    /**
     * The filter to use when searching for groups
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    group_filter: string;
    /**
     * LDAP attribute containing the group's name
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    group_name: string;
    /**
     * LDAP attribute which stores the membership relation between groups and users
     * 
     * The flag `membership_in_group` stores whether this attribute is found on groups or users
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    membership_attr: string;
    /**
     * Is the `membership_attr` set for groups and stores the list of users which are members of the group?
     * 
     * Alternatively, the `membership_attr` is set for users and stores the list of groups the user is member of.
     * @type {boolean}
     * @memberof SetLdapQuerySettingsRequest
     */
    membership_in_group: boolean;
    /**
     * The dn to search for users
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    user_base: string;
    /**
     * The filter to use when searching for users
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    user_filter: string;
    /**
     * LDAP attribute containing the user's name
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    user_name: string;
    /**
     * LDAP attribute containing the user's remote_id
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    user_remote_id: string;
}
/**
 * 
 * @export
 * @interface SetLdapSettingsErrors
 */
export interface SetLdapSettingsErrors {
    /**
     * 
     * @type {string}
     * @memberof SetLdapSettingsErrors
     */
    group_filter_invalid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetLdapSettingsErrors
     */
    user_filter_invalid?: string | null;
}
/**
 * 
 * @export
 * @interface SetLocalAuthRequirementsRequest
 */
export interface SetLocalAuthRequirementsRequest {
    /**
     * The requirements to enforce for local user's credentials
     * @type {LocalAuthRequirements}
     * @memberof SetLocalAuthRequirementsRequest
     */
    requirements: LocalAuthRequirements;
}
/**
 * 
 * @export
 * @interface SetOidcSettingsRequest
 */
export interface SetOidcSettingsRequest {
    /**
     * OAuth client id
     * @type {string}
     * @memberof SetOidcSettingsRequest
     */
    client_id: string;
    /**
     * OAuth client secret
     * 
     * This field might be set but must be ignored if `use_cert` is `true`.
     * @type {string}
     * @memberof SetOidcSettingsRequest
     */
    client_secret?: string | null;
    /**
     * Is the provider currently enabled?
     * @type {boolean}
     * @memberof SetOidcSettingsRequest
     */
    enabled: boolean;
    /**
     * Oidc claim the `remote_id` is read from
     * @type {OidcClaimRemoteId}
     * @memberof SetOidcSettingsRequest
     */
    remote_id: OidcClaimRemoteId;
    /**
     * Issuer Url (the url without the `.well-known/openid-configuration` part)
     * 
     * This should be a valid url but might not be one, if the provider is still being configured.
     * @type {string}
     * @memberof SetOidcSettingsRequest
     */
    url: string;
    /**
     * Use a x509 certificate and a JWT instead of `client_secret`
     * 
     * This option causes `client_secret` to be ignored. Instead, the global `ZtrustSettings.oidc_private_key` is used to sign a JWT. The OpenID Connect provider will verify it using the key's self-signed cert.
     * @type {boolean}
     * @memberof SetOidcSettingsRequest
     */
    use_cert: boolean;
}
/**
 * 
 * @export
 * @interface SetScimSettingsRequest
 */
export interface SetScimSettingsRequest {
    /**
     * Is the scim API enabled?
     * @type {boolean}
     * @memberof SetScimSettingsRequest
     */
    enabled: boolean;
    /**
     * Enables the workaround required for Microsoft Entra
     * @type {boolean}
     * @memberof SetScimSettingsRequest
     */
    entra_workaround: boolean;
    /**
     * Bearer token required by all scim endpoints
     * @type {string}
     * @memberof SetScimSettingsRequest
     */
    token?: string | null;
}
/**
 * Request to set a subnet's description
 * @export
 * @interface SetSubnetDescriptionRequest
 */
export interface SetSubnetDescriptionRequest {
    /**
     * The description of the subnet
     * @type {string}
     * @memberof SetSubnetDescriptionRequest
     */
    description: string;
}
/**
 * 
 * @export
 * @interface SetTagDescriptionRequest
 */
export interface SetTagDescriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof SetTagDescriptionRequest
     */
    description: string;
}
/**
 * 
 * @export
 * @interface SetTagNameErrors
 */
export interface SetTagNameErrors {
    /**
     * 
     * @type {boolean}
     * @memberof SetTagNameErrors
     */
    name_not_unique: boolean;
}
/**
 * 
 * @export
 * @interface SetTagNameRequest
 */
export interface SetTagNameRequest {
    /**
     * 
     * @type {string}
     * @memberof SetTagNameRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface ShortDeviceFromName
 */
export interface ShortDeviceFromName {
    /**
     * IPv4 of the device
     * @type {string}
     * @memberof ShortDeviceFromName
     */
    ipv4?: string | null;
    /**
     * IPv6 of the device
     * @type {string}
     * @memberof ShortDeviceFromName
     */
    ipv6?: string | null;
    /**
     * Name of the Device
     * @type {string}
     * @memberof ShortDeviceFromName
     */
    name: string;
    /**
     * Uuid of the Device
     * @type {string}
     * @memberof ShortDeviceFromName
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleAccount
 */
export interface SimpleAccount {
    /**
     * The name that is used for displaying purposes
     * @type {string}
     * @memberof SimpleAccount
     */
    display_name: string;
    /**
     * The preferred username of the account, a primary username that represents a user
     * @type {string}
     * @memberof SimpleAccount
     */
    preferred_username: string;
    /**
     * Primary key
     * @type {string}
     * @memberof SimpleAccount
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleChangelogEntry
 */
export interface SimpleChangelogEntry {
    /**
     * Timestamp when the entry was created i.e. the change was performed
     * @type {string}
     * @memberof SimpleChangelogEntry
     */
    created_at: string;
    /**
     * Additional data
     * 
     * This is a json object a user should be able to understand.
     * @type {any}
     * @memberof SimpleChangelogEntry
     */
    data: any | null;
    /**
     * Was the object created, updated or deleted?
     * @type {ChangelogOperation}
     * @memberof SimpleChangelogEntry
     */
    operation: ChangelogOperation;
    /**
     * The name of the object which was changed
     * 
     * The concrete interpretation of the name is dependent on the `target_type`. But generally, a human can hopefully identify the object using its type and name.
     * @type {string}
     * @memberof SimpleChangelogEntry
     */
    target_name: string;
    /**
     * The type of the object which was changed
     * @type {ChangelogTarget}
     * @memberof SimpleChangelogEntry
     */
    target_type: ChangelogTarget;
    /**
     * Name of the person which performed the change
     * @type {string}
     * @memberof SimpleChangelogEntry
     */
    user_name: string;
    /**
     * The preferred username of the account which performed the change
     * @type {string}
     * @memberof SimpleChangelogEntry
     */
    user_preferred_name: string;
}
/**
 * 
 * @export
 * @interface SimpleDeviceGroup
 */
export interface SimpleDeviceGroup {
    /**
     * The description for the device group
     * @type {string}
     * @memberof SimpleDeviceGroup
     */
    description: string;
    /**
     * The device group's name
     * @type {string}
     * @memberof SimpleDeviceGroup
     */
    name: string;
    /**
     * Primary key
     * @type {string}
     * @memberof SimpleDeviceGroup
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleDnsSearchDomain
 */
export interface SimpleDnsSearchDomain {
    /**
     * The domain to use as search domain
     * 
     * It must be a FQDN without a trailing dot.
     * @type {string}
     * @memberof SimpleDnsSearchDomain
     */
    domain: string;
    /**
     * Primary key
     * @type {string}
     * @memberof SimpleDnsSearchDomain
     */
    uuid: string;
}
/**
 * Simple representation of an extra DNS domain.
 * @export
 * @interface SimpleExtraDnsDomain
 */
export interface SimpleExtraDnsDomain {
    /**
     * Description
     * @type {string}
     * @memberof SimpleExtraDnsDomain
     */
    description: string;
    /**
     * The fully qualified domain name
     * @type {string}
     * @memberof SimpleExtraDnsDomain
     */
    from_dns: string;
    /**
     * The primary key
     * @type {string}
     * @memberof SimpleExtraDnsDomain
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleGroup
 */
export interface SimpleGroup {
    /**
     * 
     * @type {string}
     * @memberof SimpleGroup
     */
    description: string;
    /**
     * The group's identifier in the synced source of truth
     * 
     * I.e. DN for LDAP syncs
     * @type {string}
     * @memberof SimpleGroup
     */
    external_id: string;
    /**
     * Allows this group to have access to `autogroup:internet`
     * @type {boolean}
     * @memberof SimpleGroup
     */
    internet: boolean;
    /**
     * The group's name (**without** the "group:" prefix)
     * @type {string}
     * @memberof SimpleGroup
     */
    name: string;
    /**
     * 
     * @type {GroupProvider}
     * @memberof SimpleGroup
     */
    provider: GroupProvider;
    /**
     * The group's uuid
     * @type {string}
     * @memberof SimpleGroup
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleInvitationLink
 */
export interface SimpleInvitationLink {
    /**
     * 
     * @type {string}
     * @memberof SimpleInvitationLink
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleInvitationLink
     */
    expires_at: string;
    /**
     * An [`InvitationLink`]'s primary key
     * @type {string}
     * @memberof SimpleInvitationLink
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleOidcProvider
 */
export interface SimpleOidcProvider {
    /**
     * The PEM encoded certificate, if any.
     * @type {string}
     * @memberof SimpleOidcProvider
     */
    cert_pem: string;
    /**
     * OAuth client id
     * @type {string}
     * @memberof SimpleOidcProvider
     */
    client_id: string;
    /**
     * OAuth client secret
     * @type {boolean}
     * @memberof SimpleOidcProvider
     */
    client_secret: boolean;
    /**
     * Is the provider currently enabled?
     * @type {boolean}
     * @memberof SimpleOidcProvider
     */
    enabled: boolean;
    /**
     * Errors encountered while trying to use this OIDC provider
     * @type {string}
     * @memberof SimpleOidcProvider
     */
    errors?: string | null;
    /**
     * Display text for the login button shown on the English login page
     * @type {string}
     * @memberof SimpleOidcProvider
     */
    login_button_display_english: string;
    /**
     * Display text for the login button shown on the German login page
     * @type {string}
     * @memberof SimpleOidcProvider
     */
    login_button_display_german: string;
    /**
     * Display name for this provider
     * @type {any}
     * @memberof SimpleOidcProvider
     */
    name: any;
    /**
     * Is this the primary provider?
     * @type {boolean}
     * @memberof SimpleOidcProvider
     */
    primary: boolean;
    /**
     * Redirect Url the user follows back to ztna
     * @type {string}
     * @memberof SimpleOidcProvider
     */
    redirect_url: string;
    /**
     * Issuer Url
     * @type {string}
     * @memberof SimpleOidcProvider
     */
    url: string;
    /**
     * Use a x509 certificate and a JWT instead of `client_secret`
     * @type {boolean}
     * @memberof SimpleOidcProvider
     */
    use_cert: boolean;
    /**
     * The primary key
     * @type {string}
     * @memberof SimpleOidcProvider
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimplePlugin
 */
export interface SimplePlugin {
    /**
     * A description of the plugin
     * @type {string}
     * @memberof SimplePlugin
     */
    description: string;
    /**
     * Base64 encoded thumbnail
     * @type {string}
     * @memberof SimplePlugin
     */
    image: string;
    /**
     * Has the plugin been installed?
     * @type {boolean}
     * @memberof SimplePlugin
     */
    installed: boolean;
    /**
     * A unique display name
     * @type {string}
     * @memberof SimplePlugin
     */
    name: string;
    /**
     * Does the installed version differ from the store's current version?
     * @type {boolean}
     * @memberof SimplePlugin
     */
    outdated: boolean;
    /**
     * The ztna store's schema for this plugin
     * 
     * The returned value is only the version agnostic summary. The store has a different schema type for a plugin's specific version.
     * @type {SimplePluginSchema}
     * @memberof SimplePlugin
     */
    store?: SimplePluginSchema | null;
    /**
     * Primary key
     * @type {string}
     * @memberof SimplePlugin
     */
    uuid: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePlugin
     */
    version: string;
}
/**
 * 
 * @export
 * @interface SimplePluginSchema
 */
export interface SimplePluginSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof SimplePluginSchema
     */
    categories: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SimplePluginSchema
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePluginSchema
     */
    current_created_at: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePluginSchema
     */
    current_description: string;
    /**
     * Base64-encoded image
     * @type {string}
     * @memberof SimplePluginSchema
     */
    current_image: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePluginSchema
     */
    current_version: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePluginSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePluginSchema
     */
    uuid: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimplePluginSchema
     */
    versions: Array<string>;
}
/**
 * 
 * @export
 * @interface SimpleRulesetRule
 */
export interface SimpleRulesetRule {
    /**
     * A description
     * @type {string}
     * @memberof SimpleRulesetRule
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof SimpleRulesetRule
     */
    port: number;
    /**
     * 
     * @type {number}
     * @memberof SimpleRulesetRule
     */
    port_range_end?: number | null;
    /**
     * The transport protocol allowed by this rule.
     * @type {AccessRuleProtocol}
     * @memberof SimpleRulesetRule
     */
    protocol: AccessRuleProtocol;
    /**
     * The primary key
     * @type {string}
     * @memberof SimpleRulesetRule
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleSubnet
 */
export interface SimpleSubnet {
    /**
     * Description of the subnet
     * @type {string}
     * @memberof SimpleSubnet
     */
    description: string;
    /**
     * Does this network have an associated device routing it?
     * @type {boolean}
     * @memberof SimpleSubnet
     */
    has_router: boolean;
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof SimpleSubnet
     */
    name: string;
    /**
     * Primary key
     * @type {string}
     * @memberof SimpleSubnet
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleTag
 */
export interface SimpleTag {
    /**
     * 
     * @type {string}
     * @memberof SimpleTag
     */
    description: string;
    /**
     * The directory this tag belongs to
     * @type {string}
     * @memberof SimpleTag
     */
    directory?: string | null;
    /**
     * A locked tag's access rules can't be edited
     * @type {boolean}
     * @memberof SimpleTag
     */
    locked: boolean;
    /**
     * The tag's name (**without** the "tag:" prefix)
     * @type {string}
     * @memberof SimpleTag
     */
    name: string;
    /**
     * Primary key
     * @type {string}
     * @memberof SimpleTag
     */
    uuid: string;
}
/**
 * A directory
 * @export
 * @interface SimpleTagDirectory
 */
export interface SimpleTagDirectory {
    /**
     * The directory's name
     * @type {string}
     * @memberof SimpleTagDirectory
     */
    name: string;
    /**
     * Primary key
     * @type {string}
     * @memberof SimpleTagDirectory
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleTenant
 */
export interface SimpleTenant {
    /**
     * Color which is intended to be used for badges in the frontend
     * @type {BadgeColor}
     * @memberof SimpleTenant
     */
    badge_color: BadgeColor;
    /**
     * Short name / abbreviation which is intended to be used for badges in the frontend
     * @type {string}
     * @memberof SimpleTenant
     */
    badge_name: string;
    /**
     * Longer description of the tenant
     * @type {string}
     * @memberof SimpleTenant
     */
    description: string;
    /**
     * Unique (full) name of the tenant
     * @type {any}
     * @memberof SimpleTenant
     */
    name: any;
    /**
     * The primary key of the tenant
     * @type {string}
     * @memberof SimpleTenant
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleUser
 */
export interface SimpleUser {
    /**
     * Authentication method used by the user
     * @type {UserSource}
     * @memberof SimpleUser
     */
    auth: UserSource;
    /**
     * When the user was created
     * @type {string}
     * @memberof SimpleUser
     */
    created_at: string;
    /**
     * A name for humans to identify the user by
     * @type {string}
     * @memberof SimpleUser
     */
    display_name: string;
    /**
     * The user's uuid
     * @type {string}
     * @memberof SimpleUser
     */
    uuid: string;
}
/**
 * A single uuid wrapped in a struct
 * @export
 * @interface SingleUuid
 */
export interface SingleUuid {
    /**
     * 
     * @type {string}
     * @memberof SingleUuid
     */
    uuid: string;
}
/**
 * `TKAInfo` encodes the control plane's view of tailnet key authority (TKA) state. This information is transmitted as part of the MapResponse.
 * @export
 * @interface TKAInfo
 */
export interface TKAInfo {
    /**
     * `disabled` indicates the control plane believes TKA should be disabled, and the node should reach out to fetch a disablement secret. If the disablement secret verifies, then the node should then disable TKA locally. This field exists to disambiguate a nil TKAInfo in a delta mapresponse from a nil TKAInfo indicating TKA should be disabled.
     * @type {boolean}
     * @memberof TKAInfo
     */
    Disabled?: boolean;
    /**
     * `head` describes the hash of the latest AUM applied to the authority. `head` is encoded as tka.AUMHash.MarshalText.
     * 
     * If the `head` state differs to that known locally, the node should perform synchronization via a separate RPC.
     * @type {string}
     * @memberof TKAInfo
     */
    Head?: string;
}
/**
 * Information about the tenant that will be deleted
 * @export
 * @interface TenantDeletePreviewResponse
 */
export interface TenantDeletePreviewResponse {
    /**
     * All preauthkeys that belong to this tenant
     * @type {number}
     * @memberof TenantDeletePreviewResponse
     */
    preauthkey_count: number;
    /**
     * All server devices that belong to this tenant
     * @type {number}
     * @memberof TenantDeletePreviewResponse
     */
    server_device_count: number;
    /**
     * All users that belong to this tenant
     * @type {number}
     * @memberof TenantDeletePreviewResponse
     */
    user_count: number;
    /**
     * All user devices that belong to this tenant
     * @type {number}
     * @memberof TenantDeletePreviewResponse
     */
    user_device_count: number;
}
/**
 * @type TestLdapSearchResponse
 * 
 * @export
 */
export type TestLdapSearchResponse = TestLdapSearchResponseOneOf | TestLdapSearchResponseOneOf1;
/**
 * Results of a search for groups and users.
 * 
 * This struct is the return type of [`search_groups_and_users`].
 * @export
 * @interface TestLdapSearchResponseOneOf
 */
export interface TestLdapSearchResponseOneOf {
    /**
     * Groups found by the search.
     * 
     * Map from dn to name and members.
     * @type {{ [key: string]: SearchResultsGroup | undefined; }}
     * @memberof TestLdapSearchResponseOneOf
     */
    groups: { [key: string]: SearchResultsGroup | undefined; };
    /**
     * Dns which were not utf-8
     * 
     * This can only happen for the values in a group's member attribute.
     * 
     * List of partially decoded dns (i.e. `String::from_utf8_lossy`)
     * @type {Array<string>}
     * @memberof TestLdapSearchResponseOneOf
     */
    invalid_dns: Array<string>;
    /**
     * Entries which had to be skipped because their names were not utf-8
     * 
     * Map from dn to partially decoded name (i.e. `String::from_utf8_lossy`)
     * @type {{ [key: string]: string | undefined; }}
     * @memberof TestLdapSearchResponseOneOf
     */
    invalid_names: { [key: string]: string | undefined; };
    /**
     * Users which had to be skipped because their remote_ids were not utf-8
     * 
     * Map from dn to partially decoded remote_id (i.e. `String::from_utf8_lossy`)
     * @type {{ [key: string]: string | undefined; }}
     * @memberof TestLdapSearchResponseOneOf
     */
    invalid_remote_ids: { [key: string]: string | undefined; };
    /**
     * Entries whose dn were longer than our db allows
     * @type {Array<string>}
     * @memberof TestLdapSearchResponseOneOf
     */
    long_dns: Array<string>;
    /**
     * Entries which had to be skipped because their names were longer than our db allows
     * 
     * Map from dn to name
     * @type {{ [key: string]: string | undefined; }}
     * @memberof TestLdapSearchResponseOneOf
     */
    long_names: { [key: string]: string | undefined; };
    /**
     * Users which had to be skipped because their remote_ids were longer than our db allows
     * 
     * Map from dn to remote_id
     * @type {{ [key: string]: string | undefined; }}
     * @memberof TestLdapSearchResponseOneOf
     */
    long_remote_ids: { [key: string]: string | undefined; };
    /**
     * Entries which had to be skipped because they didn't have the name attribute
     * 
     * List of dns
     * @type {Array<string>}
     * @memberof TestLdapSearchResponseOneOf
     */
    missing_names: Array<string>;
    /**
     * Users which had to be skipped because they didn't have the remote_id attribute
     * 
     * List of dns
     * @type {Array<string>}
     * @memberof TestLdapSearchResponseOneOf
     */
    missing_remote_ids: Array<string>;
    /**
     * Entries which had multiple names (they were not skipped and are part of `users` or `groups`)
     * 
     * List of dns
     * @type {Array<string>}
     * @memberof TestLdapSearchResponseOneOf
     */
    multiple_names: Array<string>;
    /**
     * Users which had multiple remote_ids (they were not skipped and are part of `users`)
     * 
     * List of dns
     * @type {Array<string>}
     * @memberof TestLdapSearchResponseOneOf
     */
    multiple_remote_ids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TestLdapSearchResponseOneOf
     */
    type: TestLdapSearchResponseOneOfTypeEnum;
    /**
     * Users found by the search.
     * 
     * Map from dn to name.
     * @type {{ [key: string]: SearchResultsUser | undefined; }}
     * @memberof TestLdapSearchResponseOneOf
     */
    users: { [key: string]: SearchResultsUser | undefined; };
}


/**
 * @export
 */
export const TestLdapSearchResponseOneOfTypeEnum = {
    Success: 'Success'
} as const;
export type TestLdapSearchResponseOneOfTypeEnum = typeof TestLdapSearchResponseOneOfTypeEnum[keyof typeof TestLdapSearchResponseOneOfTypeEnum];

/**
 * 
 * @export
 * @interface TestLdapSearchResponseOneOf1
 */
export interface TestLdapSearchResponseOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof TestLdapSearchResponseOneOf1
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof TestLdapSearchResponseOneOf1
     */
    type: TestLdapSearchResponseOneOf1TypeEnum;
}


/**
 * @export
 */
export const TestLdapSearchResponseOneOf1TypeEnum = {
    Error: 'Error'
} as const;
export type TestLdapSearchResponseOneOf1TypeEnum = typeof TestLdapSearchResponseOneOf1TypeEnum[keyof typeof TestLdapSearchResponseOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface TestLdapSettingsErrors
 */
export interface TestLdapSettingsErrors {
    /**
     * 
     * @type {string}
     * @memberof TestLdapSettingsErrors
     */
    group_filter_invalid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TestLdapSettingsErrors
     */
    user_filter_invalid?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateAccessRuleRequest
 */
export interface UpdateAccessRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAccessRuleRequest
     */
    description?: string | null;
    /**
     * 
     * @type {CreateAccessRuleDst}
     * @memberof UpdateAccessRuleRequest
     */
    dst?: CreateAccessRuleDst | null;
    /**
     * 
     * @type {CreateAccessRulePort}
     * @memberof UpdateAccessRuleRequest
     */
    port?: CreateAccessRulePort | null;
    /**
     * 
     * @type {AccessRuleProtocol}
     * @memberof UpdateAccessRuleRequest
     */
    protocol?: AccessRuleProtocol | null;
    /**
     * 
     * @type {CreateAccessRuleSrc}
     * @memberof UpdateAccessRuleRequest
     */
    src?: CreateAccessRuleSrc | null;
}
/**
 * 
 * @export
 * @interface UpdateExtraDnsDomainError
 */
export interface UpdateExtraDnsDomainError {
    /**
     * If an existing device has the same name
     * @type {boolean}
     * @memberof UpdateExtraDnsDomainError
     */
    device_already_exists: boolean;
    /**
     * If an existing domain has the same name
     * @type {boolean}
     * @memberof UpdateExtraDnsDomainError
     */
    domain_already_exists: boolean;
    /**
     * Invalid domain
     * @type {boolean}
     * @memberof UpdateExtraDnsDomainError
     */
    domain_invalid: boolean;
}
/**
 * 
 * @export
 * @interface UpdateExtraDnsDomainRequest
 */
export interface UpdateExtraDnsDomainRequest {
    /**
     * Description
     * @type {string}
     * @memberof UpdateExtraDnsDomainRequest
     */
    description: string;
    /**
     * The fully qualified domain name
     * @type {string}
     * @memberof UpdateExtraDnsDomainRequest
     */
    from_dns: string;
}
/**
 * 
 * @export
 * @interface UpdateExtraDnsRecordError
 */
export interface UpdateExtraDnsRecordError {
    /**
     * The ip of the record is not a valid ip
     * @type {boolean}
     * @memberof UpdateExtraDnsRecordError
     */
    ip_invalid: boolean;
    /**
     * If the IP is in the internal range but no device exists
     * @type {boolean}
     * @memberof UpdateExtraDnsRecordError
     */
    no_internal_device: boolean;
}
/**
 * 
 * @export
 * @interface UpdateExtraDnsRecordRequest
 */
export interface UpdateExtraDnsRecordRequest {
    /**
     * The record type, A or AAAA accepted
     * @type {ExtraDnsRecordType}
     * @memberof UpdateExtraDnsRecordRequest
     */
    record_type: ExtraDnsRecordType;
    /**
     * The IP of the Record
     * @type {string}
     * @memberof UpdateExtraDnsRecordRequest
     */
    to_ip: string;
}
/**
 * Update Errors for the Global DNS
 * @export
 * @interface UpdateGlobalDnsErrors
 */
export interface UpdateGlobalDnsErrors {
    /**
     * If the ipv4 provider is not valid
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    ipv4_provider1: boolean;
    /**
     * If the ipv4 provider is not valid
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    ipv4_provider2: boolean;
    /**
     * If the ipv4 provider is not valid
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    ipv4_provider3: boolean;
    /**
     * If the ipv6 provider is not valid
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    ipv6_provider1: boolean;
    /**
     * If the ipv6 provider is not valid
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    ipv6_provider2: boolean;
    /**
     * If the ipv6 provider is not valid
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    ipv6_provider3: boolean;
    /**
     * If no IP address is provided
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    missing_ip_address: boolean;
}
/**
 * 
 * @export
 * @interface UpdateGroupRequest
 */
export interface UpdateGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupRequest
     */
    description?: string | null;
    /**
     * Allows this group to have access to `autogroup:internet`
     * @type {boolean}
     * @memberof UpdateGroupRequest
     */
    internet?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateOidcProviderErrors
 */
export interface UpdateOidcProviderErrors {
    /**
     * If true, the provider name was already occupied
     * @type {boolean}
     * @memberof UpdateOidcProviderErrors
     */
    name_already_exist: boolean;
}
/**
 * 
 * @export
 * @interface UpdateOidcProviderRequest
 */
export interface UpdateOidcProviderRequest {
    /**
     * OAuth client id
     * @type {string}
     * @memberof UpdateOidcProviderRequest
     */
    client_id?: string | null;
    /**
     * OAuth client secret
     * @type {string}
     * @memberof UpdateOidcProviderRequest
     */
    client_secret?: string | null;
    /**
     * Is the provider currently enabled?
     * @type {boolean}
     * @memberof UpdateOidcProviderRequest
     */
    enabled?: boolean | null;
    /**
     * Display text for the login button shown on the English login page
     * @type {string}
     * @memberof UpdateOidcProviderRequest
     */
    login_button_display_english?: string | null;
    /**
     * Display text for the login button shown on the German login page
     * @type {string}
     * @memberof UpdateOidcProviderRequest
     */
    login_button_display_german?: string | null;
    /**
     * Display name for this provider
     * @type {string}
     * @memberof UpdateOidcProviderRequest
     */
    name?: string | null;
    /**
     * Is this the primary provider?
     * @type {boolean}
     * @memberof UpdateOidcProviderRequest
     */
    primary?: boolean | null;
    /**
     * Issuer Url (the url without the `.well-known/openid-configuration` part)
     * @type {string}
     * @memberof UpdateOidcProviderRequest
     */
    url?: string | null;
    /**
     * Use a x509 certificate and a JWT instead of `client_secret`
     * @type {boolean}
     * @memberof UpdateOidcProviderRequest
     */
    use_cert?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateRuleInRulesetRequest
 */
export interface UpdateRuleInRulesetRequest {
    /**
     * A description
     * @type {string}
     * @memberof UpdateRuleInRulesetRequest
     */
    description?: string | null;
    /**
     * 
     * @type {CreateAccessRulePort}
     * @memberof UpdateRuleInRulesetRequest
     */
    port?: CreateAccessRulePort | null;
    /**
     * The transport protocol allowed by the rule.
     * @type {AccessRuleProtocol}
     * @memberof UpdateRuleInRulesetRequest
     */
    protocol?: AccessRuleProtocol | null;
}
/**
 * 
 * @export
 * @interface UpdateRulesetRequest
 */
export interface UpdateRulesetRequest {
    /**
     * A description
     * @type {string}
     * @memberof UpdateRulesetRequest
     */
    description?: string | null;
    /**
     * A name
     * @type {string}
     * @memberof UpdateRulesetRequest
     */
    name?: string | null;
}
/**
 * Error response for updating a Split Dns Domain
 * @export
 * @interface UpdateSplitDnsDomainError
 */
export interface UpdateSplitDnsDomainError {
    /**
     * The domain name is already used by another split dns domain
     * @type {boolean}
     * @memberof UpdateSplitDnsDomainError
     */
    domain_already_exists: boolean;
    /**
     * The name of the domain which is not a valid domain
     * @type {boolean}
     * @memberof UpdateSplitDnsDomainError
     */
    domain_invalid: boolean;
}
/**
 * Request for updating a Split Dns Domain
 * @export
 * @interface UpdateSplitDnsDomainRequest
 */
export interface UpdateSplitDnsDomainRequest {
    /**
     * Marks whether this Split Dns configuration is actively used or not
     * @type {boolean}
     * @memberof UpdateSplitDnsDomainRequest
     */
    disabled: boolean;
    /**
     * The domain name
     * @type {string}
     * @memberof UpdateSplitDnsDomainRequest
     */
    domain: string;
}
/**
 * Errors for creating a new split dns resolver
 * @export
 * @interface UpdateSplitDnsResolverErrors
 */
export interface UpdateSplitDnsResolverErrors {
    /**
     * Ip address is already in use in this domain
     * @type {boolean}
     * @memberof UpdateSplitDnsResolverErrors
     */
    ip_already_exists: boolean;
    /**
     * Ip address is not a valid ip address
     * @type {boolean}
     * @memberof UpdateSplitDnsResolverErrors
     */
    ip_invalid: boolean;
}
/**
 * Request for creating a new split dns resolver
 * @export
 * @interface UpdateSplitDnsResolverRequest
 */
export interface UpdateSplitDnsResolverRequest {
    /**
     * Better description to identify the resolver
     * @type {string}
     * @memberof UpdateSplitDnsResolverRequest
     */
    description: string;
    /**
     * Marks whether this resolver is actively used or not
     * @type {boolean}
     * @memberof UpdateSplitDnsResolverRequest
     */
    disabled: boolean;
    /**
     * The IP of the resolver
     * @type {string}
     * @memberof UpdateSplitDnsResolverRequest
     */
    ip: string;
}
/**
 * A directory update errors
 * @export
 * @interface UpdateTagDirectoryErrors
 */
export interface UpdateTagDirectoryErrors {
    /**
     * The directory's name already exists
     * @type {boolean}
     * @memberof UpdateTagDirectoryErrors
     */
    name_not_unique: boolean;
}
/**
 * A directory update request
 * @export
 * @interface UpdateTagDirectoryRequest
 */
export interface UpdateTagDirectoryRequest {
    /**
     * The directory's new name
     * @type {string}
     * @memberof UpdateTagDirectoryRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface UpdateTenantErrors
 */
export interface UpdateTenantErrors {
    /**
     * If the name is already used
     * @type {boolean}
     * @memberof UpdateTenantErrors
     */
    name_already_used: boolean;
}
/**
 * 
 * @export
 * @interface UpdateTenantRequest
 */
export interface UpdateTenantRequest {
    /**
     * Color which is intended to be used for badges in the frontend
     * @type {BadgeColor}
     * @memberof UpdateTenantRequest
     */
    badge_color: BadgeColor;
    /**
     * Short name / abbreviation which is intended to be used for badges in the frontend
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    badge_name: string;
    /**
     * Longer description of the tenant
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    description: string;
    /**
     * Unique (full) name of the tenant
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    name: string;
}
/**
 * A `UserProfile` is display-friendly data for a [`User`]. It includes the `login_name` for display purposes but *not* the `provider`. It also includes derived data from one of the user's logins.
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    DisplayName?: string;
    /**
     * 
     * @type {number}
     * @memberof UserProfile
     */
    ID?: number;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    LoginName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    ProfilePicUrl?: string;
    /**
     * `roles` exists for legacy reasons, to keep old macOS clients happy. It JSON marshals as [].
     * @type {Array<any>}
     * @memberof UserProfile
     */
    Roles?: Array<any>;
}
/**
 * @type UserSource
 * Source a user comes from
 * @export
 */
export type UserSource = string;
/**
 * Websocket messages sent from the client to the server
 * @export
 * @interface WsClientMsg
 */
export interface WsClientMsg {
}
/**
 * @type WsServerMsg
 * Websocket messages sent from the server to the client
 * @export
 */
export type WsServerMsg = WsServerMsgOneOf | WsServerMsgOneOf1 | WsServerMsgOneOf10 | WsServerMsgOneOf11 | WsServerMsgOneOf12 | WsServerMsgOneOf2 | WsServerMsgOneOf3 | WsServerMsgOneOf4 | WsServerMsgOneOf5 | WsServerMsgOneOf6 | WsServerMsgOneOf7 | WsServerMsgOneOf8 | WsServerMsgOneOf9;
/**
 * The client send an invalid message
 * @export
 * @interface WsServerMsgOneOf
 */
export interface WsServerMsgOneOf {
    /**
     * The invalid message
     * @type {string}
     * @memberof WsServerMsgOneOf
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf
     */
    type: WsServerMsgOneOfTypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOfTypeEnum = {
    InvalidMsg: 'InvalidMsg'
} as const;
export type WsServerMsgOneOfTypeEnum = typeof WsServerMsgOneOfTypeEnum[keyof typeof WsServerMsgOneOfTypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf1
 */
export interface WsServerMsgOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf1
     */
    type: WsServerMsgOneOf1TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf1TypeEnum = {
    TagsChanged: 'TagsChanged'
} as const;
export type WsServerMsgOneOf1TypeEnum = typeof WsServerMsgOneOf1TypeEnum[keyof typeof WsServerMsgOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf10
 */
export interface WsServerMsgOneOf10 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf10
     */
    type: WsServerMsgOneOf10TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf10TypeEnum = {
    OidcClientChanged: 'OidcClientChanged'
} as const;
export type WsServerMsgOneOf10TypeEnum = typeof WsServerMsgOneOf10TypeEnum[keyof typeof WsServerMsgOneOf10TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf11
 */
export interface WsServerMsgOneOf11 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf11
     */
    type: WsServerMsgOneOf11TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf11TypeEnum = {
    ImportCacheChanged: 'ImportCacheChanged'
} as const;
export type WsServerMsgOneOf11TypeEnum = typeof WsServerMsgOneOf11TypeEnum[keyof typeof WsServerMsgOneOf11TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf12
 */
export interface WsServerMsgOneOf12 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf12
     */
    type: WsServerMsgOneOf12TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf12TypeEnum = {
    TenantChanged: 'TenantChanged'
} as const;
export type WsServerMsgOneOf12TypeEnum = typeof WsServerMsgOneOf12TypeEnum[keyof typeof WsServerMsgOneOf12TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf2
 */
export interface WsServerMsgOneOf2 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf2
     */
    type: WsServerMsgOneOf2TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf2TypeEnum = {
    DeviceGroupsChanged: 'DeviceGroupsChanged'
} as const;
export type WsServerMsgOneOf2TypeEnum = typeof WsServerMsgOneOf2TypeEnum[keyof typeof WsServerMsgOneOf2TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf3
 */
export interface WsServerMsgOneOf3 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf3
     */
    type: WsServerMsgOneOf3TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf3TypeEnum = {
    GroupsChanged: 'GroupsChanged'
} as const;
export type WsServerMsgOneOf3TypeEnum = typeof WsServerMsgOneOf3TypeEnum[keyof typeof WsServerMsgOneOf3TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf4
 */
export interface WsServerMsgOneOf4 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf4
     */
    type: WsServerMsgOneOf4TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf4TypeEnum = {
    SubnetsChanged: 'SubnetsChanged'
} as const;
export type WsServerMsgOneOf4TypeEnum = typeof WsServerMsgOneOf4TypeEnum[keyof typeof WsServerMsgOneOf4TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf5
 */
export interface WsServerMsgOneOf5 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf5
     */
    type: WsServerMsgOneOf5TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf5TypeEnum = {
    ExitNodesChanged: 'ExitNodesChanged'
} as const;
export type WsServerMsgOneOf5TypeEnum = typeof WsServerMsgOneOf5TypeEnum[keyof typeof WsServerMsgOneOf5TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf6
 */
export interface WsServerMsgOneOf6 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf6
     */
    type: WsServerMsgOneOf6TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf6TypeEnum = {
    DevicesChanged: 'DevicesChanged'
} as const;
export type WsServerMsgOneOf6TypeEnum = typeof WsServerMsgOneOf6TypeEnum[keyof typeof WsServerMsgOneOf6TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf7
 */
export interface WsServerMsgOneOf7 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf7
     */
    type: WsServerMsgOneOf7TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf7TypeEnum = {
    KeysChanged: 'KeysChanged'
} as const;
export type WsServerMsgOneOf7TypeEnum = typeof WsServerMsgOneOf7TypeEnum[keyof typeof WsServerMsgOneOf7TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf8
 */
export interface WsServerMsgOneOf8 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf8
     */
    type: WsServerMsgOneOf8TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf8TypeEnum = {
    UsersChanged: 'UsersChanged'
} as const;
export type WsServerMsgOneOf8TypeEnum = typeof WsServerMsgOneOf8TypeEnum[keyof typeof WsServerMsgOneOf8TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf9
 */
export interface WsServerMsgOneOf9 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf9
     */
    group_uuid: string;
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf9
     */
    type: WsServerMsgOneOf9TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf9TypeEnum = {
    MembersChanged: 'MembersChanged'
} as const;
export type WsServerMsgOneOf9TypeEnum = typeof WsServerMsgOneOf9TypeEnum[keyof typeof WsServerMsgOneOf9TypeEnum];

